/* =================================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ================================================================================= */

(function($) { 

    const currentMetadataUserVersion = 2;

    var mgUtils = {

        ga: function(category, action, label){

            if(typeof ga === 'function') {

                category = category ? category : '';
                action = action ? action : '';
                label = label ? label : '';

                ga('send', 'event', category, action, label);

            } else {
                console.error('ga is not a function');
            }

        },

        checkComparador: function() { 
            var comparador = [];
            var comparadorCounter = 0;
            comparador = localStorage.getItem("comparador");
            //1. Tots els botons de comparador, els posem active.
            $.each( JSON.parse(comparador), function( key , value ) {
                //console.log(".mgComparador[data-id='"+value+"']");
                $(".mgComparador[data-id='"+value+"']").addClass("active");
                comparadorCounter++;
            });
            //2. Posem numero de cotxes comparats i mostrem missatge
            if(comparadorCounter>0){
                $(".mgComparadorCounter").html(comparadorCounter);
                $(".mgComparadorMessage").addClass("active");
                $(".mgComparadorMessage").closest(".menu-item").removeClass("hide");
            }else{
                $(".mgComparadorMessage").removeClass("active");
                $(".mgComparadorMessage").closest(".menu-item").addClass("hide");
            }
        },
        pushLocalStorage: function(item,data) {
                        var a = [];
                        if (localStorage[item]) {
                            a = JSON.parse(localStorage.getItem(item));
                        }
                        a.push(data);
                        localStorage.setItem(item, JSON.stringify(a));
                        console.log(localStorage.getItem(item));
        },
        pullLocalStorage: function(item,data) {
                        var a = [];
                        if (localStorage[item]) {
                            a = JSON.parse(localStorage.getItem(item));
                        }
                        a.remove(data);
                        localStorage.setItem(item, JSON.stringify(a));
                        console.log(localStorage.getItem(item));
        },
        changeSpinner: function(){

            (function(doc,found) {
                  window.addEventListener('DOMSubtreeModified', function() {

                    var yourdiv = doc.querySelector(".gform_ajax_spinner");

                    if(found && !yourdiv){
                      // Was there but is gone, do something
                      found = false;
                      console.log("out");
                    }

                    if(yourdiv){
                      // Found it, do something
                      found = true;                      
                      if( $('#mediagach-loader').length > 0){

                      }else{
                        console.log("inn");
                        $( '<div id="mediagach-loader" class="spinner-mediagach"><div class="cubito"></div></div>' ).insertAfter( ".gform_ajax_spinner" );
                      }
                    }

                  }, false);
                })(document,false);           

        },
        bounceRate60: function(item,data) {
            setTimeout(
                ga('send', 'event', 'NoBounce', 'Tiempo en página de más de 60s', '')
            ,60000);
   
        },
 
        openPopup: function(item,data) {
            var trigger = $(this).attr("data-trigger");
            var title = $(this).attr("data-title");
            var reference = $(this).attr("data-ref");

            if(title){
                $($(this).attr("data-target")+" .modal-title").html(title);
            }    
            if(trigger){
                $(trigger).trigger("click");
            }
            if(reference){
                console.log("ref: "+reference);
                $($(this).attr("data-target")+" .form-reference input").val(reference);
            }
            $($(this).attr("data-target")).modal();
        }, 

        carousels: function(item,data) {
            //Carrussel mediagach
            var carousel = $(".carousel-mg"); 
            carousel.each(function() {
                items = $(this).attr("data-items") || "3";
                nav = ($(this).attr("data-nav") !== "false");
                autoplay = ($(this).attr("data-autoplay") !== "false");
                autoplayTimeout = $(this).attr("data-autoplayTimeout") || "5000";
                $(this).owlCarousel({
                    nav:nav,
                    loop:true,
                    margin:10,
                    autoplay: autoplay,
                    items: items,
                    autoplayTimeout: autoplayTimeout
                });

            });
        },

        randomTransitionDelay: function(element,delay,ordered) {
            //element: tipus d'element que volem aplicar-li delay
            //delay: temps que trigarà en acabar totes les animacions
            //ordered: true/false: per ordenar les animacions

            var n = element.length;
            var numDelays = delay/n;

            if(ordered){
                element.each(function( index ) {
                    var i=index+1;
                    $( this ).css("transitionDelay",numDelays*i+"s");
                });
            }else{
                element.each(function( index ) {
                    $( this ).css("transitionDelay",delay*Math.random()+"s");
                });
            }

        },
        getUrlParameter: function(nomParametre){
            var sPageURL = window.location.search.substring(1),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;

                for (i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] === nomParametre) {
                        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                    }
                }
        },
        initMetadataStructure : function() {

            aux = {
                    utils: {   
                        ver: currentMetadataUserVersion,  
                        adw: {
                            id:  0,
                            id2: 0,
                            price: 0
                        },
                        se: [],
                        source: document.referrer,
                        idOferta: 0,
                        utm_source: utmSource,
                        utm_medium: utmMedium,
                        utm_campaign: utmCampaign
                    }
                };

            return aux;
        },     
        initMetaDataStorage: function(item,data) {
            
            var utm_source = this.getUrlParameter('utm_source');
            if(utm_source === undefined){
                utmSource = '';
            }else{
                utmSource = utm_source;
            }

            var utm_medium = this.getUrlParameter('utm_medium');
            if(utm_medium === undefined){
                utmMedium = '';
            }else{
                utmMedium = utm_medium;
            }

            var utm_campaign = this.getUrlParameter('utm_campaign');
            if(utm_campaign === undefined){
                utmCampaign = '';
            }else{
                utmCampaign = utm_campaign;
            }

            if(typeof(Storage) !== "undefined") {
                if (localStorage.getItem("metadataUser") === null) {                    
                    metadataUsuari = this.initMetadataStructure(utmSource,utmMedium,utmCampaign); 
                }else{
                    metadataUsuari = JSON.parse(localStorage.getItem("metadataUser"));    
                    if(!metadataUsuari.hasOwnProperty('utils')){
                        localStorage.clear();
                        metadataUsuari = this.initMetadataStructure(utmSource,utmMedium,utmCampaign);
                    }else{
                        if(!metadataUsuari.utils.hasOwnProperty('ver')){
                            //no te la variable ver per tant netegem tota la variable de local                            
                            localStorage.clear();
                            metadataUsuari = this.initMetadataStructure(utmSource,utmMedium,utmCampaign);
                        }else{
                            if(currentMetadataUserVersion === metadataUsuari.utils.ver){
                                //tenim la mateixa versió de metadata no cal borrar      
                                if(utmSource != ''){
                                    metadataUsuari['utils']['utm_source'] = utmSource;
                                }                    
                                if(utmMedium != ''){
                                    metadataUsuari['utils']['utm_medium'] = utmMedium;
                                }
                                if(utmCampaign != ''){
                                    metadataUsuari['utils']['utm_campaign'] = utmCampaign;
                                }    

                            }else{
                                //les versions de metadata no coincideixen, hem de netejar                                
                                localStorage.clear();
                                metadataUsuari = this.initMetadataStructure(utmSource,utmMedium,utmCampaign);
                            }
                        }
                    }
                                          
                }

                localStorage.setItem("metadataUser", JSON.stringify(metadataUsuari));
                //$('.hidden_referrer input').attr('value', metadataUsuari.utils.source);

            }
            /*
            if(typeof(Storage) !== "undefined") {
                if (typeof localStorage['metadataUser'] === 'undefined') {
                    
                    
                    aux = {
                        utils: {                             
                        },
                        leadInfo: {
                            source: document.referrer,
                            idOferta: 0,
                            sessions: [                                        
                                    ]
                        }
                    };

                    localStorage.setItem("metadataUser", JSON.stringify(aux));
                    $('.hidden_referrer input').attr('value', document.referrer);                    
                    
                   
                }else{  
                    
                    leadInfo = JSON.parse(localStorage.getItem("metadataUser"));
                    $('.hidden_referrer input').attr('value', leadInfo.source);
                       
                }
            } 
            */

        },
        trackMetaDataStorage: function(level0, level1, level2, level3, data, operation ) {

            /*                
                exemple posar valor normal
                mgUtils.trackMetaDataStorage('leadInfo', 'idOferta', '', '', 2432 );                
                mgUtils.trackMetaDataStorage('leadInfo', 'fb', 'estona', '', 36 );                
                mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '1', 'estona', 23 );
                
                exemple posar estructura a un array -> s'ha d'especificar la paraula 'push'
                mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', '', { dataAcces: 0, estona: 0 }, 'push');

                exemple per modificar algun element de l'últim objecte d'un array -> es deixa la posició de l'array a ''
                mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', 'estona', 5555); 

            */
            
            metadataUsuari = JSON.parse(localStorage.getItem("metadataUser"));
                    
            if( level2 != '' ){
                if( level3 != '' ){
                    if(operation == 'push'){
                        if(metadataUsuari[level0][level1][level2][level3] == null){
                            var newElement = [];
                            newElement.push(data);
                            metadataUsuari[level0][level1][level2][level3] = newElement;
                        }else{
                            metadataUsuari[level0][level1][level2][level3].push(data);
                        }
                    }else{
                        metadataUsuari[level0][level1][level2][level3] = data;
                    }      
                }else{
                    if(operation == 'push'){
                        if(metadataUsuari[level0][level1][level2] == null){
                            var newElement = [];
                            newElement.push(data);
                            metadataUsuari[level0][level1][level2] = newElement;
                        }else{
                            metadataUsuari[level0][level1][level2].push(data);
                        }
                        
                    }else{
                        metadataUsuari[level0][level1][level2] = data;
                    }                    
                }

            }else{
                if( level3 != '' ){
                    metadataUsuari[level0][level1][metadataUsuari[level0][level1].length-1][level3] = data;
                }else{
                    if(operation == 'push'){
                        if(metadataUsuari[level0][level1] == null){
                            var newElement = [];
                            newElement.push(data);
                            metadataUsuari[level0][level1] = newElement;                            
                        }else{
                            metadataUsuari[level0][level1].push(data);
                        }
                        
                    }else{
                        metadataUsuari[level0][level1] = data;
                    }
                }
            }

            localStorage.setItem("metadataUser", JSON.stringify(metadataUsuari));

        },
        saveTrackStorageToLead: function(item) {

            if(typeof(Storage) !== "undefined") {
                if (typeof localStorage['metadataUser'] === null) {
                                                                          
                }else{                      
                    //leadInfo = JSON.stringify(localStorage.getItem("metadataUser"));
                    metadataUsuari = localStorage.getItem("metadataUser");
                    $(item).html(metadataUsuari);                         
                }
            } 


        },        
        metadataUser: function() {
            /// METADATA 
// User Sessions 
var hoy = new Date();
hoy = hoy.getDate() + '-' + (hoy.getMonth() + 1) + '-' + hoy.getFullYear();

var sessions = {};

var session = {
    date: hoy,
    du: 0,
    lo: 0
}


if(typeof(Storage) !== "undefined") {
    if (localStorage.getItem("metadataUser") === null) {


    }else{
        metadataUsuari = JSON.parse(localStorage.getItem("metadataUser"));

        if(metadataUsuari.utils.se.length == 0){
            mgUtils.trackMetaDataStorage('utils', 'se', '', '', session , 'push');
            mgUtils.trackMetaDataStorage('utils', 'se', '', 'lo', ++session.lo);

        }else{

            var last = metadataUsuari.utils.se[metadataUsuari.utils.se.length - 1];

            if(last.date != hoy) {
                //els dies són diferents creem nova posicio a l'array de sessions
                mgUtils.trackMetaDataStorage('utils', 'se', '', '', session , 'push');
                mgUtils.trackMetaDataStorage('utils', 'se', '', 'lo', ++session.lo);
            }else{
                //seguim en el mateix dia afegim un load més a l'última sessió
                mgUtils.trackMetaDataStorage('utils', 'se', '', 'lo', ++last.lo);
            } 

        }

        var sessionTime = Date.now();

        document.body.addEventListener('click', function() {
            var resta = Date.now() - sessionTime;
            session.du += resta <= 900000 ? resta : 0;  // 900.000 = 15min
            mgUtils.trackMetaDataStorage('utils', 'se', '', 'du', session.du); 
            sessionTime = Date.now();
        });

        if(!metadataUsuari.utils.hasOwnProperty('ci')){
            //si no té la variable ci llavors anem a omplir
            //console.log('entro a localitzar-me');
            $.ajax({
                url: 'https://ip-get-geolocation.com/api/json?key=96b7a5a329382c3c5194820c627393a6', 
                success: function(result) {
                    mgUtils.trackMetaDataStorage('utils', 'ci', '', '', encodeWord(result.city)); 
                    mgUtils.trackMetaDataStorage('utils', 're', '', '', encodeWord(result.regionName)); 
                    mgUtils.trackMetaDataStorage('utils', 'co', '', '', encodeWord(result.country)); 

                    setTimeout(function(){
                        mgUtils.ga('ISO C|R|C', result.country+'|'+result.regionName+'|'+result.city); 
                        console.log('crc');                       
                    },40000);
                },
                error: function(result) {
                    
                }
            });
        }else{
            //console.log('ja estic localitzat');            
        }

    }
}

function encodeWord(str){
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode('0x' + p1);
    }));
}


/*if(JSON.parse(localStorage.getItem('metadataUser')).leadInfo != undefined) {
    sessions = JSON.parse(localStorage.getItem('metadataUser')).leadInfo.sessions;
    var last = sessions[sessions.length - 1];

    if(last == undefined || last.date != hoy) {
        mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', '', session , 'push');
    } else {
        session = last;
    }

    mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', 'loads', ++session.loads);

    //Time
    var sessionTime = Date.now();

    document.body.addEventListener('click', function() {
        var resta = Date.now() - sessionTime;
        session.estona += resta <= 900000 ? resta : 0;  // 900.000 = 15min
        mgUtils.trackMetaDataStorage('leadInfo', 'sessions', '', 'estona', session.estona); 
        sessionTime = Date.now();
    })
    // Country, Region, City
    var leadInfo = JSON.parse(localStorage.getItem('metadataUser')).leadInfo;

    if(leadInfo['city'] == undefined || leadInfo['country'] == undefined || leadInfo['region'] == undefined) {
        $.ajax({
            url: 'https://ip-to-geolocation.com/api/json?key=96b7a5a329382c3c5194820c627393a6', 
            success: function(result) {
                mgUtils.trackMetaDataStorage('leadInfo', 'city', '', '', result.city); 
                mgUtils.trackMetaDataStorage('leadInfo', 'region', '', '', result.regionName); 
                mgUtils.trackMetaDataStorage('leadInfo', 'country', '', '', result.country); 
            }
        });
    }
} else {
    localStorage.removeItem('metadataUser');
}*/
//////////////
        },
        googleAdwordsCodes: function(item,data) {
                       
            if($(".adw-content").length != 0){
                metaDataUsuari = JSON.parse(localStorage.getItem("metadataUser"));                 
                aux=metadataUsuari['utils']['adw'];                 
                if(aux == null) {
                    
                    adw = { 
                            id:  $(".adw-content").attr("data-adw-item"),
                            id2: $(".adw-content").attr("data-adw-item2"),
                            price: $(".adw-content").attr("data-adw-totalvalue")
                        };
                    metaDataUsuari.utils['adw'] = adw;                    
                    localStorage.setItem("metadataUser", JSON.stringify(metaDataUsuari));
                }else{
                    

                    if(metaDataUsuari['utils']['adw']['id'] == null){
                        metaDataUsuari.utils['adw']['id'] = $(".adw-content").attr("data-adw-item");
                        localStorage.setItem("metadataUser", JSON.stringify(metaDataUsuari));
                    }else{
                        mgUtils.trackMetaDataStorage('utils', 'adw', 'id', '',  $(".adw-content").attr("data-adw-item"));
                    }

                    if(metaDataUsuari['utils']['adw']['id2'] == null){
                        metaDataUsuari.utils['adw']['id2'] = $(".adw-content").attr("data-adw-item2");
                        localStorage.setItem("metadataUser", JSON.stringify(metaDataUsuari));
                    }else{
                        mgUtils.trackMetaDataStorage('utils', 'adw', 'id2', '',  $(".adw-content").attr("data-adw-item2")); 
                    }

                    if(metaDataUsuari['utils']['adw']['price'] == null){
                        metaDataUsuari.utils['adw']['price'] = $(".adw-content").attr("data-adw-totalvalue");
                        localStorage.setItem("metadataUser", JSON.stringify(metaDataUsuari));
                    }else{
                       mgUtils.trackMetaDataStorage('utils', 'adw', 'price', '',  $(".adw-content").attr("data-adw-totalvalue"));
                    }
                                       
                    
                }                   
            }

        },
        formSubmitSetMetadataUser: function(e) {

            e.preventDefault();            
            mgUtils.googleAdwordsCodes();
           
            //obtenim el id de formulari
            idButton = $(this).attr("id");
            aux = idButton.split("_");
            idForm = "#"+aux[0]+"_"+aux[(aux.length-1)];

            mgUtils.saveTrackStorageToLead(idForm+' .hidden_data_usr textarea');            
            $(idForm).submit();

        },
        unaAltraGenericafUNC: function(item,data) {
            console.log(localStorage.getItem(item));
            //.......
        },
    };


    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
                mgUtils.initMetaDataStorage();
            },
            finalize: function() {
                
                // JavaScript to be fired on all pages, after page specific JS is fired

                // Form Design Module
                function formDesign() {

    var inputs = document.querySelectorAll('.gform_wrapper input[type="text"]');
    var textareas = document.querySelectorAll('.gform_wrapper textarea');
    var selects = document.querySelectorAll('.gform_wrapper .ginput_container_select');

    buildFields(inputs, 'inp');
    buildFields(textareas, 'txta');


    selects = Array.prototype.slice.call(selects,0); 
    selects.forEach(function(el) {
        el.previousSibling.classList.add('select-label');
    });

}

function buildFields(els, type) {
    els = Array.prototype.slice.call(els,0); 
    els.forEach(function (el) {
        var label = el.parentNode.previousSibling;
    
        if(label && label.nodeName == 'LABEL') {
    
            el.classList.add('fd-' + type);
            label.classList.add('fd-labels-' + type);
    
            el.addEventListener('focus', function() {
    
                label.classList.replace('fd-labels-' + type, 'fd-labels-' + type + '-out');
                el.classList.replace('fd-' + type, 'fd-' + type + '-out');
    
            });
    
            el.addEventListener('focusout', function() {
    
                if(el.value.length == 0) {
                    label.classList.replace('fd-labels-' + type + '-out', 'fd-labels-' + type);
                    el.classList.replace('fd-' + type + '-out', 'fd-' + type);
                }
            
            });
    
        }
    });

} 

                // Polyfill
                // Polyfill for Array.findIndex
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
    // 1. Let O be ? ToObject(this value).
        if (this == null) {
        throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
            return k;
        }
        // e. Increase k by 1.
        k++;
        }

        // 7. Return -1.
        return -1;
    },
    configurable: true,
    writable: true
    });
}

//Math.trunc polyfill for ie
Math.trunc = Math.trunc || function(x) {
    if (isNaN(x)) {
        return NaN;
    }
    if (x > 0) {
        return Math.floor(x);
    }
    return Math.ceil(x);
};

//Includes polyfill for ie
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

function getNavigatorName() {
  if((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
    return 'opera';
  }
  if(typeof InstallTrigger !== 'undefined') {
    return 'firefox';
  }
  if(/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))) {
    return 'safari';
  }
  if(false || !!document.documentMode) {
    return 'ie';
  }
  if(!!window.StyleMedia) {
    return 'edge';
  }
  if(!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) {
    return 'chrome';
  }
  return 'otherNavigator';
}



// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null)
          this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

                formDesign(); 

                // Form Design Module - Te llamamos asyncForm 
                $('#asyncformdesign').on('click', function() {
                    formDesign();
                });

                // Form Design Module - Gravity Froms amb paginació 
                $(document).on('gform_page_loaded', function() {
                    formDesign();
                });

                // HEADER 3
                $('.container-nav-brands #menu-side-menu-autobeltran').addClass('owl-carousel');
                $('.container-nav-brands #menu-side-menu-autobeltran').owlCarousel({
                    items : 3,
                    slideSpeed : 2000,
                    nav: false,
                    autoplay: true,
                    dots: false,
                    loop: true,
                    lazyLoad: true,
                    responsiveRefreshRate : 200,
                    animateOut: 'fadeOut',
                    responsive: {
                        500: {
                            items:6
                        }
                    }
                })
                /////////////////
                

                rootFolder = webUrl;

                function onScrollInit( items, trigger ) {

                    items.each( function() {
                        var osElement = $(this);       
                        
                        if( typeof osElement.attr('data-mg-animation-delay') == 'undefined') {                            
                            var osAnimationDelay = '0s';                           
                        }else{
                            var osAnimationDelay = osElement.attr('data-mg-animation-delay');
                        }

                        osElement.css({
                          '-webkit-animation-delay':  osAnimationDelay,
                          '-moz-animation-delay':     osAnimationDelay,
                          'animation-delay':          osAnimationDelay
                        });

                        if( typeof osElement.attr('data-mg-animation') == 'undefined') {                            
                            var animationTypeElement = 'fadeIn';                           
                        }else{
                            var animationTypeElement = osElement.attr('data-mg-animation');
                        }

                        var osTrigger = ( trigger ) ? trigger : osElement;

                        osTrigger.waypoint(function() {
                            osElement.addClass('animated').addClass(animationTypeElement);
                        },{
                            triggerOnce: true,
                            offset: '90%'
                        });


                        $('img.lazy').on('load', function () {
                            Waypoint.refreshAll();
                        });



                    });

                }

                onScrollInit( $('.mg-animation') );

                

                if($('#scrollToTop').length>0){
                    window.onscroll = function() {
                      var scrollLimit = 600;
                      if (window.scrollY >= scrollLimit) {
                        $('#scrollToTop').css("display","flex");

                      }else{
                        $('#scrollToTop').hide();                          
                      }
                    };
                    $('#scrollToTop').on("click",function(){
                        //$(window).scrollTop(0);
                        $('html, body').animate({
                            scrollTop: 0
                        }, 500);
                    });
                                   

                }


                function checkCookies(){

                    var cookies = localStorage.getItem("cookies2");
                    if(cookies==null){
                        $("#cookie-bar").addClass("active");
                        /*TODO: Si hace scroll>200px. Si la cookie es superior a 3 meses.*/
                        
                        /*Despues de 15 segundos*/
                        //setTimeout(function(){ 
                            //setCookieTrue();
                        //}, 10000);
                        
                        /*Si acepta cookies*/
                        $(".close-cookie").on("click",function(){
                            setCookieTrue();
                        });

                    }
                }

                function setCookieTrue(){
                    $("#cookie-bar").removeClass("active");
                    //localStorage.cookies2=Date.now();
                    localStorage.setItem('cookies2', Date.now());
                    dataLayer.push({'event': 'AutoBeltran_Consent_Given'}); 

                } 

                Array.prototype.remove = function() {
                    var what, a = arguments, L = a.length, ax;
                    while (L && this.length) {
                        what = a[--L];
                        while ((ax = this.indexOf(what)) !== -1) {
                            this.splice(ax, 1);
                        }
                    }
                    return this;
                };


                function fillSelectModelo(auxSelect){

                    var uniqueNames = []; 
                    $.each(auxSelect, function(key, value) {

                        value2 = value.name.replace(" Nuevo","");
                        value2 = value2.replace(" Ocasión","");
                        if($.inArray(value2, uniqueNames) === -1){
                            uniqueNames.push(value2);
                            $("#selectModelo").append("<option>"+value2+"</option>");
                        } 
                    });
                }

                /*helper animate.css 
                $('#yourElement').animateCss('bounce');
                */
                $.fn.extend({
                    animateCss: function (animationName) {
                        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                        this.addClass('animated ' + animationName).one(animationEnd, function() {
                            $(this).removeClass('animated ' + animationName);
                        });
                    }
                });

                    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) { 
                        anchor.addEventListener('click', function (e) {
                            e.preventDefault();
                            console.log("aa");
                            document.querySelector(this.getAttribute('href')).scrollIntoView({
                                behavior: 'smooth'
                            });
                        });
                    });


                $(document).ready(function() {
                    document.body.classList.add(getNavigatorName()); // from polyfill.js
                    //////////////

                    $("#loop-block-star .info-content h4").sameheight();
                    $(".promo-block-title").sameheight();

                    var isCarruselOfertas = $('.carouselOffersInteresting');
                    if(isCarruselOfertas){
                        var owlCarouselInteresting = $(".carouselOffersInteresting").owlCarousel({
                            center:false,
                            dots: false,
                            loop: false,
                            margin:10,
                            autoplay: false,
                            items: 4,
                            autoplayTimeout: 5000,
                            autoplayHoverPause:true,
                            lazyLoad: true,
                            animateOut: 'fadeOut',
                            animateIn: 'fadeIn',
                            transitionStyle: "fade",
                            nav: false,
                            responsiveClass:true,
                            responsive:{
                                0:{
                                    items:2,
                                },
                                500:{
                                    items:3,
                                },
                                740:{
                                    items:4,
                                },
                                1200:{
                                    items:4,
                                }
                            }

                        });

                        $('.customInterestingNextBtn').click(function() {
                            owlCarouselInteresting.trigger('next.owl.carousel');
                        });
                        $('.customInterestingPrevBtn').click(function() {
                            owlCarouselInteresting.trigger('prev.owl.carousel');
                        });

                    }


                    var mgOpenVideo = $('.mgOpenVideo');
                    if(mgOpenVideo.length>0){

                        var $ag = $(
                                    '<div class="modal inputModal fade modal-videoplayer modal-offer-related" id="modalVideoGallery" data-easein="flipBounceXIn" role="dialog">'+
                                        '<div class="modal-dialog modal-lg">'+
                                          '<div class="modal-content">'+
                                            '<div class="modal-body">'+ 
                                                '<div class="container-fluid">'+
                                                    '<div class="row">'+
                                                        '<div class="">'+
                                                            '<button type="button" class="close" data-dismiss="modal">&#x2715;</button>'+
                                                        '</div>'+
                                                    '</div>'+
                                                    '<div class="row">'+
                                                        '<div class="">'+
                                                            '<div id="youtubeSpace">'+
                                                            '<iframe id="ytVideo" width="100%" height="450" src="" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'+
                                                              '</div>'+
                                                        '</div>'+
                                                   ' </div>'+
                                                '</div>'+
                                            '</div>'+ 
                                         '</div>'+
                                        '</div>'+
                                    '</div>'        
                        );

                        $("body").append($ag);


                        $(".mgOpenVideo").on("click",function(ev){


                            var ytVideo = $(this).attr("data-video");
                            ytVideo = ytVideo.split('/');
                            ytVideo = ytVideo[ytVideo.length-1];


                            $("#modalVideoGallery").modal();


                            $("#ytVideo")[0].src = "https://www.youtube.com/embed/"+ytVideo+"?rel=0&autoplay=1";


                            var player;
                            window.onYouTubeIframeAPIReady = function() {
                                new YT.Player(document.querySelector('#youtubeSpace iframe'), {
                                    events: {
                                        onReady: function(e) {
                                            player = e.target
                                        }
                                    }
                                })
                            }
                            player.playVideo();
                            




                        });

                        $("body").on('click','#modalVideoGallery .close,#modalVideoGallery', function(e) {
                            $("#ytVideo")[0].src = "";
                            console.log("close.video");
                        });



                    }



                    function manageMenu(){
                        $('#container-mobile-menu,button.navbar-toggle').toggleClass('is-active');
                        $("body").toggleClass("dontScroll");
                        $("#container-mobile-menu .categories").css("max-height",$(window).outerHeight()+"px");

                    }

                    $("#menu-menu-lateral .dropdown").on("click",function(){
                      var mg_helper = $(this).closest(".mg-side-menu-container").find(".mg-menu-helper");
                      if(!$(this).hasClass("open")){
                        mg_helper.empty();
                        $(this).find(".dropdown-menu").clone().appendTo( mg_helper );
                        mg_helper.addClass("open");
                      }else{
                        $(this).closest(".mg-side-menu-container").find(".mg-menu-helper").removeClass("open").empty();
                      }
                    });

                    $('.navbar-toggle,.l-menu .btn_close').on('click',manageMenu);



                    $( ".mg-menu-horizontal > ul > li" ).each(function( index ) {
                      if(!$(this).hasClass("hiddenMobile")){
                        $( this ).clone().appendTo( ".mainListMobile" );
                      }
                    });
                    $( ".mg-side-menu-container > div > ul > li" ).each(function( index ) {
                      if(!$(this).hasClass("hiddenMobile")){
                        $( this ).clone().appendTo( ".mainListMobile" );
                      }
                    });
                    /*FIX: Quan es clica a dropdown amb mobile, no funciona link*/
                    $('.dropdown-toggle').click(function(e) {
                      e.preventDefault();
                      setTimeout($.proxy(function() {
                        if ('ontouchstart' in document.documentElement) {

                          $(this).siblings('.dropdown-backdrop').off().remove();
                        }
                      }, this), 0);
                    });
                 


                    //COMPARADOR INIT
                    //Funció que cridarem cada vegada que carreguem ofertes i hi hagi botó de COMPARAR.


                    (function iOS_CaretBug() {

                        var ua = navigator.userAgent,
                        scrollTopPosition,
                        iOS = /iPad|iPhone|iPod/.test(ua),
                        iOS11 = /OS 11_0_1|OS 11_0_2|OS 11_0_3|OS 11_1|OS 11_1_1|OS 11_1_2|OS 11_2|OS 11_2_1/.test(ua);

                        // ios 11 bug caret position
                        if ( iOS && iOS11 ) {
                            $(document.body).on('show.bs.modal', function(e) {
                                if ( $(e.target).hasClass('inputModal') ) {
                                    // Get scroll position before moving top
                                    scrollTopPosition = $(document).scrollTop();
                                    // Add CSS to body "position: fixed"
                                    $("body").addClass("iosBugFixCaret");
                                }
                            });

                            $(document.body).on('hide.bs.modal', function(e) {
                                if ( $(e.target).hasClass('inputModal') ) {         
                                    // Remove CSS to body "position: fixed"
                                    $("body").removeClass("iosBugFixCaret");
                                    //Go back to initial position in document
                                    $(document).scrollTop(scrollTopPosition);
                                }
                            });
                        }
                    })();


                    $("body").on("click",".mgComparador",function(){
                        $(".effectIconComparador").remove();
                        var t = $(this);
                        var id = t.attr("data-id");
                        if(t.hasClass("active")){
                            t.removeClass("active");
                            mgUtils.pullLocalStorage("comparador",id);
                            mgUtils.checkComparador();
                        }else{
                            t.addClass("active");
                            mgUtils.pushLocalStorage("comparador",id);
                            mgUtils.checkComparador();

                            $("body").append('<i class="fa fa-star effectIconComparador" aria-hidden="true"></i>');
                            var pos1= t.find('.fa-star').offset();
                            var pos2 = $(".mgComparadorMessage .mgComparadorCounter").offset();
                            $(".effectIconComparador").css("left", pos1.left);
                            $(".effectIconComparador").css("top", pos1.top);                             
                            $(".effectIconComparador").velocity({
                                    left: pos2.left+"px",
                                    top: pos2.top+"px",
                                    opacity: 0
                            }, {
                                    duration: 400, 
                                    easing: "easeInOutBack",
                            });   

                        }
                    });
                    $("body").on("click",".mgComparadorLink",function(e){
                        e.preventDefault();
                        var t = $(this);
                        var items = localStorage.getItem("comparador");
                        items = JSON.parse(items).join("-");
                        window.open(t.attr('href')+"?vehiculos="+items,"_self");
                    });

                    //COMPARADOR END




                    //FORMULARIO CUSTOM HTML INIT
                      $(".selectCheckbox .option").on("click",function(){
                        $(this).toggleClass("active");
                        inputaux=$(this).parent().attr("data-input");
                        aux="";

                        $(".selectCheckbox .option.active").each(function() {
                          aux+=$( this ).attr("data-tipo")+",";
                        });
                        $("."+inputaux+" input").val(aux);
                      });


                    //FORMULARIO CUSTOM HTML END
                
                    /*comunes*/
                    $(".openModal").on("click",function() {
                        modalId=$(this).attr("data-modal");
                        $("#"+modalId).modal();
                    });
                    $(".callForm").one("click",function() {
                        telf=$(this).attr("data-telf");
                        telfCompact = telf.replace(/\s+/g, '');
                        $(this).after("<a href='tel:"+telfCompact+"'>"+telf+"</a>");
                    });





                    $(".contItem button").on("click",function() {
                        $("#formulario")
                            .velocity("scroll", { duration: 500, easing: "easeInOutCirc", offset: -140 });
                         $("#formulario").animateCss('flash');
                         $("#formulario .demo-icon").animateCss('tada');
                        //$("#modal-evento").modal();
                    });
                    $(".callForm").one("click", function(){  
                        ga('send', 'event', 'Campaña', 'Llamada', '');
                        $(".callFormInfo").addClass("showw");
                    });
                    $(".contItem button").on("click", function(){  
                        ga('send', 'event', 'Campaña', 'Abre popup', '');
                    });
                    $("#gform_submit_button_12").on("click", function(){  
                        ga('send', 'event', 'Campaña', 'Formulario lateral', '');
                    });
                    $("#gform_submit_button_13").on("click", function(){  
                        ga('send', 'event', 'Campaña', 'Formulario Popup', '');
                    });

                    $(".contItem").on("click", function(){  
                        $("#modal-evento2").modal();
                    });
                    




                    checkCookies();
                    mgUtils.checkComparador();
                    mgUtils.changeSpinner();
                    mgUtils.bounceRate60();
                    mgUtils.carousels();
                    mgUtils.randomTransitionDelay($(".modal .social-block"),0.6,false);                    
                    mgUtils.metadataUser();
 
                    
                    $("body").tooltip({ selector: '[data-toggle=tooltip]' });

                    $("body").on("click",".openPopup",mgUtils.openPopup);

                    $("body").on("click",'button[type="submit"], input[type="submit"]', mgUtils.formSubmitSetMetadataUser);


                    /// TOPBAR CTA 
                   
/// Key Messages v3.2

$.ajax({
    url: mediagach_vars.rootFolder + '/wp-content/themes/mediagach/templates/modules/get-key-messages.php', 
    success: function(result) {
        result = JSON.parse(result);
    
        setSessionStorage(result);
        if (window.location.search.indexOf('webview') === -1) {
            buildTopbar(result.topbar);
        }
        buildAlert(result.alert);
        buildToast(result.toast);
        buildProof(result.proof);
        buildInter(result.inter);
        buildPopup(result.popup);
    }
}); 

function setSessionStorage(result) { 
    //if(sessionStorage.getItem('closeCta') != null) return true; 
    if(localStorage.getItem('closeCta') != null) return true; 
    var setObj = {
        topbars: {},
        alerts: {},
        toasts: {},
        popups: {}
    };

    result.topbar.forEach(function(tb) {
        setObj['topbars'][tb.id] = true;
    })

    result.alert.forEach(function(al) {
        setObj['alerts'][al.id] = true;
    })

    result.toast.forEach(function(tt) {
        setObj['toasts'][tt.id] = true;
    })

    result.popup.forEach(function(pp) {
        setObj['popups'][pp.id] = true;
    })

    localStorage.setItem('closeCta', JSON.stringify(setObj));
    //sessionStorage.setItem('closeCta', JSON.stringify(setObj));
}

// Inter Offers
function buildInter(its){
    var metaData = JSON.parse(localStorage.getItem('metadataUser'));
    var parent = document.querySelector('.row-ofertas');

    var size = window.innerWidth;
    var colSizes = [
        size <= 767,
        size <= 991 && size > 767,
        size < 1200 && size > 991,
        size >= 1200
    ]; 

    var currentSize = colSizes.findIndex(function(x) { return x;});

    if(parent) {
        function insertInters() {

            //Determina la posicio on ha d'anar el banner segons el size de la pagina
            function setPosition(offer, fila) {
                
                var colData = offer.getAttribute('class').split(' ');
                var tamanys = [];
    
                colData.forEach(function(c, i) {
    
                    var arr1 = colData[i].split('-');
    
                    if(arr1[0] == 'col' && arr1.length == 3) {
                        rowSize = 12 / parseInt(arr1[2]);
                        tamanys.push(rowSize);
                    }
    
                })
    
                return fila * tamanys[currentSize];
            }
    
            its.forEach(function(x, i) {
    
                var already = document.querySelector('#inter-' + x.id);
    
                var filters = [
                    valUrl(x),
                    excUrl(x),
                    valSLoads(x, metaData),
                    valCountry(x, metaData),
                    valRegion(x, metaData),
                    valCity(x, metaData)
                ];
    
                if(!already && filters.every(valid)) {
                    var offers = document.querySelectorAll('.oferta-item');
                    var inter = document.createElement('div');  
                    var position = setPosition(offers[0], x.fila);
    
        
                    inter.setAttribute('class','col-xs-12 col-sm-12 col-md-12 col-lg-12 km-inter');
                    inter.setAttribute('id','inter-' + x.id);
                    inter.style.backgroundImage = 'linear-gradient(to right,' + x.bg_1 + ',' + x.bg_2 + ')';
                    inter.style.color = x.color;
                    inter.innerHTML = x.html;
    
                    if(offers[position]) {
                        parent.insertBefore(inter, offers[position]);
                    }
                }
               
            });
    
        }

        // Apaño
        var offers = document.querySelectorAll('.oferta-item');
        if(offers[0]) {
            insertInters();
        }
        //////
    
        //Event procedent de listOffers ajax
        $(document).on('insert_inter', function() {
            insertInters();
        });
    
        window.addEventListener('resize', function() {
            var kmInters = document.querySelectorAll('.km-inter');
            size = window.innerWidth;
            colSizes = [
                size <= 767,
                size <= 991 && size > 767,
                size < 1200 && size > 991,
                size >= 1200
            ]; 

            kmInters = Array.prototype.slice.call(kmInters,0); 
    
            kmInters.forEach(function(x) { 
                x.remove(); 
            })
    
            currentSize = colSizes.findIndex(function(x) { return x;});
            insertInters();
        })
    }
}

// PROOF
function buildProof(pfs) {

    if(pfs.length == 0) return false;

    $.ajax({
        url: mediagach_vars.rootFolder + '/wp-content/themes/mediagach/templates/modules/get-meta-leads.php', 
        success: function(data) {

            var queue = [];                
            var nVisites = document.querySelector('#nVisites');
            nVisites = nVisites ? nVisites.getAttribute('data-visites') : false;

            data = JSON.parse(data);

            //Omplir Array Queue
            pfs.forEach(function(pf) {

                var filters = [
                    valSLoads(pf, metaData),
                    valCountry(pf, metaData),
                    valRegion(pf, metaData),
                    valCity(pf, metaData)
                ];

                if(pf.tipo == 'proof2') {
                    filters.push(valUrl(pf));
                    filters.push(excUrl(pf));
                }
            
                if(filters.every(valid)) {
                    // Strike   
                    if(pf.tipo == 'proof' && nVisites > 30 && nVisites < 200) {
                        queue.push({
                            type: 'strike',
                            img: mediagach_vars.rootFolder + '/mediagach/media/imgmap/flame.png',
                            msg: '<b>' + nVisites + '</b> usuarios han visitado esta oferta <br> <a class="proof-mg" style="margin: 5px 0 0 -6px" target="_blank" href="https://www.mediagach.com/mg-proof/?source=' + window.location.host + '">Verified by MGProof </a>',
                            color: pf.color,
                            bg: pf.bg_1
                        });
                    }
                    // Geolead
                    if(pf.tipo == 'proof2'){
                        data.forEach(function(el, i) {
                            queue.push({
                                type: 'geolead',
                                img: mediagach_vars.rootFolder + data[i].image,
                                msg: '<div class="proof-msg">Alguien de ' + data[i].poblacion + ' esta interesado en ' + data[i].ofertaName + '</div><div class="proof-time"><span>' + data[i].dateMsg + '</span><a class="proof-mg" target="_blank" href="https://www.mediagach.com/mg-proof/?source=' + window.location.host + '">Verified by MGProof </a></div>',
                                color: pf.color,
                                bg: pf.bg_1
                            })
                        })
                    }

                }

            })

            // Mostrar per timings 
            if(queue.length > 0) {

                var metaData = JSON.parse(localStorage.getItem('metadataUser'));
            
                function createDiv(name) {
                    var tmp = document.createElement('div');
                    tmp.classList.add(name);
            
                    return tmp;
                }

                //DOM ELEMENTS
                var proofContainer = createDiv('proof-container');
                var proofImage = createDiv('proof-image');
                var proofText = createDiv('proof-text');
                var x = createDiv('proof-close');
            
                //Ordenar proofs per prioritat
                pfs = pfs.sort(function(a, b) {
                    return parseInt(b.prioridad) - parseInt(a.prioridad);
                })
            
                //Crear DOM Estroctura
                proofContainer.appendChild(proofImage);
                proofContainer.appendChild(proofText);
                proofContainer.appendChild(x);
                
                document.body.appendChild(proofContainer);
        
                x.addEventListener('click', function() {
                    proofContainer.classList.remove('active');
                })
    
                // Init variables animations
                var x = 0;
                var settings = {
                    delay: (parseInt(pfs[0].delay) * 1000 + 1000) || 2000, // +1000 compensar desfas amb les animacions
                    duration: (parseInt(pfs[0].duracion) * 1000) || 1000,
                    max: parseInt(pfs[0].cantidad_maxima) || 5,
                }

                //Animations
                //Tancar
                function interval1() {
                    setTimeout(function() {
                        proofContainer.classList.remove('active');
                        interval2();
                    }, settings.duration)
                }
                //Obrir
                function interval2() {
                    setTimeout(function() {
                        //console.log('Hola', settings);
                        if(settings.max > x && x < queue.length) {
                            proofText.innerHTML = queue[x].msg;
                            proofContainer.style.backgroundColor = queue[x].bg;
                            proofImage.style.backgroundImage = 'url("' + queue[x].img + '")';
                            proofText.style.color = queue[x].color;
                            proofText.style.backgroundColor = queue[x].bg;
                            proofImage.style.boxShadow = queue[x].type == 'strike' ? 'unset' : 'inset 0 0 10px 0px rgba(0, 0, 0, 0.3)';

                            x++;

                            proofContainer.classList.add('active');
                            interval1();
                        }

                    }, settings.delay)
                }

                interval2();

            }

        }
    }); 


}

// TOPBAR
function buildTopbar(tbs) {

    var html = '';
    var metaData = JSON.parse(localStorage.getItem('metadataUser'));
    //var topbars = JSON.parse(sessionStorage.getItem('closeCta')).topbars;
    var topbars = JSON.parse(localStorage.getItem('closeCta')).topbars;

    tbs.forEach(function (tb) {
        //Aplicar filtres: tancat, validar, excluir, sloads, country, region, city
        var filters = [
            topbars[tb.id],
            valUrl(tb),
            excUrl(tb),
            valSLoads(tb, metaData),
            valCountry(tb, metaData),
            valRegion(tb, metaData),
            valCity(tb, metaData)
        ];

        if(filters.every(valid)) setHtml(tb);
    })

    if(html.length > 0) {
        var divAux = document.createElement('div'); // Evitar bug amb menu ofertas
        document.body.appendChild(divAux); // Evitar bug amb menu ofertas
    
        divAux.innerHTML += html;

        topbarCta();
    }

    function setHtml(tb) { 
        html += '<div topbar-id="' + tb.id + '" class="container-fluid topbarCtaBar" style="color: ' + tb['color'] + ';background-image: linear-gradient(to right,' + tb['bg_1'] + ',' + tb['bg_2'] + ');">';
        html +=   '<div class="row">';
        html +=       '<div class="col-xs-1 col-sm-2 col-md-2 col-lg-2"></div>';
        html +=       '<div class="col-xs-9 col-sm-8 col-md-8 col-lg-8 vCenter">' + tb['html'] +'</div>';
        html +=       '<div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 closeCta"><i class="fa fa-times" aria-hidden="true"></i></div>';      
        html +=   '</div>';
        html += '</div>';
    }     
}

function topbarCta() {
    var allCta = document.querySelectorAll('.topbarCtaBar');
    var mtBody = parseInt(window.getComputedStyle(document.body).getPropertyValue('margin-top'));
    var ctaFxs = document.querySelectorAll('.fixedNavKM'); //Busca els fixed 
    var animInt;

    allCta = Array.prototype.slice.call(allCta,0); //ie
    ctaFxs = Array.prototype.slice.call(ctaFxs,0); //ie

    // Guardar el margin original dels fixed
    for(var x in ctaFxs) {
        if(typeof(ctaFxs[x]) === 'object') {
            var fixMargin = parseInt(window.getComputedStyle(ctaFxs[x]).getPropertyValue('margin-top'));
            if(typeof(ctaFxs[x]) === 'object') ctaFxs[x].setAttribute('ctaMargin', fixMargin);
        }
    }

    getMaxHeight(allCta); // Estableix el height en base al topbar mes gran
    animInt = animOpacity0(allCta); // Animacio Fade per veure tots els topbars
    marginFixeds(allCta, mtBody, ctaFxs); // Mou tots els elements Fixeds respecte als topbar
    closeAllCtaX(allCta, mtBody, ctaFxs, animInt); // Tanca tots els ctas de cop
    resizeTopbar(allCta, mtBody, ctaFxs); // Ajusta tots els elements segons el height necesari
}

function getMaxHeight(allCta) {
    maxH = 0; 

    allCta.forEach(function(cta) {
        var ctaHeight = parseInt(window.getComputedStyle(cta).height);
        if(ctaHeight > maxH) maxH = ctaHeight;
    })

    allCta.forEach(function(cta) {
        var ctaHeight = parseInt(window.getComputedStyle(cta).height);
        if(ctaHeight != maxH) { 
            cta.style.height = maxH + 'px';
        } else {
            cta.classList.add('maxH');
            var close = cta.childNodes[0].children[2];
            close.setAttribute('style', 'height: ' + maxH + 'px'); // z.style.height no funciona
        }
    })
}

function animOpacity0(allCta) { 
    var clock = allCta.lenght == 1 ? 0 : 1;
    var animInt = '';
    if(allCta.length > 1) {
        allCta[0].style.zIndex = 9999;
        animInt = setInterval(function() {
            allCta.forEach(function(cta, index) {
                if(index == clock) {
                    cta.style.transition = '0s';
                    cta.style.opacity = 1;
                    setTimeout(function() {
                        cta.style.zIndex = 9998;
                    }, 300)
                } else {
                    cta.style.transition = '.3s';
                    cta.style.opacity = 0;
                    setTimeout(function() {
                        cta.style.zIndex = 9997;
                    }, 300)
                } 
            })
            clock = clock < allCta.length - 1 ? ++clock : 0;
        }, 5000)
    }

    return animInt;
}

function marginFixeds(allCta, mtBody, ctaFxs) {
    var ctaHeight = parseInt(window.getComputedStyle(allCta[0]).height);  

    document.body.style.marginTop = (mtBody + ctaHeight) + 'px';  

    for(var x in ctaFxs) {
        if(typeof(ctaFxs[x]) === 'object') {
            var fixMargin = parseInt(ctaFxs[x].getAttribute('ctaMargin'));
            ctaFxs[x].style.marginTop = (fixMargin + ctaHeight) + 'px'; 
        }
    }
}

function closeAllCtaX(allCta, mtBody, ctaFxs, animInt) {
    //var s = JSON.parse(sessionStorage.getItem('closeCta'));
    var s = JSON.parse(localStorage.getItem('closeCta'));
    
    allCta.forEach(function(cta) {

        var close = cta.childNodes[0].children[2];

        close.addEventListener('click', function() {

            clearInterval(animInt);

            allCta.forEach(function(cta) {
                var ctaHeight = parseInt(window.getComputedStyle(cta).height);
                cta.style.height = ctaHeight + 'px';
                cta.style.transition = '.3s';
        
                var tId = cta.getAttribute('topbar-id');
                s.topbars[tId] = false;
                
                setTimeout(function() {
                    cta.style.height = '0px';

                    document.body.style.marginTop = mtBody + 'px'; //Margin top inicial del Body

                    ctaFxs.forEach(function(x) {
                        var fixMargin = parseInt(window.getComputedStyle(x).marginTop);
                        x.style.transition = '.3s';
                        x.style.marginTop = (fixMargin - ctaHeight) + 'px';
                    }) 

                }, 10);
            })

            $('body').trigger('km-closed');

            localStorage.setItem('closeCta', JSON.stringify(s));
            //sessionStorage.setItem('closeCta', JSON.stringify(s));

        })
        
    })
}

function resizeTopbar(allCta, mtBody, ctaFxs) {
    window.addEventListener('resize', function() {
        var ctaMax = document.querySelector('.maxH');
        var maxH = parseInt(window.getComputedStyle(ctaMax).height);

        allCta.forEach(function(cta) {
            if (cta != ctaMax) cta.style.height = maxH + 'px';
        })   

        marginFixeds(allCta, mtBody, ctaFxs);
    })
}
////////////

// Alert
function buildAlert(als) {

    var html = '';
    //var alerts = JSON.parse(sessionStorage.getItem('closeCta')).alerts;
    //var metaData = JSON.parse(localStorage.getItem('metadataUser'));
    var alerts = JSON.parse(localStorage.getItem('closeCta')).alerts;
    var metaData = JSON.parse(localStorage.getItem('metadataUser'));

    als.forEach(function (al) {

        if(alerts == null) {
            setObj[al.id] = true;
        } else {

            //Aplicar filtres: tancat, validar, excluir, sloads, country, region, city
            var filters = [
                alerts[al.id],
                excUrl(al),
                valUrl(al),
                valSLoads(al, metaData),
                valCountry(al, metaData),
                valRegion(al, metaData),
                valCity(al, metaData)
            ];

            if(filters.every(valid)) setHtml(al);  
        }

    })

    var headerCta = document.querySelector('.alert-here') == null ? 'header' : '.alert-here';

    if(document.querySelector(headerCta) != null) {
        if(html.length != 0) {
            html = '<div class="alerts-container">' + html + '</div>';
            document.querySelector(headerCta).innerHTML += html;  
            alertCta(); 
        }
    } 

    function setHtml(al) {
        html +=  '<div alert-id="' + al.id +'" class="alertCta" style="color:' + al['color'] + '; background-image: linear-gradient(to right,' + al['bg_1'] + ',' + al['bg_2'] + '); box-shadow: inset 0 0 0 2px ' + al['color'] + '">';
        html +=    '<div class="msg">' + al['html'] + '</div>';
        html +=    '<div class="closeAlert"><i class="fa fa-times" aria-hidden="true"></i></div>';
        html +=  '</div>';
    }
}

function alertCta() { 
    var alerts = document.querySelectorAll('.alertCta');
    //var s = JSON.parse(sessionStorage.getItem('closeCta'));
    var s = JSON.parse(localStorage.getItem('closeCta'));

    alerts.forEach(function(alert) {
        var close = alert.childNodes[1];
        close.addEventListener('click', function() {
            alert.style.opacity = 0;
            setTimeout(function() {
                alert.style.margin = 0;
                alert.style.height = 0;
                alert.style.minHeight = 0;
                alert.style.border = 0;
                alert.style.fontSize = 0;
                close.style.display = 'none';
            }, 500);

            var aId = alert.getAttribute('alert-id');

            s.alerts[aId] = false;
            //sessionStorage.setItem('closeCta', JSON.stringify(s));
            localStorage.setItem('closeCta', JSON.stringify(s));
        })
    })
}
////////////

// Toast
function buildToast(tts) {
    var metaData = JSON.parse(localStorage.getItem('metadataUser'));
    //var sObj = JSON.parse(sessionStorage.getItem('closeCta'));
    var sObj = JSON.parse(localStorage.getItem('closeCta'));

    tts.forEach(function(tt) {

        var fTime = false;
        tt.duracion = parseInt(tt.duracion);
        tt.delay = parseInt(tt.delay);
        if(isNaN(tt.duracion)) tt.duracion = 0;
        if(isNaN(tt.delay)) tt.delay = 0;

        if(tt.options != '') {
            fTime = tt.options.find(function(e) {return e == "firstTime"}) == undefined ? false : true;
        }

        /*toastr.options = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": 'toast-top-right',
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": tt.duracion * 1000,
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }
        */

        //Aplicar filtres: tancat, validar, excluir, sloads, country, region, city
        var filters = [
            sObj.toasts[tt.id],
            valUrl(tt),
            excUrl(tt),
            valSLoads(tt, metaData),
            valCountry(tt, metaData),
            valRegion(tt, metaData),
            valCity(tt, metaData)
        ];

        setTimeout(function() {
            if(filters.every(valid)) {
                //toastr['info'](tt.html);
                var toastList = document.querySelector('#toast-container');
                var lastToast = toastList.children[toastList.children.length - 1];
                lastToast.style.backgroundColor = tt.bg_1;
                lastToast.style.color = tt.color;
            }
        }, tt.delay * 1000);
 
        if(fTime) {
            sObj.toasts[tt.id] = false;
            localStorage.setItem('closeCta', JSON.stringify(sObj));
            //sessionStorage.setItem('closeCta', JSON.stringify(sObj));
        }
    })
}
///////////


// POPUP
function buildPopup(pps){

    var html = '';
    var metaData = JSON.parse(localStorage.getItem('metadataUser'));
    //var popups = JSON.parse(sessionStorage.getItem('closeCta')).popups;
    //var s = JSON.parse(sessionStorage.getItem('closeCta'));
    var popups = JSON.parse(localStorage.getItem('closeCta')).popups;
    var s = JSON.parse(localStorage.getItem('closeCta'));
    var popupExecuted=false;
    pps.forEach(function (pp) {
        //console.log("-");
        //console.log(pp);
        var fTime = false;
        if(!popupExecuted){
        
            pp.duracion = parseInt(pp.duracion);
            pp.delay = parseInt(pp.delay);
            if(isNaN(pp.duracion)) pp.duracion = 0;
            if(isNaN(pp.delay)) pp.delay = 0;

            if(pp.options != '') {
                fTime = pp.options.find(function(e) {return e == "firstTime"}) == undefined ? false : true;
                //console.log(fTime);
            }

            var filters = [
                popups[pp.id],
                valUrl(pp),
                excUrl(pp),
                valSLoads(pp, metaData),
                valCountry(pp, metaData),
                valRegion(pp, metaData),
                valCity(pp, metaData)
            ];
                //console.log(filters);
                console.log("keymssg");

            if(filters.every(valid)){
                console.log("show keymssg");
                setHtml(pp);
                popupExecuted=true;
            } 

            setTimeout(function() {
                //alert('soc timetout');
                $(".keymessagePopup").modal();
                if(pp.duracion != 0){
                    hidePopup(pp.duracion);
                }
               
                
            }, pp.delay * 1000);

            

            if(fTime) {
               
                s.popups[pp.id] = false;
                //sessionStorage.setItem('closeCta', JSON.stringify(s));
                localStorage.setItem('closeCta', JSON.stringify(s));
            }

        }



    });


    if(html.length > 0) {
        var divAux = document.createElement('div'); // Evitar bug amb menu ofertas
        document.body.appendChild(divAux); // Evitar bug amb menu ofertas    
        divAux.innerHTML += html;
        
    }



    function hidePopup(time){
        setTimeout(function() {           
           $(".keymessagePopup").modal('hide'); 
        }, time * 1000);
    }

    function setHtml(pp) { 
       

        html += '<div class="modal fade keymessagePopup" id="keymessageModalCenter" tabindex="-1" role="dialog" aria-labelledby="keymessageModalCenter" aria-hidden="true">';
        html +=     '<div class="modal-dialog modal-dialog-centered modal-popup-dialog" role="document">';
        html +=         '<div class="modal-content" style="background-image: linear-gradient(to right,' + pp['bg_1'] + ',' + pp['bg_2'] + '); ">';
        html +=             '<div class="modal-header" style="border: 0; border-radius: 6px; background-color: transparent; background-image: none; ">';
        //html +=                '<h5 class="modal-title" id="exampleModalCenterTitle">Modal title</h5>';
        html +=                '<button type="button" class="close" data-dismiss="modal" aria-label="Close" style="background-color: transparent; border: 0; padding: 9px 9px 0px 9px;  color:'+ pp['color'] +' !important; ">';
        html +=                  'x';
        html +=                '</button>';
        html +=              '</div>';
        html +=              '<div class="modal-body" style="border-radius: 6px; color: ' + pp['color'] + '; background-color: transparent;">';
        html +=                pp['html'];
        html +=              '</div>';
        /*html +=              '<div class="modal-footer">';
        html +=                '<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>';
        html +=                '<button type="button" class="btn btn-primary">Save changes</button>';
        html +=              '</div>';*/
        html +=         '</div>';
        html +=     '</div>';
        html +=  '</div>';


        
    }    


}
///////////


// Validacions de filtres 
function valUrl(x) {
    var show = x.show.replace(/ /g,'').replace(/,/g,'|');

    if(/\*/.test(show)) {
        return true;
    } else {
        var reg = new RegExp(show);
        return reg.test(window.location.href);
    }
}

function excUrl(x) {
    var hide = x.hide.replace(/ /g,'').replace(/,/g,'|');
    if(x.hide.length == 0) return true; // ?

    if(/\*/.test(hide)) {
        return false;
    } else {
        var reg = new RegExp(hide);
        return !reg.test(window.location.href);
    }
}

function valSLoads(x, m) {
    if(x.s_loads == null || x.s_loads <= 1) return true;

    var sessions = m.utils.se;

    if(sessions.length == 0){
        var last = {
            date: hoy,
            du: 0,
            lo: 0
        };
    }else{
        var last = sessions[sessions.length - 1];
    }

    return last.lo >= x.s_loads;
}

function valCountry(x, m) {
    if(x.country == undefined || x.country.length == 0) return true;

    var country = atob(m.utils.co);

    return x.country.includes(country); 
}

function valRegion(x, m) {
    if(x.region == undefined || x.region.length == 0) return true;

    var region = atob(m.utils.re);

    return x.region.includes(region); 
}

function valCity(x, m) {
    if(x.city == undefined || x.city.length == 0) return true;

    var city = atob(m.utils.ci);
   
    return x.city.includes(city); 
}

function valid(e) {
    return e;
}



                    $(".close-cookie").on("click",function(){
                        $("#cookie-bar").css("display","none");

                    });

                    counterLogo=0;
                    actualLogo=1;
                    setInterval(function(){
                        $(".logo-marcas-left").removeClass("marca"+actualLogo);
                        actualLogo=counterLogo%3;
                        $(".logo-marcas-left").addClass("marca"+actualLogo);
                        counterLogo=counterLogo+1;
                    },3000);

                    $(".rutaMaps").on("click",function(){
                        markerManual=$(this).attr("data-marker");
                        $("#wpgmza_marker_"+markerManual+" a").trigger("click");
                    });

                    $(".llamar").on("click",function(){
                        $(this).html($(this).attr("data-telf"));
                        $(this).find("span").css("display","block");
                    });

                    $('.owlCarruselOfertas').owlCarousel({
                        loop:true,
                        margin:10,
                        responsiveClass:true,
                        lazyLoad:true,
                        autoplay: 2000, 
                        nav:true,
                        stopOnHover : true,
                        autoplayHoverPause: true,
                        navText: [
                           "<i class='demo-icon icon-tipografia-drivim-06'></i>",
                           "<i class='demo-icon icon-tipografia-drivim-05'></i>"
                        ],
                        responsive:{
                            0:{
                                items:2
                            },
                            768:{
                                items:3
                            },
                            1000:{
                                items:4
                            }
                        }

                    });



                    $(".right-sidebar-static ul").hover(function(){
                        $(".right-sidebar-static").addClass("right0").removeClass("right1");
                    },function(){
                        $(".right-sidebar-static").removeClass("right0").addClass("right1");
                    });

                    $(".tellamamos a").on("click",function() {
                        copiedModal = $("#modal-tellamamos");
                        ////$("#modal-tellamamos").remove();
                        ////copiedModal.appendTo("body");
                        $("#modal-detail").modal("hide");
                        $("#modal-contact").modal("hide");
                        $("#modal-tellamamos").modal();
                    });
                    $(".prueba-domicilio a").on("click",function() {
                        copiedModal = $("#modal-prueba");
                        /////$("#modal-prueba").remove();
                        ////copiedModal.appendTo("body");                        
                        $("#modal-detail").modal("hide");
                        $("#modal-contact").modal("hide");
                        $("#modal-prueba").modal();
                    });


                    //if ($(".autobeltran_collection")[0]){
                            var owlCollection = $('.owl-carousel-brands');
                            owlCollection.owlCarousel({
                                    items:4,
                                    loop:true,
                                    margin:10,
                                    autoplay:true,
                                    autoplayTimeout:5000,
                                    autoplayHoverPause:false,
                                    lazyLoad: true,
                                    animateOut: 'fadeOut',
                                    animateIn: 'fadeIn',
                                    transitionStyle: "fade",

                                    responsiveClass:true,
                                        responsive:{
                                            0:{
                                                items:2,
                                            },
                                            600:{
                                                items:3, 
                                            },
                                            1000:{
                                                items:4,
                                            }
                                        }

                            });



                    //}


                    var isEventoQR = document.getElementById('gform_wrapper_33');
                    if (isEventoQR !== null){
                        texto=Math.floor(Math.random() * (20000 - 10000 + 1)) + 10000;
                        texto2=Math.floor(Math.random() * (2000 - 1000 + 1)) + 1000;
                        setTimeout(function(){ 
                            $("#gform_wrapper_33 textarea").html(texto+"_M1t63_"+texto2);
                            $("#gform_wrapper_33 textarea #inner-editor").html(texto+"_M1t63_"+texto2);
                        }, 6000);
                        
                    }

                   /* var isSliderSmart = document.getElementById('mediagachSliderSmart');
                    if (isSliderSmart !== null){
                        $(document).on("mouseup touchend", function(e) {
                            
                            $(document).off("mousemove touchmove");
                            
                        });

                        $("#sliderCarousel").swipe({
                          swipe: function(event, direction, distance, duration, fingerCount, fingerData) {

                            if (direction == 'left') $(this).carousel('next');
                            if (direction == 'right') $(this).carousel('prev');

                          },
                          allowPageScroll:"vertical"

                        });
                    }
                    */



                    //FICHAS CENTRO FOOTER INIT
                    var owlFichas = $('.owl-carousel-fichas');
                    owlFichas.owlCarousel({
                            items:3,
                            loop:false,
                            margin:0,
                            autoplay:false,
                            autoplayTimeout:10000,
                            autoplayHoverPause:true,
                            lazyLoad: true,
                            animateOut: 'fadeOut',
                            animateIn: 'fadeIn',
                            transitionStyle: "fade",
                            nav: true,
                            navText: [
                               "<i class='icon-mediagach-tipografia_drivim_icones_final-02'></i>",
                               "<i class='icon-mediagach-tipografia_drivim_icones_final-03'></i>"
                            ],
                            responsiveClass:true,
                                responsive:{
                                    0:{
                                        items:1,
                                    },
                                    650:{
                                        items:2,
                                    },
                                    900:{
                                        items:3,
                                    },
                                    1200:{
                                        items:3,
                                    }
                                }

                    });

                    $(".owl-carousel-fichas .centro-text-info .direccion").sameheight();
                    $(".owl-carousel-fichas .centro-text-info .servicios").sameheight();

                    //END FICHAS CENTRO FOOTER


                    $(".close-menu").on("click",function(){
                        if($(this).hasClass("active")){
                            $(this).removeClass("active");
                            $(this).find(".text").html("Cerrar");
                            $("nav.menu-lateral").velocity({
                                bottom: "0px"
                            }, {
                                duration: 100, 
                            });
                        }else{
                            $(this).addClass("active");
                            $(this).find(".text").html("Abrir");
                            $("nav.menu-lateral").velocity({
                                bottom: "-56px"
                            }, {
                                duration: 100, 
                            });

                        }
                    });

                    var isBuscador = document.getElementById('mediagachBuscador');
                    if (isBuscador !== null){

                        $(".verOfertasBuscador").on("click",function(){
                            selectTipo = document.getElementById("selectTipo").value;
                            selectModelo = document.getElementById("selectModelo").value;
                            selectCarroceria = document.getElementById("carroceriaModelo").value;
                            flagModelo = true;
                            flagtipo = true; 
                            flagCarroceria = true;
                            
                            if(selectTipo===""){
                                flagtipo=false;
                            }
                            if(selectModelo===""){
                                flagModelo=false;
                            }
                            if(selectCarroceria===""){
                                flagCarroceria=false;
                            }
                            var urlBuscador = webUrl+"ofertas/";
                            if(flagtipo){
                                if(selectTipo=="-nuevos"){
                                    urlBuscador=webUrl+"ofertas-nuevos-y-km0/";
                                }else{
                                    urlBuscador=webUrl+"ofertas-ocasion";
                                }
                            }

                            if(flagModelo){
                                urlBuscador+="?modelos="+encodeURI(selectModelo);
                            }
                            if(flagCarroceria){
                                var symbolUrl = "?";
                                if(flagModelo){
                                    symbolUrl = "&";
                                }
                                urlBuscador+=symbolUrl+"carroceria="+encodeURI(selectCarroceria);
                            }
                            
                            location.href=urlBuscador;





                            
                        });



                        $("#finder_mediagach input").on("focus",function(){
                            $("#mediagachBuscador")
                            .velocity("scroll", { duration: 1500, easing: "easeInOutCirc", offset: -70 });
                        });


                        



                        //$("#selectModelo").append();
                        var typeOffersModelo = new Bloodhound({
                                         datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
                                         queryTokenizer: Bloodhound.tokenizers.whitespace,
                                         prefetch: webUrl+'mediagach/scripts/typeaheadModeloTipo.php'
                        });

                        typeOffersModelo.initialize();
          


                        auxSelect=typeOffersModelo.index.datums;
                        if($('body').hasClass("smart")){
                            $("#selectModelo").append("<option value='ForTwo'>fortwo</option>");
                            $("#selectModelo").append("<option value='ForTwo Cabrio'>fortwo cabrio</option>");
                            $("#selectModelo").append("<option value='ForFour'>forfour</option>");
                            
                        }else{
                           //fillSelectModelo(auxSelect);


                        }

                       







 
                    /*    var engine = new Bloodhound({
                            datumTokenizer: function (datum) {
                                  return Bloodhound.tokenizers.whitespace(datum.name);
                            },
                            queryTokenizer: Bloodhound.tokenizers.whitespace,
                            prefetch: {
                                url: webUrl+'api/get_posts/?post_type=promocion',
                                cache: false,
                                transform: function(response) {
                                    console.log(response);
                                    return $.map(response.posts, function (tag) {
                                        return {
                                            name: tag.title,
                                            url: tag.url,
                                            image: tag.custom_fields.imagen
                                        }
                                    });
                                }




                            }
                        });

                        engine.initialize();*/







                    function getSourceWithDefaults(q, sync) {
                      if (q === '') {
                         sync(typeOffersModelo.all().slice(0, 6)); 
                      }
                      else {
                        typeOffersModelo.search(q, sync);
                      }
                    }




                        $('#finder_mediagach .typeahead').typeahead({
                          minLength: 0,
                          highlight: true
                        },
                        {
                        limit:6,
                        name: 'ofertasModelo',
                        displayKey: 'value',
                        source: getSourceWithDefaults,
                        templates: {
                            header: '<h3 class="block-name">Ofertas por modelo</h3>',
                            suggestion: function (data) {
                                console.log(data.name);
                                    ofer_aux="ofertas";
                                    if(data.num==="1"){ofer_aux="oferta";}
                                    nameReplaced=data.name;
                                    /*Init Excepcion Autobeltran*/
                                    nameReplaced = nameReplaced.replace(' Nuevo','-nuevos');
                                    nameReplaced = nameReplaced.replace(' Ocasión','-ocasion');
                                    /*End Excepcion Autobeltran*/
                                    return '<a href=" '  + webUrl + 'ofertas/' + encodeURI(nameReplaced) + ' " onClick="ga(&quot;send&quot;, &quot;event&quot;, &quot;Buscador&quot;, &quot;' + data.name + '&quot;, &quot;&quot;);"><p class="finderP"><div class="filler"></div><b> ' + data.name + '</b> - <span>' + data.num + ' ' + ofer_aux +'</span></p></a>';
                            }
                          } 
                        }, 

                        {
                          limit:6,
                          name: 'masBuscado',
                           displayKey: 'name',
                           source: function(query, cb) {
                                var result = [
                                {'name': 'Ofertas Ocasión','url' : 'ofertas-ocasion/','icon':'fa-car'},
                                {'name': 'Ofertas Nuevos y KM0','url' : 'ofertas-nuevos-y-km0/','icon':'fa-car'},
                                {'name': 'Ofertas Smart','url' : 'ofertas-smart/','icon':'fa-car'},
                                {'name': 'Promociones posventa','url' : 'posventa/','icon':'fa-bullhorn'},
                                {'name': 'Pedir cita taller','url' : 'cita-previa/','icon':'fa-calendar-check-o'},
                                {'name': 'Contactar','url' : 'contacto/','icon':'fa-envelope-o'},
                                {'name': '¿Dónde estamos?','url' : 'contacto/#footer','icon':'fa-map-marker'}
                                ];
                              cb(result);
                            },
                             templates: {
                               header: '<h3 class="block-name">Lo más buscado...</h3>',
                                suggestion: function (data) {
                                    return '<a href=" ' + webUrl + data.url + ' " onClick="ga(&quot;send&quot;, &quot;event&quot;, &quot;Buscador&quot;, &quot;' + data.name + '&quot;, &quot;&quot;);"><p><i class="fa ' + data.icon + '" aria-hidden="true"></i> ' + data.name + '</p></a>';
                                }
                             } 
              
                        });
                   /*     {
                        name: 'engine',
                        display: 'name',
                        source: engine,
                        limit: 2,
                            templates: {
                                header: '<h3 class="block-name">Promociones</h3>',
                                suggestion: function (data) {
                                        return '<a href=" ' + data.url + ' "><p class="finderP"><div class="filler"></div><b> <img src="' + data.image[0] + '" width="100"/></b><span>' + data.name + ' ofertas</span></p></a>';
                                }
                              }
                            }*/

                    






                    }

                    /* OWL CAROUSEL - FOOTER V3 */
                    $('.owl-carousel-footerV3').owlCarousel({
                        items : 1,
                        slideSpeed : 2000,
                        nav: false,
                        autoplay: true,
                        dots: false,
                        loop: true,
                        lazyLoad: true,
                        responsiveRefreshRate : 200,
                        animateOut: 'fadeOut',
                    })

                    /* OWL CAROUSEL - NOTICIAS V3 */
                    $('.noticias-owl').owlCarousel({
                        items: 3,
                        autoplay: true,
                        dots: false,
                        nav: false, 
                        loop: false,
                        mouseDrag: true,
                        touchDrag: true,
                        pullDrag: false,
                        rewind: false,
                        lazyLoad: false,
                        animateOut: false, 
                        navText: [
                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-left"></i></a></object>',
                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-right"></i></a></object>'
                        ],
                        responsive : {
                            0: {
                                items: 1,
                            },
                            800: {
                                items: 2,
                            },
                            992: {
                                items: 3,
                            }
                        }
                    });


                    $(".mg-side-menu-container2 .mg-menu-vertical-left ul").addClass('owl-carousel');

                    var newMenu = document.querySelector('.mg-side-menu-container2');

                    if(newMenu) {
                        var ignoreItems = document.querySelectorAll('.ignore-side-item');

                        //star
                        var star = document.querySelector('.starXperience .main-container');
                        if(star) star.style.width = '100%';

                        ignoreItems = Array.prototype.slice.call(ignoreItems,0);
                        
                        for(var x in ignoreItems) {
                            if(typeof(ignoreItems[x]) == 'object') ignoreItems[x].remove();
                        }
                    }

                    $(".mg-side-menu-container2").show();

                    // OWL CAROUSEL - Menu V3
                    $(".mg-side-menu-container2 .mg-menu-vertical-left ul").owlCarousel({
                        items: 8,
                        autoplay: false,
                        dots: false,
                        nav: false, 
                        loop: true,
                        mouseDrag: true,
                        touchDrag: true,
                        pullDrag: false,
                        rewind: false,
                        lazyLoad: true,
                        animateOut: false, 
                        responsive : {
                            0: {
                                items: 3,
                                autoplay: true,
                            },
                            800: {
                                items: 6,
                                autoplay: true,
                            },
                            992: {
                                items: 6,
                                autoplay: false,
                            }
                        }
                    })
                });

                $('img.lazy').on('load', function () {
                    Waypoint.refreshAll();
                });
                

                
setTimeout(function() {

    $('body').on('click','.mgComparador', function() {
        metaCount(this, 'numComparador');
    });

    $('body').on('click','.detallesBtn', function() {

        var visitesPon = document.querySelector('.row-ofertas').children;
        var currentDiv = this.parentNode.parentNode;
        var posicion = 0;

        for(var x = 0; x < visitesPon.length; x++) {

            if(visitesPon[x].children[0].isEqualNode(currentDiv)) {
                posicion = x;
            }

        }
 
        metaCount(this, 'numVisites', posicion);

    });

    $('body').on('click','.metaCountImageUrl', function() {
        metaCount(this, 'numVisites');
    });

    $('body').on('click','.socialShareMini, .socialShare', function() {
        metaCount(this, 'numLikes');
    });


}, 10000)


function metaCount(el, type, pon) {

    var idOferta = el.getAttribute('data-id');

    pon = pon == undefined ? '' : '&pon=' + pon;
    
    if(idOferta && type) {

        $.ajax({
            url: mediagach_vars.rootFolder + '/wp-content/themes/mediagach/utils/modules/count-fields.php/?idOffer=' + idOferta + '&type=' + type + pon,
        }); 

    }
} 


                //Preloader
                var windowLoadedFlag = false;

                window.onpageshow = function () {
                    if(!windowLoadedFlag){
                        console.log('pageshow');
                        windowLoadedFlag=true;
                        windowLoaded();
                    }
                }
                $(document).ready(function() {
                    if(!windowLoadedFlag){
                        console.log('docready');
                        windowLoadedFlag=true;
                        windowLoaded();
                    }
                });
                //fallback
                setTimeout(function() {
                    if(!windowLoadedFlag){
                        console.log('setimeout');
                        windowLoadedFlag=true;
                        windowLoaded();
                    }
                    setTimeout(function() {
                        windowLoaded();
                    }, 1000);
                }, 1500);

                function windowLoaded(){
                    //preloader
                    //var pre = document.querySelector('#preloader');
                    //pre.style.opacity = 0;
                    $("#ultimasNoticias .entry-title").sameheight();
                    setTimeout(function() {   
                        //pre.style.display = 'none';
                    }, 300);
                    $(document).trigger('window_onload');
                }

        

            }
        },
        // Blog 
        'blog': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                $("#grid-2x1-v1 .blockPost,#grid-3x1-v1 .blockPost").sameheight();
                $("#loop-block-star .info-content h4").sameheight();
            }
        },       
        // Home page 
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }

        },

        'registrate': {
            init: function() {
                // JavaScript to be fired on the about us page
                
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                function regformhash() {

                    pwd = hex_sha512( $('[name="input_3"]').val());
                    conf = hex_sha512($('[name="input_3_2"]').val());

                    $('[name="input_4"]').val(pwd);
                    $('[name="input_5"]').val(conf);
                                        
                }

                $(".gform_button").click(function() {
                    regformhash();

                    

                });

            }

        },

        'reset_password': {
            init: function() {
                
                $('.gf_readonly input').attr("readonly","readonly");
                $('.gf_readonly input').css("backgroundColor","#d4d4d4");
                
                
            },
            finalize: function() {
                
                

                $(".gform_button").click(function() {
                    pwd = hex_sha512( $('[name="input_2"]').val());
                    $('[name="input_3"]').val(pwd);     

                });

            }


        },
        'page_template_template_eq_V3': {
            init: function() {

            },
            finalize: function() {

                $(document).ready(function () {
  
                    function initCarousel() {
          
                        var checkWidth = $(document).width();
                    
                        if(checkWidth < 768){
                            $(".gama-items").owlCarousel({
                                items: 3,
                                autoplay: true,
                                dots: true,
                                nav: true, 
                                loop: true,
                                mouseDrag: true,
                                touchDrag: true,
                                pullDrag: false,
                                rewind: false,
                                lazyLoad: true,
                                animateOut: false, 

                                navText: [
                                    '<i class="icon-mediagach-navigation-chevron-left"></i>',
                                    '<i class="icon-mediagach-navigation-chevron-right"></i>'
                                ],
                                
                                responsive: {
                                    0: {
                                        items: 1
                                    },
                                    500: {
                                        items: 3
                                    }
                                }
                            });
                        } else {
                            $('.gama-items').owlCarousel('destroy'); 
                        }
                    }

                    initCarousel();
                    

                    window.addEventListener('resize', function(){
                        initCarousel();
                        $('.gama-car').sameheight();
                    })

                    new Waypoint({
                        element: $(".mini-menu"),
                        handler: function(direction) {
                          if(direction === "down"){
                              $(".mini-menu").addClass("stuck");
                              $(".mini-menu-offset").addClass("active");
                          }else{
                              $(".mini-menu").removeClass("stuck");
                              $(".mini-menu-offset").removeClass("active");
                          }
                        },
                        offset: 50
                    });
                    
                });

                //Event que es crida al window.onload del common
                $(document).on('window_onload', function() { 
                    $('.gama-car').sameheight();
                });
 
            }
        },
        'page_template_template_eq_V4': {
            init: function() {

            },
            finalize: function() {

                $(document).ready(function () {
  
                    function initCarousel() {
          
                        var checkWidth = $(document).width();
                    
                        if(checkWidth < 768){
                            $(".gama-items").owlCarousel({
                                items: 3,
                                autoplay: true,
                                dots: false,
                                nav: false, 
                                loop: true,
                                mouseDrag: true,
                                touchDrag: true,
                                pullDrag: false,
                                rewind: false,
                                lazyLoad: true,
                                animateOut: false, 
                                responsive: {
                                    0: {
                                        items: 1
                                    },
                                    500: {
                                        items: 3
                                    }
                                }
                            });
                        } else {
                            $('.gama-items').owlCarousel('destroy'); 
                        }
                    }

                    initCarousel();
                    

                    window.addEventListener('resize', function(){
                        initCarousel();
                        $('.gama-car').sameheight();
                    })

                    new Waypoint({
                        element: $(".mini-menu"),
                        handler: function(direction) {
                          if(direction === "down"){
                              $(".mini-menu").addClass("stuck");
                              $(".mini-menu-offset").addClass("active");
                          }else{
                              $(".mini-menu").removeClass("stuck");
                              $(".mini-menu-offset").removeClass("active");
                          }
                        },
                        offset: 50
                    });
                    
                });

                //Event que es crida al window.onload del common
                $(document).on('window_onload', function() { 
                    $('.gama-car').sameheight();
                });
 
            }
        },
        'page_template_template_galeria_eventos':{

            init: function(){

            },
            finalize: function(){  
                
                 $('.cover-event-gallery').hover(
                  function() {
                    $(this).css("background-color","rgba(200, 200, 200, 0)");
                  }, function() {
                    $(this).css("background-color","rgba(200, 200, 200, 0.15)");
                  }
                );

            }

        },

        'page_template_template_no_sidebar':{

            init: function(){

            },
            finalize: function(){  
                
                $("body").on("click",".btn-open-form-page",function(){

                    copiedModal = $("#modal-page");
                    ////$("#modal-page").remove();
                    ////copiedModal.appendTo("body");
                    $("#modal-page").modal();                   
                    
                });
                 

            }

        },

        'page_template_template_modelo_page':{
            init: function(){

            },
            finalize: function(){

                $('.owl-carousel-eventos').owlCarousel({                          
                        loop: true,
                        items:4,        
                        nav: false,
                        autoplay:false,
                        autoplayTimeout:3000,
                        autoplayHoverPause:true, 
                        responsive : {                            
                            0 : {
                                items: 4,
                            },                           
                            480 : {
                                items: 5,
                            },
                            992 : {
                                items: 5,
                            }
                        }
                });

                $('.customNextBtn').click(function() {
                        $('.owl-carousel-eventos').trigger('next.owl.carousel');
                    }               
                );
                $('.customPrevBtn').click(function() {
                    $('.owl-carousel-eventos').trigger('prev.owl.carousel');
                    }               
                );

                $('.container-color-group').on("click",function(){
                    
                    $('.selected-color.selected').removeClass("selected");
                    $(this).find("hr").addClass("selected");
                    numColor =  $(this).attr("data-color");

                    //agafem la url actual de la imatge
                    url = $('.car-image-config').attr("src");
                    typeFile = url.split("."); 
                    fileExtension = typeFile[typeFile.length-1];                    
                    url = url.substring(0, url.length - 6);
                   
                    $('.car-image-config').attr("src",url+numColor+"."+fileExtension);
                
                });
                
                function fillHiddenField(t) {                                   
                    $(".detalles-promocion input").val($(t).attr("data-detalles"));
                    //$("#input_38_17").val('CLA');
                }

                $("body").on("click",".btn-open-form-detail",function(){
                      copiedModal = $("#modal-pideOferta");
                      ////$("#modal-pideOferta").remove();
                      ////copiedModal.appendTo("body");
                      $("#modal-pideOferta").modal();
                      
                      $(".textarea-interested").addClass("hidden");
                      $(".addMessage p").removeClass("hidden");   
                      
                      fillHiddenField($(this));
                });

                $(document).ready(function() {   

                    $("body").on("click",".addMessage",function(){
                         $(".textarea-interested").toggleClass("hidden");
                         $(".addMessage p").toggleClass("hidden");
                    });
                                
               });  
            }

        },

        'page_template_template_portada':{
           init: function(){
                       var owl = $('.slider-carousel');

 
                        
          


           },
           finalize: function(){

                // Carousel initialization
               
     /* loop:true,
      margin:0,
      navSpeed:500,
      nav:true,
      items:1*/


    
        var owl = $('.slider-carousel');
            owl.owlCarousel({ 
                        center: true,                
                        loop: true,                    
                        margin:10,   
                        items: 1, 
                        stagePadding: 100,
                        //autoWidth:true,
                        dots: true,
                        video: true,                    
                        videoWidth: false, 
                        videoHeight: false,
                        
                        autoplay: true,
                        autoplayTimeout: 7500,                    
                        merge: true,
                        lazyLoad: false,
                        responsiveClass:true,     
                        responsive:{
                            0:{
                                stagePadding: 0
                            },
                            720:{
                                stagePadding: 100
                            }
                        } ,
                        onInitialized: function(event){
                            $('.owl-carousel').css("opacity","1");
                            var $currentItem = $('.owl-item', owl).eq(event.item.index);
                            var currentBackground = $currentItem.find('.image-bg');
                            currentBackground.addClass('animation-bg-slider');
                            var $elemsToanim = $currentItem.find("[data-animation-in]");
                            setAnimation ($elemsToanim, 'in', 'animated');
                            currenVideo = $currentItem.find('.owl-video-tn');
                            if(currenVideo.length){
                                url = currenVideo.css('background-image');
                                urlNew = url.replace("_640","_1280");
                                currenVideo.css('background-image',urlNew);
                            }
                        } 
                        
                    });  
                   
                   
        
                    owl.on('change.owl.carousel', function(event) {
                       
                        $('.button-more-carousel').css('opacity', '0');
                        $('.image-bg').removeClass('animation-bg-slider');

                    });

                    owl.on('changed.owl.carousel', function(event) {                        
                        var $currentItem = $('.owl-item', owl).eq(event.item.index);
                        var currentBackground = $currentItem.find('.image-bg');
                        currentBackground.addClass('animation-bg-slider');                        
                        var $elemsToanim = $currentItem.find("[data-animation-in]");
                        setAnimation ($elemsToanim, 'in', 'animated');
                        /*currenVideo = $currentItem.find('.owl-video-tn');
                        if(currenVideo.length){
                            url = currenVideo.css('background-image');
                            urlNew = url.replace("_640","_1280");
                            currenVideo.css('background-image',urlNew);
                        }*/
                        
                    });
                             

                $("body").on("click",".open-modal-video",function(){
                    
                    urlVideo = $(this).attr('data-video');
                    separat = urlVideo.split("/");
                    if(separat[separat.length-1]==""){
                        idVimeo = separat[separat.length-2];
                    }else{
                        idVimeo = separat[separat.length-1];
                    }
                    urlVimeo = "https://player.vimeo.com/video/"+idVimeo+"?color=ffffff&title=0&byline=0&portrait=0";
                    $('.iframe-vimeo-video').attr('src',urlVimeo);
                    copiedModal = $("#modalVideo");
                    ////$("#modalVideo").remove();
                    ////copiedModal.appendTo("body");
                    $("#modalVideo").modal();
                    
                });

                 $("body").on("click","#modalVideo",function(){
                    $('.iframe-vimeo-video').attr('src',"");

                 });


            function setAnimation ( _elem, _InOut, _cssClass ) {
            
                var animationEndEvent = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                
                _elem.each ( function () {
                  var $elem = $(this);
                  if($elem.hasClass("button-more-carousel")){
                    var $animationType = 'animatedDelay ' + $elem.data( 'animation-' + _InOut );                
                  }else{
                    var $animationType = _cssClass + ' ' + $elem.data( 'animation-' + _InOut );
                  }
                 
                    $elem.addClass($animationType).one(animationEndEvent, function () {
                        $elem.removeClass($animationType); // remove animate.css Class at the end of the animations
                        $elem.css('opacity', '1');
                    });
                });
            }

          
            function setAnimationBackground ( _elem, _InOut, _cssClass ) {           
                var animationEndEvent = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                
                _elem.each ( function () {
                  var $elem = $(this);
                  if($elem.hasClass("button-more-carousel")){
                    var $animationType = 'animatedDelay ' + $elem.data( 'animation-' + _InOut );                
                  }else{
                    var $animationType = _cssClass + ' ' + $elem.data( 'animation-' + _InOut );
                  }
                 
                    $elem.addClass($animationType).one(animationEndEvent, function () {
                        $elem.removeClass($animationType); // remove animate.css Class at the end of the animations
                        $elem.css('opacity', '1');
                    });
                });
            }

            var buscadorModelo = "";
            var buscadorCombustible= "";
            var buscadorCambios = "";
            $('#mgBuscador3 select').select2({
                    placeholder: "Selecciona un modelo",
                    allowClear: true,
                    templateResult: setOptionSelect

            });
            $('#mgBuscador3 select').on("select2:select", function (e) { 
                console.log("ofertas/?modelos="+e.params.data.id);
                window.location.href = "ofertas/?modelos="+e.params.data.id;
            });

              function setOptionSelect (data) { 
                  if (!data.id) {
                    return data.text;
                  }
                    var $model = $( '<a href="dewdew.com"><span class="blockSelectBuscador3">' + data.text + '<span class="num">' + data.element.dataset.num +'</span></span></a>');
                    return $model;
                };

            $( "#mgBuscador2 select#selectModelos,#mgBuscador2 select#selectCombustible,#mgBuscador2 select#selectCambios" ).change(function() {
                var buttonBuscador = $( "#mgBuscador2 button");
                var hrefBuscador = buttonBuscador.parent().attr("data-href")+"?";
                var buscadorAux=[];

                  switch ($(this).attr("id")) {
                      case "selectModelos":
                          buscadorModelo=$(this).val();
                          break;
                      case "selectCombustible": 
                          buscadorCombustible=$(this).val();
                          break;
                      case "selectCambios":
                          buscadorCambios=$(this).val();
                          break;
                  }
                  if(buscadorModelo!=""){
                    buscadorAux.push(buscadorModelo);
                    hrefBuscador+="modelos="+buscadorModelo;
                  }
                  if(buscadorCombustible!=""){
                    buscadorAux.push(buscadorCombustible);
                    hrefBuscador+="&motor="+buscadorCombustible;
                  }
                  if(buscadorCambios!=""){
                    buscadorAux.push(buscadorCambios);
                    hrefBuscador+="&cambios="+buscadorCambios;
                  }
                    if (buscadorAux.length > 0) {
                        buttonBuscador.html("Ver stock ("+buscadorAux.join(", ")+")");
                        buttonBuscador.parent().attr("href",hrefBuscador);
                    }else{
                        buttonBuscador.html(buttonBuscador.attr("data-title"));                        
                        buttonBuscador.parent().attr("href",hrefBuscador);
                    }

            });


         
           }
        },

        'page_template_template_portada_amg2': {
            init: function() {
        
            },
            finalize: function() {
        
                //Event que es crida al window.onload del common
                $(document).on('window_onload', function() { 
                    $('.ficha-text-p').sameheight();
                });
        
                window.addEventListener('resize', function() {
                    $('.ficha-text-p').sameheight();
                });
                $(".amg-container .fichas-empleados").owlCarousel({
                    items: 2,
                    autoplay: true,
                    dots: false,
                    nav: false, 
                    loop: true,
                    mouseDrag: true,
                    touchDrag: true,
                    pullDrag: false,
                    rewind: false,
                    lazyLoad: true,
                    animateOut: false,
                    navText: [
                        '<i class="icon-mediagach-navigation-chevron-left"></i>',
                        '<i class="icon-mediagach-navigation-chevron-right"></i>'
                    ],
                    responsive: {
                        0: {
                            items: 1,
                            nav: true
                        },
                        576: {
                            items: 2,
                            nav: false
                        },
                        992: {
                            items: 3,
                            nav: false
                        }
                    }
                });
            }
        },
        
        
        'page_template_template_portadaV3':{
            init: function() {

            },
            finalize: function() {

                /* OWL CAROUSEL - PORTADA V3 */
                $('.owl-slider-portadaV3').owlCarousel({
                    items: 1,
                    autoplay: true,
                    dots: true,
                    nav: false, 
                    loop: true,
                    mouseDrag: true,
                    touchDrag: true,
                    pullDrag: false,
                    rewind: false,
                    lazyLoad: true,
                    animateOut: false, 
                    navText: [
                        '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-left"></i></a></object>',
                        '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-right"></i></a></object>'
                    ]
                });
            }
        },

        /// Template BUSCADOR CENTROS 
        'page_template_template_buscadorCentros': {
    init: function() {
        // JavaScript to be fired on the home page
    },
    finalize: function() {
        $("#buscador-centro .centro-text-info .direccion").sameheight();
        $("#buscador-centro .centro-text-info .servicios").sameheight();
        var Shuffle = window.shuffle;
        var element = document.getElementById('buscador-centro');

        shuffle_centros = new Shuffle(element, {
            itemSelector: '#buscador-centro .centro-item-content',
            sizer: '.my-sizer-element',
            speed: 1000,
            easing: 'ease'
        });


        $("#filters_buscador_centro select").on("change",function(){

            var marcasVal = $("select#marcasBuscador").val();
            var serviciosVal = $("select#serviciosBuscador").val();
            var poblacionesVal = $("select#poblacionesBuscador").val();

            shuffle_centros.filter(function(element) {
                var marcas = JSON.parse(element.querySelector('#buscador-centro .centro-item').getAttribute('data-marcas'));
                var servicios = JSON.parse(element.querySelector('#buscador-centro .centro-item').getAttribute('data-servicios'));
                var poblacion = JSON.parse(element.querySelector('#buscador-centro .centro-item').getAttribute('data-poblacion'));
                if( (marcas.indexOf(marcasVal) !== -1) || (marcasVal==="-") ){
                    console.log("marca");
                    if( (servicios.indexOf(serviciosVal) !== -1) || (serviciosVal==="-") ){
                    console.log("servicios");
                        if( (poblacion.indexOf(poblacionesVal) !== -1) || (poblacionesVal==="-") ){
                    console.log("poblacion");
                            return true;
                        }else{
                            return false;
                        }
                    }else{
                        return false;

                    }
                }else{
                    return false;
                }
            });
        });
    }
},


 
        /////////

        'page_template_template_buscador': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
        
            }
        },

        'page_template_template_recover_pwd': {
            init: function() {
                // JavaScript to be fired on the home page
                

            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                
                function regformhash() {

                    email = $("#email-input").val();
                    password = $("#new-password").val();
                    conf= $("#renew-password").val();

                     // Check each field has a value
                    if ( email == ''     || 
                          password == ''  || 
                          conf == '') {
                 
                        alert('You must provide all the requested details. Please try again');
                        return false;
                    }
                         
                    // Check that the password is sufficiently long (min 6 chars)
                    // The check is duplicated below, but this is included to give more
                    // specific guidance to the user
                    if (password.length < 6) {
                        alert('Passwords must be at least 6 characters long.  Please try again');
                        $("#new-password").focus();
                        return false;
                    }
                 
                    // At least one number, one lowercase and one uppercase letter 
                    // At least six characters 
                 
                    var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/; 
                    if (!re.test(password)) {
                        alert('Passwords must contain at least one number, one lowercase and one uppercase letter.  Please try again');
                        return false;
                    }
                 
                    // Check password and confirmation are the same
                    if (password != conf) {
                        alert('Your password and confirmation do not match. Please try again');
                        $("#new-password").focus();
                        return false;
                    }
                 
                    // Create a new element input, this will be our hashed password field. 
                    var p = document.createElement("input");
                 
                    // Add the new element to our form. 
                    $("#reset-form").append(p);
                    p.name = "p";
                    p.type = "hidden";
                    p.value = hex_sha512(password);
                 
                    // Make sure the plaintext password doesn't get sent. 
                    $("#new-password").val("");
                    $("#renew-password").val("");
                   
                    // Finally submit the form. 
                    $("#reset-form").submit();
                                        
                }


                $("#button-reset").click(function() {
                    
                    regformhash();

                });
               

            }

        },

        'page_template_template_login': {
            init: function() {
                // JavaScript to be fired on the home page
                 

            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                
                function formhash() {
                    
                    var p = document.createElement("input");
                 
                    $("#login-form").append(p);
                    p.name = "p";
                    p.type = "hidden";
                    p.value = hex_sha512($("#password").val());
                 
                    $("#password").val("");
                 
                    $("#login-form").submit();
                    
                }

                $("#button-login").click(function() {
                    
                    formhash();

                });
            }
        },

        'single_eventos':{
            init: function() {
            // JavaScript to be fired on the home page

            },
            finalize: function() {

            setTimeout(function(){
                $('body').addClass('loaded');
            }, 300);
          

          $windowH=$(window).height()+53;
          $headerH=$("header").height()+40;
          $("#cd-intro").css("height",$windowH+"px");

          $(".cd-content").css("marginTop",$windowH-200+"px");

          var content_evento = new Waypoint({
              element: $(".cd-content"),
              handler: function(direction) {

                if(direction==="down"){
                      console.log("direction down");
                    $("header").addClass("showed");
                }else{
                    $("header").removeClass("showed");
                }
              },
              offset: '80%'
          });





                var introSection = $('#cd-intro-background'),
                    introSectionHeight = introSection.height(),
                    //change scaleSpeed if you want to change the speed of the scale effect
                    scaleSpeed = 0.3,
                    //change opacitySpeed if you want to change the speed of opacity reduction effect
                    opacitySpeed = 1; 
                var introSectionText = $('#cd-intro-tagline');

                //update this value if you change this breakpoint in the style.css file (or _layout.scss if you use SASS)
                var MQ = 1170;

                triggerAnimation();
                $(window).on('resize', function(){
                    triggerAnimation();
                }); 

                //bind the scale event to window scroll if window width > $MQ (unbind it otherwise)
                function triggerAnimation(){
                    if($(window).width()>= MQ) {
                        $(window).on('scroll', function(){
                            //The window.requestAnimationFrame() method tells the browser that you wish to perform an animation- the browser can optimize it so animations will be smoother
                            //window.requestAnimationFrame(animateIntro);

                            if( $(window).scrollTop() < introSectionHeight) {
                                auxer2=(($(window).scrollTop()/3)).toFixed(1);
                                /*introSection.css({
                                    'background-position-y': auxer2 + 'px',
                                    //'opacity': 1 - scrollPercentage*opacitySpeed
                                });
                                introSectionText.css({
                                    '-moz-transform': 'translatetranslateY(' + auxer2*2 + 'px) translateX(-50%)  translateZ(0)',
                                    '-webkit-transform': 'translateY(' + auxer2*2 + 'px) translateX(-50%)  translateZ(0)',
                                    '-ms-transform': 'translateY(' + auxer2*2 + 'px) translateX(-50%)  translateZ(0)',
                                    '-o-transform': 'translateY(' + auxer2*2 + 'px) translateX(-50%)  translateZ(0)',
                                    'transform': 'translateY(' + auxer2*2 + 'px) translateX(-50%)  translateZ(0)',
                                    //'opacity': 1 - scrollPercentage*opacitySpeed
                                });*/

                                window.requestAnimationFrame(animateIntro);

                            }



                        });
                    } else {
                        $(window).off('scroll');
                    }
                }
                //assign a scale transformation to the introSection element and reduce its opacity
                function animateIntro () {
                    //var scrollPercentage = ($(window).scrollTop()/introSectionHeight).toFixed(5),
                    //    scaleValue = 1 - scrollPercentage*scaleSpeed;
                    //check if the introSection is still visible
                    if( $(window).scrollTop() < introSectionHeight) {
                        /*introSection.css({
                            '-moz-transform': 'scale(' + scaleValue + ') translateZ(0)',
                            '-webkit-transform': 'scale(' + scaleValue + ') translateZ(0)',
                            '-ms-transform': 'scale(' + scaleValue + ') translateZ(0)',
                            '-o-transform': 'scale(' + scaleValue + ') translateZ(0)',
                            'transform': 'scale(' + scaleValue + ') translateZ(0)',
                            'opacity': 1 - scrollPercentage*opacitySpeed
                        });*/
                    //var scrollPercentage = ($(window).scrollTop()/introSectionHeight).toFixed(2);

                        //auxer2=((1-scaleValue)*introSectionHeight*2).toFixed(2);
                      //  auxer2=2*($(window).scrollTop()/3);
                        /*introSection.css({
                            '-moz-transform': 'translateY(' + auxer2 + 'px)',
                            '-webkit-transform': 'translateY(' + auxer2 + 'px)',
                            '-ms-transform': 'translateY(' + auxer2 + 'px)',
                            '-o-transform': 'translateY(' + auxer2 + 'px)',
                            'transform': 'translateY(' + auxer2 + 'px)',
                            'opacity': 1 - scrollPercentage*opacitySpeed
                        });*/
                       // introSection.css({
                         //   'background-position-y': auxer2 + 'px',

                            //'opacity': 1 - scrollPercentage*opacitySpeed
                      //  });
                    $effect="1";
                    if($effect=="1"){
                        var scrollPercentage = ($(window).scrollTop()/introSectionHeight).toFixed(5),
                            scaleValue = 1 - scrollPercentage*scaleSpeed;
                        if( $(window).scrollTop() < introSectionHeight) {
                            introSection.css({
                                '-moz-transform': 'scale(' + scaleValue + ') translateZ(0)',
                                '-webkit-transform': 'scale(' + scaleValue + ') translateZ(0)',
                                '-ms-transform': 'scale(' + scaleValue + ') translateZ(0)',
                                '-o-transform': 'scale(' + scaleValue + ') translateZ(0)',
                                'transform': 'scale(' + scaleValue + ') translateZ(0)',
                                'opacity': 1 - scrollPercentage*opacitySpeed
                            });
                        }
                    }else{
                        var scrollPercentage = ($(window).scrollTop()/introSectionHeight).toFixed(5);
                        auxer2=-2*($(window).scrollTop()/3);
                        if( $(window).scrollTop() < introSectionHeight) {
                            introSection.css({
                                '-moz-transform': 'translateY(' + auxer2 + 'px)',
                                '-webkit-transform': 'translateY(' + auxer2 + 'px)',
                                '-ms-transform': 'translateY(' + auxer2 + 'px)',
                                '-o-transform': 'translateY(' + auxer2 + 'px)',
                                'transform': 'translateY(' + auxer2 + 'px)',
                                'opacity': 1 - scrollPercentage*opacitySpeed
                            });
                        }
                    }




                    }
                }




            }
        },

        'single_modelo':{
            init: function() {
            // JavaScript to be fired on the home page
                if ($(window).width() < 720) {
                    $(".pestanyas-single-modelo").addClass("nav-stacked");
                }
            },
            finalize: function() {
            // JavaScript to be fired on the home page, after the init JS
                $(".view-image-model").click(function() {
                    id_detail = $(this).attr("data-slide-to"); 
                    copiedModal = $("#myModal-Single-Model");
                    ////$("#myModal-Single-Model").remove();
                    ////copiedModal.appendTo("body"); 
                    $('#myModal-Single-Model .active').removeClass('active'); 
                    $('.image-item'+id_detail).parent().addClass("active"); 
                    // $(".item-image-"+id_detail).addClass("active"); 
                    var easeOpen = $("#myModal-Single-Model").attr('data-easein');
                        $('#myModal-Single-Model').velocity('transition.' + easeOpen);     
                });

                $(window).resize(function() {
                  windowsize = $(window).width();
                  if (windowsize < 720) {
                    $(".pestanyas-single-modelo").addClass("nav-stacked");
                  }else{
                    $(".pestanyas-single-modelo").removeClass("nav-stacked");
                  }
                });
            }
        },

        'page_template_template_details_offer2':{
            init: function() {
                $('.current-slide-number').html('1');
            },
            finalize: function() {


                $("body").on("click",".tab-header-item:not(.active)",function(){
                    $(".tab-header-item").removeClass("active");
                    $(this).addClass("active");
                    var tab = $(this).attr("data-tab");
                    if(tab=="precio"){
                        $(".dItemCuotasTab").addClass("hide").removeClass("showFlex");
                        $(".dItemPrecioTab").addClass("showFlex").removeClass("hide");
                    }else{
                        $(".dItemCuotasTab").addClass("showFlex").removeClass("hide");
                        $(".dItemPrecioTab").addClass("hide").removeClass("showFlex");
                    }
                });
                    
                var infoCuotas = null;
                getFinanciacionBBVA();

                function metaCount2(id, type, pon) {


                    pon = pon == undefined ? '' : '&pon=' + pon;
                    
                    if(id && type) {

                        $.ajax({
                            url: mediagach_vars.rootFolder + '/wp-content/themes/mediagach/utils/modules/count-fields.php/?idOffer=' + id + '&type=' + type + pon,
                        }); 

                    }
                }
                setTimeout(function(){ metaCount2($(".adw-content").attr("data-id-item"), 'numVisites') }, 20000);

 
            $(".showMoreEquip,.tab-equipment-item").on("click",function(){
                
                $(".showMoreEquip").remove();
                setTimeout(function(){ 
                    $(".hideEquip").removeClass("hideEquip");
                }, 800);

                
            });

             /*RESERVALO*/
             $(".selectorBank .bank-picker").on("click",function(){
                 $(this).parent().parent().find(".selected").removeClass("selected");
                 $(this).addClass("selected");
                 var bank = $(this).attr("data-bank");
                 $(".bankData .bank.active").removeClass("active");
                 $(".bankData .bank-"+bank).addClass("active");
             });

             $("#slider-range-entrada").slider({   
                    value: 0,                 
                    min: 0,
                    max: parseInt($('#range-entrada').attr('data-max')),
                    step: 250,
                    slide: function(event, ui) {
                        $( "#amount-entrada" ).val( formatearNumero(ui.value) + ' €' );  
                        $( "#amount-entrada" ).attr('data-entrada', ui.value );
                        $( "#entrada-result" ).val( formatearNumero(ui.value) + ' €' );  
                        
                        $( "#import-financiar" ).val( formatearNumero((parseInt($( "#import-financiar" ).attr('data-price'))-parseInt(ui.value))) + ' €'  );
                                            
                    },
                    stop: function(event, ui) {
                        getFinanciacionBBVA();                      

                    }
                });    

                $("#slider-range-meses").slider({   
                    value: 6,                 
                    min: 6,
                    max: 120,
                    step: 6,
                    slide: function(event, ui) {
                        $( "#amount-meses" ).val( ui.value+ ' meses' ); 
                        $( "#num-plazos-result" ).val( ui.value );

                        $( "#amount-meses" ).attr('data-meses', ui.value);
                        $('#importe-cuota').val( formatearNumero(infoCuotas[ui.value]['cuota'])+" €/mes" );      
                        setTextFinanciacionBBVA();                  
                    },
                    stop: function(event, ui) {
                                              

                    }
                });    

                function formatearNumero(nStr) {
                    nStr += '';
                    x = nStr.split('.');
                    x1 = x[0];
                    x2 = x.length > 1 ? ',' + x[1] : '';
                    var rgx = /(\d+)(\d{3})/;
                    while (rgx.test(x1)) {
                            x1 = x1.replace(rgx, '$1' + '.' + '$2');
                    }
                    return x1 + x2;
                }

                function setTextFinanciacionBBVA(){
                    $('.legal-meses').text($( "#amount-meses" ).attr('data-meses'));
                    $('.legal-cuota').text(formatearNumero(infoCuotas[$( "#amount-meses" ).attr('data-meses')]['cuota']));
                    $('.legal-tin').text( formatearNumero(infoCuotas[$( "#amount-meses" ).attr('data-meses')]['tin']) );
                    $('.legal-tae').text( formatearNumero(infoCuotas[$( "#amount-meses" ).attr('data-meses')]['tae']) );
                    $('.legal-capertura').text( formatearNumero(infoCuotas['capertura']) );                                       
                    $('.legal-caperturaTotal').text( formatearNumero(infoCuotas[$( "#amount-meses" ).attr('data-meses')]['caperturaTotal']) );
                    $('.legal-financiar').text( formatearNumero(parseInt($('#import-financiar').attr('data-price'))-parseInt($('#amount-entrada').attr('data-entrada'))) );
                    $('.legal-final').text( formatearNumero(parseInt(infoCuotas[$( "#amount-meses" ).attr('data-meses')]['cuota'])*parseInt($( "#amount-meses" ).attr('data-meses'))) );
                    $('#apertura-result').val(formatearNumero(infoCuotas[$( "#amount-meses" ).attr('data-meses')]['caperturaTotal'])+' €');
                    $('#tin-result').val(formatearNumero(infoCuotas[$( "#amount-meses" ).attr('data-meses')]['tin'])+' %');
                    $('#tae-result').val(formatearNumero(infoCuotas[$( "#amount-meses" ).attr('data-meses')]['tae'])+' %');

                }

                function getFinanciacionBBVA(){

                    var entradaBBVA = parseInt($('#amount-entrada').attr('data-entrada'))*100;
                    var importBBVA = parseInt($('#import-financiar').attr('data-price'))*100;
                    
                    if(isNaN(entradaBBVA)){
                        
                    }else{
                        
                        $.ajax({
                            url: mediagach_vars.rootFolder + '/wp-content/themes/mediagach/utils/modules/calculaBBVAFinanciacion.php',
                            type: "POST",
                            dataType: 'json',
                            data: { "entrada" : entradaBBVA, "importe":importBBVA},
                            success: function(data) {
                                //console.log('rebem de bbva');
                                //console.log(data);
                                //console.log('import::'+importBBVA);
                                //console.log('entrada::'+entradaBBVA);
                                infoCuotas = data['infocuotasimporte']['cuotasmes'];
                                infoCuotas['capertura'] = data['infocuotasimporte']['infogeneral']['capertura'];
                                //console.log($( "#amount-meses" ).attr('data-meses'));
                                //console.log(infoCuotas['6']['cuota']);
                                
                                $('#importe-cuota').val( formatearNumero(infoCuotas[$( "#amount-meses" ).attr('data-meses')]['cuota']) +" €/mes*" );
                                
                                setTextFinanciacionBBVA();
                                
                                //console.log(data);

                            },
                            error: function(xhr, status, error) {
                                //Ajax problem
                                console.log("101 error"+xhr+"--------"+status+"------"+error);
                                console.log(xhr);
                                console.log(xhr.responseText);
                                
                            }
                        });
                    }

                    


                }
             
            var sync1 = $("#carouselBig");
            var sync2 = $("#carouselSmall");
            var slidesPerPage = 8; //globaly define number of elements per page
            var syncedSecondary = true;

            // Telf print
            var telf = '<span>' + $(".detail-form-call a").text() + '</span>';  
            $(".printable-telf").append(telf);

            sync1
                .on('initialized.owl.carousel', function (el) {
                    // console.log("aaaa");
                    $(".carouselCounter .numCounter").html("1");
                    var count = el.item.count-1;
                    $(".carouselCounter .numTotal").html(count+1);

                })
                .owlCarousel({
                    items : 1,
                    slideSpeed : 2000,
                    nav: false, // Desactiva la navegación interna
                    autoplay: false,
                    dots: false,
                    loop: true,
                    lazyLoad:true,
                    responsiveRefreshRate : 200,
                    animateOut: 'fadeOut'
                    // navText eliminado
                }).on('changed.owl.carousel', syncPosition);


                $('#customPrevBtn').click(function() {
                    sync1.trigger('prev.owl.carousel');
                });
                $('#customNextBtn').click(function() {
                    sync1.trigger('next.owl.carousel');
                });

            sync2
                .on('initialized.owl.carousel', function () {
                sync2.find(".owl-item").eq(0).addClass("current");
                })
                .owlCarousel({
                items : slidesPerPage,
                responsiveClass:true,
                responsive:{
                    0:{
                        items:4,
                    },
                    500:{
                        items:5,
                    },
                    800:{
                        items:8,
                    }
                },



                dots: false,
                nav: false,
                smartSpeed: 200,
                lazyLoad:true,
                margin:8,
                slideSpeed : 500,
                slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
                responsiveRefreshRate : 100
            }).on('changed.owl.carousel', syncPosition2);


                function syncPosition(el) {

                var count = el.item.count-1;
                var current = Math.round(el.item.index - (el.item.count/2) - .5);
                if(current < 0) {
                current = count;
                }
                if(current > count) {
                current = 0;
                }
                $(".carouselCounter .numCounter").html(current+1);
                $(".carouselCounter .numTotal").html(count+1);



                sync2
                .find(".owl-item")
                .removeClass("current")
                .eq(current)
                .addClass("current");
                var onscreen = sync2.find('.owl-item.active').length - 1;
                var start = sync2.find('.owl-item.active').first().index();
                var end = sync2.find('.owl-item.active').last().index();
            

                if (current > end) {
                sync2.data('owl.carousel').to(current, 100, true);
                }else if (current < start) {
                sync2.data('owl.carousel').to(current - onscreen, 100, true);
                }




            }
    

            function syncPosition2(el) {
                /*if(syncedSecondary) {
                var number = el.item.index;
                sync1.data('owl.carousel').to(number, 100, true);
                }*/
            }
            
            sync2.on("click", ".owl-item", function(e){
                e.preventDefault();
                var number = $(this).index();
                sync1.data('owl.carousel').to(number, 300, true);
            });

            $(".zoomGalleryPhotos").on("click", function(e){
                $(".carouselBlock").appendTo("#modalCarousel3");
                setTimeout(function(){
                    window.dispatchEvent(new Event('resize'));
                    $("#modalGalleryPhotos .modal-body").css("opacity",1);
                }, 200);
            });
            $("#modalGalleryPhotos .close").on("click", function(e){
                $("#modalGalleryPhotos .modal-body").css("opacity",0);
                $(".carouselBlock").appendTo("#photosCarousel");
                window.dispatchEvent(new Event('resize'));
            });



                $("body").on("click",".btnOpenPopUp",function(){

                    copiedModal = $("#modal-pideOferta");
                    /////$("#modal-pideOferta").remove();
                    /////copiedModal.appendTo("body");
                    $("#modal-pideOferta").modal();
                    //fillTextarea($(this));
                    //fillHiddenField($(this));
                    texto = "Hola,\n\nMe gustaría recibir más información de:\n";
                    texto = texto + "\t·" + $('.detail-model').text() + " - "+ $(".detail-final-price").text() +"\n";
                    texto = texto + "\n¡Gracias!";

                    $(".modal-offer-related textarea").not($('.key_info textarea, .hidden_data_usr textarea')).html(texto);

                    var textoHidden = $(".detail-model").attr("data-hidden");
                    $(".modal-offer-related .textarea-privado textarea").html(textoHidden);
                    $(".textarea-interested").addClass("hidden");
                    $(".addMessage p").removeClass("hidden");

                });

                /*$("body").on("click",".btnOpenPopUp",function(){
                
                    texto = "Hola,\n\nMe gustaría recibir más información de:\n";
                    texto = texto + "\t·" + $('.detail-model').text() + " - "+ $(".detail-final-price").text() +"\n";
                    
                    texto = texto + "\n¡Gracias!";

                    $(".modal-offer-related textarea").not($('.key_info textarea, .hidden_data_usr textarea')).html(texto);

                    textoHidden = $(".detail-model").attr("data-hidden");

                $(".modal-offer-related .textarea-privado textarea").not($('.key_info textarea, .hidden_data_usr textarea')).html(textoHidden);

                    
                });*/

                $("body").on("click", '.openPopup', function(){                
                    mgUtils.trackMetaDataStorage('utils', 'idOferta', '', '', $('.adw-content').attr('data-id-item'));
                        
                });

                $('#detailCarouselImages').on('slid.bs.carousel', function() {  
                    currentIndex = $('#detailCarouselImages div.active').index() + 1;
                    $('.current-slide-number').html(''+currentIndex+'');

                });

                /*var waypointBlockForm = new Waypoint({
                element: $(".offer-detail-container-form"),
                handler: function(direction) {
                    if(direction === "down"){
                        $(".offer-detail-container-form").addClass("stuck");
                    }else{
                        $(".offer-detail-container-form").removeClass("stuck");

                    }
                },
                offset: 59 
                });*/


                function fillTextarea(t) {
                        
                    $(".modal-offer-related textarea").not($('.hidden_data_usr textarea')).html($(".detail-form-container textarea").html());
                }

                function fillHiddenField(t) {
                
                    $(".modal-offer-related .textarea-privado textarea").html($(".detail-form-container .textarea-privado textarea").html());
                }


                texto = "Hola,\n\nMe gustaría recibir más información de:\n";
                texto = texto + "\t·" + $('.detail-model').text() + " - "+ $(".detail-final-price").text() +"\n";
                if ($(".vip-price-container").length > 0){
                    texto = texto + "Con promoción: " + $(".vip-price-container").text()+"\n";     
                }
                texto = texto + "\n¡Gracias!";

                $(".detail-form-container textarea").not($('.hidden_data_usr textarea')).html(texto);

                textoHidden = $(".detail-model").attr("data-hidden");
                $(".detail-form-container .textarea-privado textarea").not($('.hidden_data_usr textarea')).html(textoHidden);

                
                $(document).ready(function() {
                        
                    $(".gform_button").on("click",function(){
                        ga('send', 'event', 'Enviar', $(this).attr("data-info"), '');
                    });            

                    $(".btn-ver-fotos").on("click", function(){
                            indexItem = $('#detailCarouselImages .item.active').index();
                            var id = parseInt(indexItem);
                            heightMax = $( window ).height()*0.8;
                            //$('#modalGalleryPhotos .item img').height(heightMax);

                            $('#modalGalleryPhotos .item img').css('max-height', heightMax+'px');
                            $('#modalGalleryPhotos').modal('show');
                            $('#modalCarousel').carousel(id);                        
                    });     

                        $("body").on("click",".addMessage",function(){
                            $(".textarea-interested").toggleClass("hidden");
                            $(".addMessage p").toggleClass("hidden");
                        });
                                    
                });    

                
                $('#detailCarouselImages .item').on('load', function() {
                
                    }).each(function(i) {
                        urlImatge = $(this).attr("data-photo"); 
                        
                        var item = $('<div class="item"><img class="img img-responsive" src="'+urlImatge+'" ></img></div>'); 
                        //var item = $('<div class="item" style=" background-image: url('+urlImatge+');"></div>');
                        item.appendTo('#modalGalleryPhotos .carousel-inner'); 
                        if (i==0){ // set first item active
                        item.addClass('active');
                        }
                    
                    });          
                    

                    $(window).on('resize', function() {   
                        heightMax = $( window ).height()*0.8;
                        //$('#modalGalleryPhotos .item img').height(heightMax);
                    
                        $('#modalGalleryPhotos .item img').css('max-height', heightMax+'px');
                    });
                    

                    $("#modalGalleryPhotos .carousel-inner").on("click", function(){
                        $('#modalGalleryPhotos').modal('toggle');
                    });

                /*var waypoint = new Waypoint({
                    element: $(".offer-detail-container-info"),
                    handler: function() {                
                        $(".offer-detail-container-form").toggleClass('fixedForm');
                    },
                    offset: '5%'
                });

                var waypoint2 = new Waypoint({
                    element: $(".offer-detail-title"),
                    handler: function() {                
                        $(".container-nav-information").toggleClass('unHide');
                    },
                    offset: '0%'
                });
                */
                
            }

        },

        'page_template_template_details_offer':{
           init: function() {
           },
           finalize: function() {


            


            $("body").on("click",".btn-open-form-detail",function(){
                  copiedModal = $("#modal-pideOferta");
                  ////$("#modal-pideOferta").remove();
                  ////copiedModal.appendTo("body");
                  $("#modal-pideOferta").modal();
                  fillTextarea($(this));
                  fillHiddenField($(this));
            });

                var waypoint = new Waypoint({
                  element: $(".detail-legal-note"),
                  handler: function() {                
                    $(".container-button-open-form").toggleClass('hide');
                  },
                  offset: '90%'
                });

                function fillTextarea(t) {
                    
                    $(".modal-offer-related textarea").html($(".detail-form-container textarea").html());
                }

                function fillHiddenField(t) {
                   
                    $(".modal-offer-related .textarea-privado textarea").html($(".detail-form-container .textarea-privado textarea").html());
                }


               texto = "Hola,\n\nMe gustaría recibir más información de:\n";
               texto = texto + "\t·" + $('.detail-model').text() + " - "+ $(".detail-final-price").text() +"\n";
               if ($(".vip-price-container").length > 0){
                   texto = texto + "Con promoción: " + $(".vip-price-container").text()+"\n";     
               }
               texto = texto + "\n¡Gracias!";

               $(".detail-form-container textarea").html(texto);

               textoHidden = $(".detail-model").attr("data-hidden");
               $(".detail-form-container .textarea-privado textarea").html(textoHidden);

               
               $(document).ready(function() {
                    
                   $(".gform_button").on("click",function(){
                       ga('send', 'event', 'Enviar', $(this).attr("data-info"), '');
                   });

                  /* $('.detail-button-info').click(function() {                        
                       $('html,body').animate({
                           scrollTop: eval($('#' + $(this).attr('target')).offset().top - 110)
                       }, 1000);                        
                   });*/

                   /*
                   posicioCarrusel= $('.carrusel_ofertas').position().top;                    
                   posicioTope = $('.carrusel_ofertas').position().top - $('.detail-form-container').height()-220;
                   */

                   /*$(window).scroll(function() {

                      var height = $(window).scrollTop();
                       if((height  < 1200)||(height  > 2000)) {
                         $('.detail-button-info').css("display", "inline-block");
                       }else{
                         $('.detail-button-info').css("display", "none");
                       }                        
                       
                   }); */ 
                     
                                 
               });                
           }
        },
        'page_template_template_corporate': {
                init: function() {
                    $(".main-postventas-corporate").hide();
            
                },
                finalize: function() {
                
                $(".ventas-button").click(function() {
                        $(".ventas-button").addClass("selected");
                        $(".postventas-button").removeClass("selected");
                        $(".main-postventas-corporate").hide();
                    $(".main-ventas-corporate").velocity("transition.expandIn");
                    });

                $(".postventas-button").click(function() {
                        $(".ventas-button").removeClass("selected");
                        $(".postventas-button").addClass("selected");
                        $(".main-ventas-corporate").hide();
                        $(".main-postventas-corporate").velocity("transition.expandIn");
                    //$(".main-ventas-corporate").hide();
                    });


                }
        },

        'page_template_template_comparador': {
            init: function() {




            },
            finalize: function() {

 
                $(".mgComparadorTable").clone(true).appendTo('#table-scroll').addClass('clone');   


                    $("body").on("click",".removeComparadorItem",function(){
                        var t = $(this);
                        var id = t.attr("data-id");
                        mgUtils.pullLocalStorage("comparador",id);
                        var items = localStorage.getItem("comparador");
                        items = JSON.parse(items).join("-");
                        window.open(t.attr('data-href')+"comparador/?vehiculos="+items,"_self");
                    });
                    $("body").on("click",".gotoLink",function(){
                        var tdWidth = $("tr.fotoCar td")[0].offsetWidth;
                        console.log(tdWidth);
                        if($(this).hasClass("gotoRight")){
                            $(".table-scroll").velocity("scroll", { axis: "x", container: $(".table-wrap"),  offset: tdWidth+"px" });
                        }else{
                            $(".table-scroll").velocity("scroll", { axis: "x", container: $(".table-wrap"),  offset: "-"+tdWidth+"px" });                            
                        }
                    });

                    $("body").on("click",".mgComparadorSend",function(){
                        $("#modal-comparteFavoritos").modal();
                    });

                    $("body").on("click",".solicitaMasInfo",function(){
                        $("#idFormOfertaDetalle").modal();
                        var texto = "Hola!\nQuiero recibir más información de:\n";
                        texto += $(this).attr("data-info");
                        texto += "\n\n¡Gracias!";
                        $("#idFormOfertaDetalle textarea").html(texto);
                    });



 

            }
        },

        'page_template_template_landing1': {
            init: function() {
                // JavaScript to be fired on the home page
 /*$.getScript("https://cdn.jsdelivr.net/jquery.typeit/4.3.0/typeit.min.js", function(){

 });*/



            },
            finalize: function() {

 


                // JavaScript to be fired on the home page, after the init JS
                    function landingCSSRecalculate(){
                        logosHeight=$('body .logos').outerHeight(true);
                        affixTopWidth=$(".sidebarAffix").outerWidth(true);
                        $(".affixTopWrapper").css("min-height",logosHeight+50);
                        $(".sidebarAffix").css("width",affixTopWidth+"px");
                        $(".sidebarHeader h1").css("height",logosHeight+"px");
                    }


                    //$(".sidebarAffix").css("top",logosHeight);

                $( window ).resize(function() {
                  landingCSSRecalculate();
                });

                $(document).ready(function() {
 
                    setTimeout(function(){
                        $('body').addClass('loaded');
                    }, 1000);


                    });

                 $(window).load(function() {
                    affixSidebarTop=$('.sidebarAffix').offset().top;
                    affixTopWidth=$(".sidebarAffix").outerWidth(true);
                    affixLogosTop=$('.logos').offset().top;
                    logosHeight=$('body .logos').outerHeight(true);
                    affixSidebarHeight=$('.sidebarAffix').outerHeight(true);
                    $(".affixTopWrapper").css("min-height",logosHeight+50);


                    footerHeight=$('body footer').outerHeight(true);
                    $('.sidebarAffix').affix({
                        offset: {     
                          //top:affixSidebarTop-logosHeight+50,
                          top:affixSidebarTop,
                          bottom: footerHeight
                        }
                    });
                    $(".sidebarAffix").css("width",affixTopWidth+"px");
                    $(".sidebarHeader h1").css("height",logosHeight+"px");
 
                    $('.logos').affix({
                        offset: {     
                          top:affixLogosTop,
                          bottom: footerHeight+affixSidebarHeight
                        }
                    });

                    $(".lazyImage").each(function(index) {
                        aux=$(this).attr("data-original");
                        $(this).attr("src",aux); 
                    });


                    $(".masOfertas button").one("click", function(){  
                        ga('send', 'event', 'Campaña', 'Quiere ver más Ofertas', '');
                        $(".hiddenPromo").each(function(index) {
                            $(this).removeClass("hiddenPromo");
                        });
                        $(this).parent().addClass("hiddenPromo");
                    });

                    var landingModels=["Unidades Clase A","Unidades Clase B","Unidades Clase C","Unidades Clase CLA","Unidades GLA","Unidades Smart"];
                    var landingNum=["104","107","111","101","105","107"];
                    counterInterval=0;

                    $( ".odometer" ).each(function( index ) {   
                        var o = new Odometer({
                            el: this,
                            format: '(,ddd)', // Change how digit groups are formatted, and how many digits are shown after the decimal point
                            duration: 250, 
                        });
                        o.render();
                        $(".nombreModelo").html(landingModels[0]);
                        o.update(landingNum[0]);
                        var counterInterval=1;
                        setInterval(function(){ 
                            $(".nombreModelo").animateCss("zoomOut");
                                $(".nombreModelo").html(landingModels[counterInterval]);
                                $(".nombreModelo").removeClass("animated zoomOut");
                                $(".nombreModelo").animateCss("zoomIn");
                                o.update(landingNum[counterInterval]);
                                counterInterval++; 
                                if(counterInterval===6){
                                    counterInterval=0;
                                }
                        }, 4000);
                    });
                    /*tOdometer=$(".odometer");
                    var o = new Odometer({
                            el: tOdometer,
                            value: 30,
                            format: '(,ddd)', // Change how digit groups are formatted, and how many digits are shown after the decimal point
                            duration: 10000, 
                    });
                    o.render();*/



                  /*  $('#typeUnits').typeIt({
                         speed: 25,
                         autoStart: false,
                         loop:true,

                    }).tiType('Clase A: <strong>10</strong> unidades')
                        .tiPause(500)
                        .tiDelete()
                        .tiType('Clase CLA: <strong>3</strong> unidades')
                        .tiPause(1000)
                        .tiDelete();
                    */


 
                });
 


                function getTimeRemaining(endtime) {
                  var t = Date.parse(endtime) - Date.parse(new Date());
                  var seconds = Math.floor((t / 1000) % 60);
                  var minutes = Math.floor((t / 1000 / 60) % 60);
                  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
                  var days = Math.floor(t / (1000 * 60 * 60 * 24));
                  return {
                    'total': t,
                    'days': days,
                    'hours': hours,
                    'minutes': minutes,
                    'seconds': seconds
                  };
                }

                function initializeClock(id, endtime) {
                  var clock = document.getElementById(id);
                  var daysSpan = clock.querySelector('.days');
                  var hoursSpan = clock.querySelector('.hours');
                  var minutesSpan = clock.querySelector('.minutes');
                  var secondsSpan = clock.querySelector('.seconds');
                  function updateClock() {
                    var t = getTimeRemaining(endtime);
                    daysSpan.innerHTML = t.days;
                    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
                    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
                    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
                    if (t.total <= 0) {
                      clearInterval(timeinterval);
                    }
                  }
                  updateClock();
                  var timeinterval = setInterval(updateClock, 1000);
                }
                //var deadline = new Date(Date.parse(new Date()) + 1 * 24 * 60 * 60 * 1000);
                var deadline = '2017-05-21';
                var contador = document.getElementById('clockdiv');
                if (contador !== null){
                    initializeClock('clockdiv', deadline);
                }



            }
        },

        'page_template_template_landing_generica': {
            init: function() {
                // JavaScript to be fired on the home page
 /*$.getScript("https://cdn.jsdelivr.net/jquery.typeit/4.3.0/typeit.min.js", function(){

 });*/


            },
            finalize: function() {


                $("body").on("click",".btn-open-form-detail",function(){
                    copiedModal = $("#modal-evento2");
                    ////$("#modal-evento2").remove();
                    ////copiedModal.appendTo("body");
                    $("#modal-evento2").modal();
                    fillTextarea($(this));
                    fillHiddenField($(this));
                    
                });

                $("body").on("click",".btn-behinf-form-landing",function(){
                    ga('send', 'event', 'Promocion', 'Llamada', $(".btn-behinf-form-landing").attr("data-promo"));                    
                    $(".btn-behinf-form-landing").html($(".btn-behinf-form-landing").attr("data-phone"));

                });

                $(".same-height").sameheight();

                


               /* var waypoint = new Waypoint({
                  element: $(".promocionForm"),
                  handler: function() {                
                    $(".container-button-open-form-langing").toggleClass('hide');
                  },
                  offset: '90%'
                });*/




                function fillTextarea(t) {
                                    
                    $(".modal-offer-related textarea").html($(".detail-form-container textarea").html());
                }

                function fillHiddenField(t) {                                   
                    $(".modal-evento .detalles-promocion input").val($(t).attr("data-detalles"));
                    //$("#input_38_17").val('CLA');

                }



                // JavaScript to be fired on the home page, after the init JS
                    function landingCSSRecalculate(){
                        logosHeight=$('body .logos').outerHeight(true);
                        affixTopWidth=$(".sidebarAffix").outerWidth(true);
                        $(".affixTopWrapper").css("min-height",logosHeight+50);
                        $(".sidebarAffix").css("width",affixTopWidth+"px");
                        $(".sidebarHeader h1").css("height",logosHeight+"px");
                    }


                    //$(".sidebarAffix").css("top",logosHeight);

                $( window ).resize(function() {
                  landingCSSRecalculate();
                });

 
                    setTimeout(function(){
                        $('body').addClass('loaded');
                    }, 700);
                    
                    $(".gform_button").on("click",function(){
                       ga('send', 'event', 'Enviar', $(this).attr("data-info"), '');
                    });


                 $(window).load(function() {
                    affixSidebarTop=$('.sidebarAffix').offset().top;
                    affixTopWidth=$(".sidebarAffix").outerWidth(true);
                    affixLogosTop=$('.logos').offset().top;
                    logosHeight=$('body .logos').outerHeight(true);
                    affixSidebarHeight=$('.sidebarAffix').outerHeight(true);
                    $(".affixTopWrapper").css("min-height",logosHeight+50);


                    footerHeight=$('body footer').outerHeight(true);
                    $('.sidebarAffix').affix({
                        offset: {     
                          top:affixSidebarTop,
                          bottom: footerHeight
                        }
                    });
                    $(".sidebarAffix").css("width",affixTopWidth+"px");
                    $(".sidebarHeader h1").css("height",logosHeight+"px");
 
                    $('.logos').affix({
                        offset: {     
                          top:affixLogosTop,
                          bottom: footerHeight+affixSidebarHeight
                        }
                    });

                    $(".lazyImage").each(function(index) {
                        aux=$(this).attr("data-original");
                        $(this).attr("src",aux); 
                    });


                    $(".masOfertas button").one("click", function(){  
                        ga('send', 'event', 'Campaña', 'Quiere ver más Ofertas', '');
                        $(".hiddenPromo").each(function(index) {
                            $(this).removeClass("hiddenPromo");
                        });
                        $(this).parent().addClass("hiddenPromo");
                    });




 
                });
 


                function getTimeRemaining(endtime) {
                  var t = Date.parse(endtime) - Date.parse(new Date());
                  var seconds = Math.floor((t / 1000) % 60);
                  var minutes = Math.floor((t / 1000 / 60) % 60);
                  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
                  var days = Math.floor(t / (1000 * 60 * 60 * 24));
                  return {
                    'total': t,
                    'days': days,
                    'hours': hours,
                    'minutes': minutes,
                    'seconds': seconds
                  };
                }

                function initializeClock(id, endtime) {
                  var clock = document.getElementById(id);
                  var daysSpan = clock.querySelector('.days');
                  var hoursSpan = clock.querySelector('.hours');
                  var minutesSpan = clock.querySelector('.minutes');
                  var secondsSpan = clock.querySelector('.seconds');
                  function updateClock() {
                    var t = getTimeRemaining(endtime);
                    daysSpan.innerHTML = t.days;
                    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
                    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
                    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
                    if (t.total <= 0) {
                      clearInterval(timeinterval);
                    }
                  }
                  updateClock();
                  var timeinterval = setInterval(updateClock, 1000);
                }
                //var deadline = new Date(Date.parse(new Date()) + 1 * 24 * 60 * 60 * 1000);
                var deadline = '2017-05-21';
                var contador = document.getElementById('clockdiv');
                if (contador !== null){
                    initializeClock('clockdiv', deadline);
                }



            }
        },

        'page_template_template_landing_formulari': {
            init: function() {



            },
            finalize: function() {

 


                $(document).ready(function() {
 
                    setTimeout(function(){
                        $('body').addClass('loaded');
                    }, 1000);


                });

 




            }
        },

        'page_template_template_landing_formulari2': {
            init: function() {



            },
            finalize: function() {

 


                $(document).ready(function() {
 
                    setTimeout(function(){
                        $('body').addClass('loaded');
                    }, 1000);


                });

 




            }
        },

        'page_template_template_landing2': {
            init: function() {
                // JavaScript to be fired on the home page
 

            },
            finalize: function() {

                $("body").on("click",".btn-open-form-detail",function(){
                    copiedModal = $("#modal-evento2");
                    ////$("#modal-evento2").remove();
                    ////copiedModal.appendTo("body");
                    $("#modal-evento2").modal();
                    fillTextarea($(this));
                    fillHiddenField($(this));
                });

                var waypoint = new Waypoint({
                  element: $(".promocionForm"),
                  handler: function() {                
                    $(".container-button-form").toggleClass('hide');
                  },
                  offset: '90%'
                });

                function fillTextarea(t) {
                    
                    $(".modal-offer-related textarea").html($(".detail-form-container textarea").html());
                }

                function fillHiddenField(t) {
                   
                    $(".modal-offer-related .textarea-privado textarea").html($(".detail-form-container .textarea-privado textarea").html());
                }


                // JavaScript to be fired on the home page, after the init JS
                    function landingCSSRecalculate(){
                        logosHeight=$('body .logos').outerHeight(true);
                        affixTopWidth=$(".sidebarAffix").outerWidth(true);
                        $(".affixTopWrapper").css("min-height",logosHeight+50);
                        $(".sidebarAffix").css("width",affixTopWidth+"px");
                        $(".sidebarHeader h1").css("height",logosHeight+"px");
                    }


                    //$(".sidebarAffix").css("top",logosHeight);

                $( window ).resize(function() {
                  //landingCSSRecalculate();
                });

                $(document).ready(function() {
 
                    setTimeout(function(){
                        $('body').addClass('loaded');
                    }, 1000);

                    $(".gform_button").on("click",function(){
                       ga('send', 'event', 'Enviar', $(this).attr("data-info"), '');
                    });

                    });

                 $(window).load(function() {
                   /* affixSidebarTop=$('.sidebarAffix').offset().top;
                    affixTopWidth=$(".sidebarAffix").outerWidth(true);
                    affixLogosTop=$('.logos').offset().top;
                    logosHeight=$('body .logos').outerHeight(true);
                    affixSidebarHeight=$('.sidebarAffix').outerHeight(true);
                    $(".affixTopWrapper").css("min-height",logosHeight+50);
                    */

                    footerHeight=$('body footer').outerHeight(true);
                    /*$('.sidebarAffix').affix({
                        offset: {     
                          top:affixSidebarTop,
                          bottom: footerHeight
                        }
                    });
                    $(".sidebarAffix").css("width",affixTopWidth+"px");
                    $(".sidebarHeader h1").css("height",logosHeight+"px");
 
                    $('.logos').affix({
                        offset: {     
                          top:affixLogosTop,
                          bottom: footerHeight+affixSidebarHeight
                        }
                    });
                    */
                    $(".lazyImage").each(function(index) {
                        aux=$(this).attr("data-original");
                        $(this).attr("src",aux); 
                    });


                    $(".masOfertas button").one("click", function(){  
                        ga('send', 'event', 'Campaña', 'Quiere ver más Ofertas', '');
                        $(".hiddenPromo").each(function(index) {
                            $(this).removeClass("hiddenPromo");
                        });
                        $(this).parent().addClass("hiddenPromo");
                    });

                    var landingModels=["Unidades Clase A","Unidades Clase B","Unidades Clase C","Unidades Clase CLA","Unidades GLA","Unidades Smart"];
                    var landingNum=["104","107","111","101","105","107"];
                    counterInterval=0;

                    $( ".odometer" ).each(function( index ) {   
                        var o = new Odometer({
                            el: this,
                            format: '(,ddd)', // Change how digit groups are formatted, and how many digits are shown after the decimal point
                            duration: 250, 
                        });
                        o.render();
                        $(".nombreModelo").html(landingModels[0]);
                        o.update(landingNum[0]);
                        var counterInterval=1;
                        setInterval(function(){ 
                            $(".nombreModelo").animateCss("zoomOut");
                                $(".nombreModelo").html(landingModels[counterInterval]);
                                $(".nombreModelo").removeClass("animated zoomOut");
                                $(".nombreModelo").animateCss("zoomIn");
                                o.update(landingNum[counterInterval]);
                                counterInterval++; 
                                if(counterInterval===6){
                                    counterInterval=0;
                                }
                        }, 4000);
                    });
                     
                });
 


                function getTimeRemaining(endtime) {
                  var t = Date.parse(endtime) - Date.parse(new Date());
                  var seconds = Math.floor((t / 1000) % 60);
                  var minutes = Math.floor((t / 1000 / 60) % 60);
                  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
                  var days = Math.floor(t / (1000 * 60 * 60 * 24));
                  return {
                    'total': t,
                    'days': days,
                    'hours': hours,
                    'minutes': minutes,
                    'seconds': seconds
                  };
                }

                function initializeClock(id, endtime) {
                  var clock = document.getElementById(id);
                  var daysSpan = clock.querySelector('.days');
                  var hoursSpan = clock.querySelector('.hours');
                  var minutesSpan = clock.querySelector('.minutes');
                  var secondsSpan = clock.querySelector('.seconds');
                  function updateClock() {
                    var t = getTimeRemaining(endtime);
                    daysSpan.innerHTML = t.days;
                    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
                    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
                    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
                    if (t.total <= 0) {
                      clearInterval(timeinterval);
                    }
                  }
                  updateClock();
                  var timeinterval = setInterval(updateClock, 1000);
                }
                //var deadline = new Date(Date.parse(new Date()) + 1 * 24 * 60 * 60 * 1000);
                var deadline = '2017-05-21';
                var contador = document.getElementById('clockdiv');
                if (contador !== null){
                    initializeClock('clockdiv', deadline);
                }



            }
        },

        'page_template_template_landings_francia_v1': {
            init: function() {
                // JavaScript to be fired on the home page
 

            },
            finalize: function() {

                jQuery(document).ready(function($) {
    // Floating CTA Bar
    var floatingCTA = $('.floating-cta-bar');
    var scrollThreshold = 600; // Aparece después de 300px de scroll
    
    // Show/hide floating CTA based on scroll
    $(window).scroll(function() {
        var scrollPosition = $(window).scrollTop();
        
        if (scrollPosition > scrollThreshold) {
            floatingCTA.addClass('visible');
        } else {
            floatingCTA.removeClass('visible');
        }
    });  

    // Offer items hover effects
    $('.offer-item').hover(
        function() {
            $(this).addClass('hover');
        },
        function() {
            $(this).removeClass('hover');
        }
    );
});  

            }
        },
        'page_template_template_modelos_2025': {
            init: function() {
                // JavaScript to be fired on the home page
 

            },
            finalize: function() {

                var numItemsPerRow = window.innerWidth < 1200 ? 8 : 12;
var filters = {
    brand: "",
    brand2: "",
    cambios: "",
    carroceria: "",
    category: "",
    distintivos: "",
    maxKilometer: "",
    maxP: 1000000,
    maxYear: "",
    minKilometer: "",
    minP: 1000,
    minYear: "",
    model: $(".model-offers-filter").data("model"),
    motor: "",
    sortBy: "",
    type: ""
};

xhr = $.ajax({
    url: mediagach_vars.rootFolder + 'mediagach/scripts/listOffers2.php',
    type: 'POST',
    dataType: 'html',
    data: { 
        p: mediagach_vars, 
        start: 0, 
        limit: 10, 
        filters: filters, 
        offerBlockSize: numItemsPerRow,
        numItemsPerRow: numItemsPerRow
    },
    success: function(data) {
        console.log("data");
        console.log(data);
        $(".container-main-llistat-ofertas").append(data);
        if ($('.oferta-item').length === 0) {
            $('.block-ofertas-modelo').css('min-height', '0').css("height", "0");
            $(".titule").css("opacity", "0");
            $(".contenido_directo").css("margin-top", "0");
        } 



        
        var ajaxImages = document.querySelectorAll('.container-main-llistat-ofertas .offer-ajax-images:not(.owl-loaded)');

        if(ajaxImages) { 
            var lasts = ajaxImages.length - 12;
            var imgCache = {};

            function animationImagesAjax(id, type) {
                $('.id-' + id).owlCarousel({
                    items: 1,
                    dots: false,
                    nav: true, 
                    loop: true,
                    mouseDrag: false,
                    touchDrag: false,
                    pullDrag: false,
                    rewind: false,
                    lazyLoad: true,
                    animateOut: type || false, 
                    navText: [
                        '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-left"></i></a></object>',
                        '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-right"></i></a></object>'
                    ]
                });
            } 

            lasts = lasts > 0 ? lasts : 0;
      
            for(var x = 0; x < ajaxImages.length; x++) {
                animationImagesAjax(ajaxImages[x].getAttribute('data-id'), ajaxImages[x].getAttribute('data-type'));
                ajaxImages[x].addEventListener('mouseover', function() {
                    var offer = this;
                    var data = {
                        id: offer.getAttribute('data-id'),
                        imgTable: offer.getAttribute('data-imgTable'),
                        idImage: offer.getAttribute('data-idImage'),
                        color1: offer.getAttribute('data-color1'),
                        color2: offer.getAttribute('data-color2'),
                        url1: offer.getAttribute('data-url1')
                    };

                    if(!imgCache[data.id]) {
                        $.ajax({
                            url: mediagach_vars.rootFolder + "wp-content/themes/mediagach/templates/modules-Ofertas/ofertas5/ajaxImages.php",
                            type: "POST",
                            dataType: 'html',
                            data: data,
                            success: function(result) {
                                result = JSON.parse(result);
                                imgCache[data.id] = true;
                                result.shift();

                                for(var x = 0; x < result.length; x++) {
                                    var image = 'background-image: url(\'' + result[x] + '\');';
                                    var item = '<div class="item" style="' + image + '"></div>';
                                    $('.id-' + data.id).trigger('add.owl.carousel', item);
                                }

                                $('.id-' + data.id).trigger('refresh.owl.carousel');
                            }
                        });
                    }
                });
            }
        }


        
        $(".block-ofertas-modelo").css("opacity", "1");



    },
    error: function(xhr, status, error) {
        console.log("Error:", error);
        $(".container-main-llistat-ofertas").append(xhr.responseText);
    }
});


$("body").on("click",".pideOferta",function(e){
    e.preventDefault();
    $(".cta-button.openPopup").trigger("click");
});

            }
        },



        'page_template_template_gracias': {

            init: function() {
               
            },
            finalize: function() {

                $(document).ready(function() {
                    //console.log('entro');
                    if(typeof(Storage) !== "undefined") {
                        //console.log('entro2');
                        if (localStorage.getItem("metadataUser") === null) {  

                        }else{ 
                            metaUsuari = JSON.parse(localStorage.getItem("metadataUser"));   
                            //console.log(metaUsuari);
                            if(!metadataUsuari.utils.hasOwnProperty('adw')){
                               
                            }else{
                                var dataLayer = window.dataLayer || [];
                                dataLayer.push(
                                    {
                                        'dynx_pagetype' : 'conversion',
                                        'dynx_itemid': metaUsuari.utils.adw.id,
                                        'dynx_itemid2': metaUsuari.utils.adw.id2,
                                        'dynx_totalvalue' : metaUsuari.utils.adw.price 
                                    }); 
                                
                                mgUtils.trackMetaDataStorage('utils', 'adw', 'id', '', 0);
                                mgUtils.trackMetaDataStorage('utils', 'adw', 'id2', '', 0);
                                mgUtils.trackMetaDataStorage('utils', 'adw', 'price', '', 0);
                                                                
                            }                             
                            
                        }
                    }
                });
            }
        },

        // Promociones 
        'page_template_template_galeria': {
            init: function() {
            },
            finalize: function() {

                $("body").on("click",".promo_details",function(){
                    var promoname = $(this).attr("data-name");
                    $(".autoFilled input").val(promoname);
                });

            }
        },
 
        // Ofertas5
        'page_template_template_ofertas5': {
            init: function() {

            },
            finalize: function(){
 

                                //Per afegir un nou filtre s'ha de tocar: initListeners(), initFilters(), processData() || hardcoded(), listOffers2.php, css, addAplicado dic
                var ofertasLlistat = document.querySelector('#ofertasLlistat .row-ofertas');
                var btnBorrar = document.querySelector('#borrarFiltres');
                var filterAside = document.querySelector('.filter-aside');
                var filterBar = document.querySelector('.filter-bar');
                var aplicados = document.querySelector('#aplicados');
                var vips = document.querySelector('.exc');
                var numItemsPerRow = getCountOfItemsInRow('.container-main-llistat-ofertas');

                //AKESTA VARIABLE S'HA DE CANVIAR SI MODIFIQUEM LA MIDA MÍNIMA DE LES FITXES, serveix per calcular el número d'ofertes per fila
                var widthFitxa=350;
                var startFilter = 0;
                //var offerBlockSize = 12; // Es cridaran ofertas de x en x 
                var offerBlockSize = Math.max(12, getCountOfItemsInRow('.container-main-llistat-ofertas')*3); // Minimum 12 items per block
                var limitFilter = offerBlockSize;
                var infoFilters = {}; // Data de la taula ofertas
                var domFilters = domFilters(); // HTML dels filtres
                var urlFilters = {}; // Info de la url
                var filters = {}; // Objecte que es pasará a listOffers - AJAX
                var clientStyles = {};
                var params = window.location.href.split('?')[1];
                var firstTime = true;
                var bottomWp;
                var xhr; //Ajax

                //
                function getCountOfItemsInRow(selector) {
                    var numItemsInRow=4;
                    var ampleContainerOfertas = parseInt($(selector).width());
                    var numItemsInRow = ampleContainerOfertas/widthFitxa;
                    if(parseInt(numItemsInRow) == 0){
                        numItemsInRow=2;
                    }                     
                    //console.log('numItemInRow::'+parseInt(numItemsInRow));
                    return parseInt(numItemsInRow);
                }


                function iframe(){
                    if(params && params.includes('iframe')){
                        document.body.classList.add('iframe-view');

                        var borrar = [
                            '.mg-side-menu-container',
                            '.mg-menu-horizontal',
                            '#shiftnav-toggle-main-button',
                            '#filterTopAncla',
                            '#top-mobile-bar',
                            'footer'
                        ];
    
                        for(var x in borrar){
                            var el = document.querySelector(borrar[x]);
                            if(el) el.remove();
                        }

                    }
                }

         

                function listOffers(fallback){
                    fallback = fallback || 0;

                    offerBlockSize = getCountOfItemsInRow('.container-main-llistat-ofertas')*3;
                    numItemsPerRow = getCountOfItemsInRow('.container-main-llistat-ofertas');



                    var filtersToUse = filters;
                    if (fallback==1) {
                        console.log("fallback1");
                        filtersToUse = Object.assign({}, filters);
                        // Mantener solo carroceria, sizes y type
                        var carroceria = filtersToUse.carroceria;
                        var sizes = filtersToUse.sizes;
                        var type = filtersToUse.type;
                        
                        // Resetear todos los valores
                        for (var key in filtersToUse) {
                            if (filtersToUse.hasOwnProperty(key)) {
                                filtersToUse[key] = "";
                            }
                        }
                        
                        // Restaurar los valores que queremos mantener
                        filtersToUse.carroceria = carroceria;
                        filtersToUse.sizes = sizes;
                        filtersToUse.type = type;
                        console.log("filtersFallback"); 
                        console.log(filtersToUse); 
                        numItemsPerRow=10;


                        
                    }else if(fallback==2){
                        console.log("fallback2");

                        filtersToUse = Object.assign({}, filters);
                        // Mantener solo carroceria, sizes y type
                        var type = filtersToUse.type;
                        
                        // Resetear todos los valores
                        for (var key in filtersToUse) {
                            if (filtersToUse.hasOwnProperty(key)) {
                                filtersToUse[key] = "";
                            }
                        }
                        
                        // Restaurar los valores que queremos mantener
                        filtersToUse.type = type;
                        console.log("filtersFallback2"); 
                        console.log(filtersToUse); 
                        numItemsPerRow=10;

                    }

                    if(fallback>0){
                        $(".fallbackNoStock").show();

                    }

 

                    //En cas de que s'apliqui un filtre avans de que comenci el success de l'anterior
                    if(typeof(xhr) !== 'undefined') xhr.abort();
                    numItemsPerRow=15;
                    numItemsPerRow=offerBlockSize;
                    console.log("startFilter");
                    console.log(startFilter);
                    console.log("limitFilter");
                    console.log(limitFilter);
                    console.log("numItemsPerRow");
                    console.log(numItemsPerRow);
                    xhr = $.ajax({
                        url: mediagach_vars.rootFolder + 'mediagach/scripts/listOffers2.php',
                        type: 'POST',
                        dataType: 'html',
                        data: { 'p' : mediagach_vars, 
                            'start' : parseInt(startFilter), 
                            'limit' : parseInt(limitFilter), 
                            'filters' : filtersToUse, 
                            'offerBlockSize': numItemsPerRow,
                            'numItemsPerRow': numItemsPerRow
                        },
                        success: function(data) {

                            $("#ofertasLlistat .row-ofertas").append(data);

                            if(firstTime) {
                                loadWaypointBottomOfertas(); // Listener per carregar noves ofertes 
                                firstTime = false;
                            }
                            
                            //MARQUEM EL MAXWIDTH PQ LES ÚLTIMES OFERTES NO SURTIN OCUPANT TOTA LA FILA
                            //$('.oferta-item').css("maxWidth",document.getElementsByClassName('oferta-item')[0].clientWidth+'px');
 
                            mgUtils.checkComparador();

                            //Provoca que la barra dels filtres perdi el offset
                            Waypoint.refreshAll();
                            //bottomWp.context.refresh(); 
                            
                            /* AJAX IMAGES HOVER*/
                            var ajaxImages = document.querySelectorAll('.row-ofertas .offer-ajax-images:not(.owl-loaded)');

                            if(ajaxImages) { 
                                var lasts = ajaxImages.length - 12; //Peticions de les 12 ultimes
                                var imgCache = {};

                                function animationImagesAjax(id, type) {
                                    //console.log('animationImagesAjax');
                                    //console.log('.id-' + id);
                                    $('.id-' + id).owlCarousel({
                                        items: 1,
                                        //autoplay: true,
                                        dots: false,
                                        nav: true, 
                                        loop: true,
                                        mouseDrag: false,
                                        touchDrag: false,
                                        pullDrag: false,
                                        rewind: false,
                                        lazyLoad: true,
                                        animateOut: type || false, 
                                        navText: [
                                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-left"></i></a></object>',
                                            '<object><a href="#" onclick="return false;"><i class="icon-mediagach-navigation-chevron-right"></i></a></object>'
                                        ]
                                    });

                                }
    
                                lasts = lasts > 0 ? lasts : 0;
                          
                                for(var x = 0; x < ajaxImages.length; x++) {
                                //for(var x = lasts; x < ajaxImages.length; x++) {

                                    animationImagesAjax(ajaxImages[x].getAttribute('data-id'), ajaxImages[x].getAttribute('data-type'));
                 
                                    ajaxImages[x].addEventListener('mouseover', function() {
                            
                                        var offer = this;
                                        var data = {
                                            'id': offer.getAttribute('data-id'),
                                            'imgTable': offer.getAttribute('data-imgTable'),
                                            'idImage': offer.getAttribute('data-idImage'),
                                            'color1': offer.getAttribute('data-color1'),
                                            'color2': offer.getAttribute('data-color2'),
                                            'url1': offer.getAttribute('data-url1')
                                        }
          
                                        if(!imgCache[data.id]) {
                                            $.ajax({
                                                url: mediagach_vars.rootFolder+"wp-content/themes/mediagach/templates/modules-Ofertas/ofertas5/ajaxImages.php",
                                                type: "POST",
                                                dataType: 'html',
                                                data: data,
                                                success: function(result) {   
                                                    //console.log("result");                     
                                                    //console.log(result);                     
                                                    result = JSON.parse(result);
                                                    imgCache[data.id] = true; 
    
                                                    result.shift(); 

                                                    //Test 500 Size
                                                    var size = document.querySelector('.owl-carousel[data-id="' + data.id + '"] div[data-500]');

                                                    size = size ? size.getAttribute('data-500') == 'true' : false;
                                                           
                                                    for(var x = 0; x < result.length; x++) {
                                                        if(size) {
                                                            var spt = result[x].split('.');
                                                            spt[spt.length-2]=spt[spt.length-2]+'-500';
                                                            result[x] = spt.join('.');
                                                           // result[x] = spt[0] + '.' + spt[1] + '-500.' + spt[2];
                                                        }

                                                        var image = 'background-image: url(\'' + result[x] + '\');';
                                                        var item = '<div class="item" style="' + image + '"></div>';

                                                        $('.id-' + data.id).trigger('add.owl.carousel', item);
                                                    }
                                                    
                                                    //$('.id-' + data.id).data('owl.carousel').options.loop = true;

                                                    $('.id-' + data.id).trigger('refresh.owl.carousel');
                                                }
        
                                            });
                                        }
    
                                    });
    
                                }

                            }

                            ///////////////////

                            //Num Ofertas
                            var numOffers = document.querySelector('#numOffers').textContent;
                            var numOffersDiv = document.querySelector('.numVehiculos');
                            
                            var s = numOffers == 1 ? '' : 's';

                            numOffersDiv.innerHTML = '<span>' + numOffers + '</span> vehículo' + s;

                            if(numOffers == 0){
                                $(".numVehiculos").hide();
                            }else{
                                $(".numVehiculos").show();
                            }
                            //console.log("fallback2");
                            //console.log(data.length);
                            //console.log(numOffers);

                            //Stock msg / row masker
                            if(data.length < 300 || numOffers == 0){

                                if($('.oferta-item').length === 0){
                                    $(".avisoNoStock").show();
                                                                        /**
                                     * Si els filtres marcats no mostren cap oferta:
                                     * 1. Eliminem els filtres excepte carroceria i tipologio(vo,vn...)
                                     * Si tampoc rebem cap oferta:
                                     * 2. Eliminem el filtre de tipologia.
                                     */
                                    $(".fallbackNoStock").hide();
                                    console.log("fallback");
                                    console.log(data.length);
                                    switch(fallback){
                                        case 0:
                                            listOffers(1);
                                            break;
                                        case 1:
                                            listOffers(2);
                                            break;
                                    }
                                    
                                }else{
                                    $(".fallbackNoStock").show();
                                    if(!fallback){
                                        $(".fallbackNoStock").hide();
                                        $(".avisoNoStock").hide();
                                    }

                                }

                                $("#row-masker").hide();
                            }else{
                                if(!fallback){
                                    $(".avisoNoStock").hide();
                                }
                            }

                            $(document).trigger('insert_inter');


                        },
                        error: function(xhr, status, error) {
                            //Ajax problem
                            console.log("101 error"+xhr+"--------"+status+"------"+error);
                            console.log(xhr);
                            console.log(xhr.responseText);
                            $("#ofertasLlistat .row-ofertas").append(xhr.responseText);
                            //getDetailOffer(id);
                        }
                    });

                }
                //Inicialitza l'objecte domFilters
                function domFilters() {
                    var obj = {};
                    var dom = document.querySelectorAll('#ofertasFiltre .filter');
                    
                    for(var x = 0; x < dom.length; x++) {                        
                        var name = dom[x].getAttribute('id');
                        obj[name] = dom[x];
                    }
                    
                    return obj;
                }

                function loadWaypointBottomOfertas(){
                    bottomWp = new Waypoint({
                        element: document.getElementById('bottom-ofertas'),
                        handler: function(direction) {
                            //console.log('direction down');
                            if(direction === 'down'){
                                startFilter = limitFilter;
                                limitFilter = limitFilter + offerBlockSize;
                                listOffers();
                            } 
                        },
                        offset: '110%',
                        //context: document.getElementById('bottom-ofertas')
                    });
                }
                //String de les variables URL
                function buildURL(name, value) {
                    urlFilters[name] = value;
                    var url = '';

                    if(value == '') delete urlFilters[name];

                    Object.keys(urlFilters).forEach(function(x, i){
                        var prefix = i === 0 ? '?' : '&';
                        url += prefix + x + '=' + urlFilters[x]; 
                    });

                    if(url == '') url = '?';

                    return url;
                }
                //Agafa variables de la URL i inicialitza si no estan;

                function getParamsFromURL(){
                    if(params) {
                        params = params.split('&');

                        params.forEach(function(x){
                            var param = x.split('=');
                            if(param[0] == 'modelos') param[0] = 'model';
                            if(typeof(param[1]) === 'undefined') param[1] = '';   

                            if(param[0] != 'iframe') urlFilters[param[0]] = decodeURI(param[1].replace('+','%20').replace('%2F','/').replace('%2B','%20'));

                            if((param[0] == 'maxYear') || (param[0] == 'minYear') ){                                
                                addAplicadoInterval('year', param[0], param[1]);
                            }else{             
                                if((param[0] == 'maxKilometer') || (param[0] == 'minKilometer') ){
                                    addAplicadoInterval('kilometer', param[0], param[1]);
                                }else{
                                    if(param[0] != 'sortBy' && param[0] != 'iframe') addAplicado(param[0], decodeURI(param[1].replace('+','%20').replace('%2F','/').replace('%2B','%20')));
                                }                   
                                
                            } 
                            
                        });
                    } else {
                        //Params especials AB .../ofertas/fortwo-nuevos/
                        params = window.location.href.split('/');
                        var i = params.length;
                        if(params[i - 3] == 'ofertas') {
                            var special = decodeURI(params[i - 2]);
                            if(special.includes('-')) {
                                special = special.split('-');

                                if(special[0] != 'ofertas') {
                                    urlFilters.model = special[0];
                                    addAplicado('model', urlFilters.model);
                                }

                                urlFilters.category = special[1] == 'nuevos' ? 'Nuevos/KM0' : 'Ocasión';
                                addAplicado('category', urlFilters.category);
                            } else {
                                urlFilters.model = special;
                                addAplicado('model', urlFilters.model);
                            }
                        }
                    }

                    initFilters();
                }

                function buildCheckbox(parent, value) {
                    if(value != '') {
                        var cbox = document.createElement('div');
                        var label = document.createElement('label');
                        var container = document.createElement('div');
                        var style = clientStyles[mediagach_vars.cl];
    
                        label.textContent = value;
                        cbox.setAttribute('checked', 'false');
                        cbox.setAttribute('class', 'cbox');
                        if(style && style.cbox) cbox.classList.add(style.cbox);
                        cbox.setAttribute('value', value);
                        
                        container.setAttribute('class','cbox-container col-xs-6 col-sm-6 col-md-6 col-lg-6');
                        container.setAttribute('value', value);
                        container.appendChild(cbox);
                        container.appendChild(label);
                        parent.appendChild(container);
    
                        if(value == 'Todos') {
                            var span = document.createElement('span');
                            span.textContent = parent.getAttribute('data-name');
                            span.setAttribute('class','cbox-title col-xs-6 col-sm-6 col-md-6 col-lg-6');
                            parent.appendChild(span);
    
                            container.setAttribute('class','todos col-xs-6 col-sm-6 col-md-6 col-lg-6');
                        }
    
                    }
                }
                //buildCheckbox(),initChecked()
                function hardCodedModules() {

                    /* --- SortBy --- */
                    if(domFilters.sortBy) {
                        // Per defecte desde la URL
                        if(filters.sortBy) { 

                            var dic = {
                                price: 'Precio más bajo',
                                price2: 'Precio más alto',
                                potencia: 'Potencia más baja',
                                potencia2: 'Potencia más alta'
                            };

                            domFilters.sortBy.children[0].children[0].textContent = dic[filters.sortBy]; 
                            domFilters.sortBy.children[0].children[0].style.color = '#000';
                            domFilters.sortBy.children[0].children[1].children[0].style.display = 'inline-block';
                        }
                    }
                    /* --- Custom Brand --- */
                    if(domFilters.brand2) {
                        var items = ['Mercedes-Benz', 'Mercedes-AMG','smart','Mercedes EQ'];

                        buildCheckbox(domFilters.brand2, 'Todos');
                        for(var x in items) buildCheckbox(domFilters.brand2, items[x]);

                        initChecked('brand2');
                    }

                    /* --- Cambios --- */
                    if(domFilters.cambios) {
                        var items = ['Manual', 'Automático'];

                        buildCheckbox(domFilters.cambios, 'Todos');
                        for(var x in items) buildCheckbox(domFilters.cambios, items[x]);

                        initChecked('cambios');
                    }

                    /* --- Combustible --- */
                    if(domFilters.motor) {
                        var items = ['Gasolina', 'Diésel', 'Eléctrico','Híbrido','Híbrido Enchufable'];

                        buildCheckbox(domFilters.motor, 'Todos');
                        for(var x in items) buildCheckbox(domFilters.motor, items[x]);

                        initChecked('motor');
                    }

                    /* --- Type (Cuotas) --- */
                    if(domFilters.type) {
                        var items = ['Compra', 'Cuotas'];

                        buildCheckbox(domFilters.type, 'Todos');
                        for(var x in items) buildCheckbox(domFilters.type, items[x]);

                        initChecked('type');
                    }

                    /* --- Nuevos --- */
                    if(domFilters.category) {
                        var items = ['Nuevos', 'Ocasión/KM0'];

                        buildCheckbox(domFilters.category, 'Todos');
                        for(var x in items) buildCheckbox(domFilters.category, items[x]);

                        initChecked('category');
                    }
                    /* --- Carroceria Hardcoded --- */
                    if(domFilters.carroceria) {
                        var items = ['Berlina', 'Coupé','Compacto','Familiar','Monovolumen','SUV/Todoterreno','Cabrio'];

                        buildCheckbox(domFilters.carroceria, 'Todos');
                        for(var x in items) buildCheckbox(domFilters.carroceria, items[x]);

                        initChecked('carroceria');
                    }


                    /* --- Distintivos --- */
                    if(domFilters.distintivos) {
                        //Hardcoded
                        initHardcodedChecked('distintivos',false); //Inicialitzem checkBox desde la URL
                    }



                   
                }
                //Crea els filtres que depenen de la base de dades
                function processData(data) {
                    infoFilters = data;

                    //Primer parametre id del filter (ha de ser igual a url name); 
                    //Segon parametre nom de la columna de la taula;
                    if(domFilters.brand) resetSelect('brand', 'marca'); 
                    if(domFilters.model) resetSelect('model','name');
 
                    /* --- Price Range --- */
                    if(domFilters.range.children[0]) {
                        filters.minP = filters.minP == 0 ? data.minP : filters.minP;
                        filters.maxP = filters.maxP == 1000000 ? data.maxP : filters.maxP;

                        var plus = Math.trunc(filters.maxP) == 100000 ? '+' : '';

                        domFilters.range.children[0].value = numberWithCommas(Math.trunc(filters.minP)) + ' € / '+ plus + numberWithCommas(Math.trunc(filters.maxP)) + ' € ';
                        
                        $("#slider-range").slider({
                            range: true,
                            min: parseInt(data.minP),
                            max: parseInt(data.maxP),
                            values: [filters.minP, filters.maxP],
                            slide: function(event, ui) {
                                plus = ui.values[1] == 100000 ? '+' : '';
                                domFilters.range.children[0].value = numberWithCommas(Math.round(ui.values[0] / 1000) * 1000) + ' € / ' + plus + numberWithCommas(Math.round(ui.values[1] / 1000) * 1000) + ' €' ;
                            },
                            stop: function(event, ui) {
                                filters.minP = ui.values[0] == data.minP ? '' : Math.round(ui.values[0] / 1000) * 1000;
                                filters.maxP = ui.values[1] == data.maxP ? '' : Math.round(ui.values[1] / 1000) * 1000;
    
                                if(ui.value == ui.values[0]) {
                                    if(aplicados) addAplicado('minP', filters.minP);
                                    resetPagination('minP', filters.minP);
                                } else {
                                    if(aplicados) addAplicado('maxP', filters.maxP);
                                    resetPagination('maxP', filters.maxP);
                                }
    
                            }
                        });    

                        filters.minP = data.minP;
                        filters.maxP = data.maxP;
                    }
                    //console.log("domFilters");
                    //console.log(domFilters);
                    /* --- Carroceria autogenerated:  error quan un model té 2 carroceries --- */
                    /*if(domFilters.carroceria) {
                        //Borrar antics
                        while (domFilters.carroceria.firstChild) {
                            domFilters.carroceria.removeChild(domFilters.carroceria.firstChild);
                        } 

                        // Array amb la columna carroceria
                        var arr1 = infoFilters.models.map(function(x) { 
                            return x.carroceria;
                        }) 

                        //ES6 arr1 = arr1.filter( f,i,arr => arr.map(m => m.toLowerCase()).indexOf(f.toLowerCase()) === i )

                        arr1 = arr1.filter(function(f,i,arr) { 
                            arr = arr.map(function(m) { return m.toLowerCase()});
                            return arr.indexOf(f.toLowerCase()) === i;
                        })

                        buildCheckbox(domFilters.carroceria, 'Todos');
                        for(var x = 0; x < arr1.length; x++) buildCheckbox(domFilters.carroceria, arr1[x]);

                        initChecked('carroceria'); //Inicialitzem checkBox desde la URL
                    }*/

                }
                //AJAX -> processData(), initListeners()
                function loadInfoForFilters(){

                    $.ajax({
                        url: mediagach_vars.rootFolder+"mediagach/scripts/loadInfoForFilters2.php",
                        type: "POST",
                        dataType: 'json',
                        data: { "p" : mediagach_vars,"filters" : filters,"urlFilters" : urlFilters},
                        success: function(data) {
                            //console.log(data);
                            processData(data);
                            initListeners(); //Inicialitza tots els listeners dels filtres
                            jsForCss(); // Css per els estils dels filtres 
                        },
                        error: function(xhr, status, error) {
                            console.log("101 error"+xhr+"--------"+status+"------"+error);
                            console.log(xhr);
                            console.log(xhr.responseText);
                        }
                    });
                }

                function resetPagination(name, value) {

                    startFilter = 0;
                    limitFilter = offerBlockSize;

                    window.scrollTo(0,0);

                    window.history.pushState(null, null, buildURL(name, value));
                    filters[name] = value;

                    //Borrem totes les ofertas
                    while (ofertasLlistat.firstChild) {
                        ofertasLlistat.removeChild(ofertasLlistat.firstChild);
                    }

                    listOffers();

                }

                function resetSelect(field, column) {

                    var arr1 = infoFilters.models;
                    var dom = domFilters[field].children; // span.default i div.options

                    // Filtrar per marca si marca esta selected
                    if(field === 'model' && urlFilters.brand){
                        arr1 = arr1.filter(function(x) {
                            return urlFilters.brand == x.marca;
                        });
                    }

                    arr1 = arr1.map(function(x) { return x[column].trim(); }) // Array amb la columna field; Amb ES6: arr1.map( x => x[column] )
                    arr1 = arr1.filter(function(x,i) { return arr1.indexOf(x) === i; }) //Filtrem duplicats

                    //Borrar antics
                    while (dom[1].firstChild) {
                        dom[1].removeChild(dom[1].firstChild);
                    }

                    //Afegim les opcions
                    var option = document.createElement('input');
                    option.setAttribute('type', 'text'); 
                    option.setAttribute('keep','true');
                    dom[1].appendChild(option);
                   
                    for(var x = 0; x < arr1.length; x++){

                        var option = document.createElement('div');
                        option.setAttribute('value', arr1[x]); 
                        option.setAttribute('class', 'option'); 
                        option.textContent = arr1[x];

                        // Per defecte desde la URL
                        if(filters[field] == arr1[x] && arr1[x].length > 0) { 
                            dom[0].children[0].textContent = arr1[x]; // Text visible
                            dom[0].children[0].style.color = '#000';
                            dom[0].children[1].children[0].style.display = 'inline-block';
                        }

                        dom[1].appendChild(option);
                    }
                }
                //Posa true els checkbox que estan a la URL
                function initChecked(type) {
                       
                    var cboxs = document.querySelectorAll('#' + type + ' .cbox');
                    cboxs[0].setAttribute('checked','true'); // Toggle Todos

                    if(urlFilters[type]) {
                        var urlItems = urlFilters[type].split('_');
                        var checked = 'false';

                        cboxs[0].setAttribute('checked', checked); // Toggle Todos
                        for(var x = 1; x < cboxs.length; x++) {
                            for(var y = 0; y < urlItems.length; y++) {
                                if(cboxs[x].getAttribute('value') == urlItems[y]) cboxs[x].setAttribute('checked', checked = 'true');
                            }
                        } 

                    } 
                }

                function initHardcodedChecked(type,todos) { 
                       
                    var itemsFilter = document.querySelectorAll('#' + type + ' .itemsFilter');
                    if(todos){
                        itemsFilter[0].setAttribute('checked','true'); // Toggle Todos
                    }
                    if(urlFilters[type]) {
                        var urlItems = urlFilters[type].split('_');
                        var checked = 'false';
                        if(todos){
                            itemsFilter[0].setAttribute('checked', checked); // Toggle Todos
                        }
                        for(var x = 0; x < itemsFilter.length; x++) {
                            itemsFilter[x].children[0].setAttribute('checked', 'false');
                            for(var y = 0; y < urlItems.length; y++) {
                                if(itemsFilter[x].children[0].getAttribute('value') == urlItems[y]) {
                                    itemsFilter[x].children[0].setAttribute('checked', 'true');
                                }
                            }
                        } 

                    } 
                }


                function initFilters() {
                    
                    filters = {};
                    filters.sortBy = urlFilters.sortBy || '';
                    filters.brand = urlFilters.brand || '';
                    filters.model = urlFilters.model || '';
                    filters.minP = urlFilters.minP || 0;
                    filters.maxP = urlFilters.maxP || 1000000;
                    filters.carroceria = urlFilters.carroceria || '';
                    filters.motor = urlFilters.motor || ''; 
                    filters.cambios = urlFilters.cambios || ''; 
                    filters.brand2 = urlFilters.brand2 || ''; 
                    filters.type = urlFilters.type || '';
                    filters.category = urlFilters.category || '';
                    filters.distintivos = urlFilters.distintivos || '';
                    filters.minYear = urlFilters.minYear || '';
                    filters.maxYear = urlFilters.maxYear || '';
                    filters.minKilometer = urlFilters.minKilometer || '';
                    filters.maxKilometer = urlFilters.maxKilometer || '';

                    if(vips) {
                        filters.exc = {
                            msg: vips.getAttribute('data-exc'),
                            nom: vips.getAttribute('data-exc2'),
                            desc: vips.getAttribute('data-exc3')
                        }
                    }
                }

                //seria en el cas de matriculació -> year, minYear o maxYear, valor
                function addAplicadoInterval(parentType, type, value){
                    value = value.toString().replace(/_/g, ', ');

                    var spanMsg = document.querySelector('#aplicados > span');
                    var dic = {
                        year: 'Año de matriculación',
                        minYear: 'desde ',
                        maxYear: 'hasta ',
                        kilometer: 'Kilómetros',
                        minKilometer: 'desde ',
                        maxKilometer: 'hasta '
                    }

                    spanMsg.style.display = 'none';
                    var exists = document.querySelector('.aplicado-label.ap-' + parentType);
                    var value = ((type == 'minKilometer' || type == 'maxKilometer') && (value != '')) ? numberWithCommas(value) + ' Km' : value;




                    if(exists) {
                        //ens quedem amb min o max del tipus
                        var searchMask = parentType;
                        var regEx = new RegExp(searchMask, "ig");
                        var replaceMask = "";
                        var result = type.replace(regEx, replaceMask);

                        if(exists.getAttribute('data-'+result)){
                            exists.setAttribute('data-'+result, value);
                        }else{
                            exists.setAttribute('data-'+result, value);
                        }

                        var min = '';
                        if(exists.getAttribute('data-min')){
                            min = exists.getAttribute('data-min');
                        }

                        var max = '';
                        if(exists.getAttribute('data-max')){
                            max = exists.getAttribute('data-max');
                        }

                        if((min != '')&&(max != '')){
                            exists.children[1].textContent = min+'-'+max;
                        }else{
                            var parentName = parentType.charAt(0).toUpperCase()+parentType.slice(1);

                            if(min != ''){
                                exists.children[1].textContent = dic['min'+parentName]+min;
                            }
                            if(max != ''){
                                exists.children[1].textContent = dic['max'+parentName]+max;
                            }
                        }


                        //exists.children[1].textContent = value;
                        exists.style.display = 'flex';
                        if((min == '')&&(max == '')){
                            exists.style.display = 'none';
                        }
                        if(min == ' Km' || max == ' Km') {
                            exists.style.display = 'none';
                        }

                    } else {
                        if((value != '' || value != ' Km') && dic[parentType]) {
                            var cont = document.createElement('div');
                            var title = document.createElement('span');
                            var values = document.createElement('div');
                            var x = document.createElement('i');
    
                            
                            x.setAttribute('class','fa fa-times remove-option2');
                            title.innerHTML = dic[parentType] + ':&nbsp;';
                            cont.appendChild(title);
                            values.textContent = dic[type]+value;
                            cont.appendChild(values);
                            cont.appendChild(x);
                            cont.setAttribute('class', 'aplicado-label ap-' + parentType);

                            //ens quedem amb min o max del tipus
                            var searchMask = parentType;
                            var regEx = new RegExp(searchMask, "ig");
                            var replaceMask = "";
                            var result = type.replace(regEx, replaceMask);
                            cont.setAttribute('data-'+result, value);


                            aplicados.appendChild(cont);
    
                            cont.addEventListener('click', function() {
                                
                                cont.style.display = 'none'; 

                                var parentName = parentType.charAt(0).toUpperCase()+parentType.slice(1);

                                $('#min'+parentName).val("0");
                                $('#max'+parentName).val("0");
                                resetPagination('min'+parentName, '');
                                resetPagination('max'+parentName, '');

                                $('.ap-'+parentType).removeAttr('data-min');
                                $('.ap-'+parentType).removeAttr('data-max');

                                /*
                                if((type == 'minYear')||(type == 'maxYear')){
                                    $('#minYear').val("0");
                                    $('#maxYear').val("0");
                                    resetPagination('minYear', '');
                                    resetPagination('maxYear', '');

                                    $('.ap-year').removeAttr('data-min');
                                    $('.ap-year').removeAttr('data-max');
                                }

                                if((type == 'minKilometer')||(type == 'maxKilometer')){
                                    $('#minKilometer').val("0");
                                    $('#maxKilometer').val("0");
                                    resetPagination('minKilometer', '');
                                    resetPagination('maxKilometer', '');

                                    $('.ap-kilometer').removeAttr('data-min');
                                    $('.ap-kilometer').removeAttr('data-max');
                                }
                                */

                                
                                var filtersNone = [];
                                for(var a = 2; a < aplicados.children.length; a++) {
                                    filtersNone.push(aplicados.children[a]);
                                }

                                filtersNone = filtersNone.every(function(a) { return a.getAttribute('style') == 'display: none;'; });

                                if(filtersNone) spanMsg.style.display = 'block';
                                

                            })
    
                            cont.addEventListener('mouseover', function() {
                                cont.children[2].style.color = '#111';
                                cont.children[2].style.transform = 'rotateZ(90deg)';
                            })
    
                            cont.addEventListener('mouseout', function() {
                                cont.children[2].style.color = '#AAA';
                                cont.children[2].style.transform = 'rotateZ(0deg)';
                            })
                        }

                    }


                }

                function addAplicado(type, value) {
                    value = value.toString().replace(/_/g, ', ');

                    var spanMsg = document.querySelector('#aplicados > span');
                    var dic = {
                        type: 'Compra/Cuota',
                        category: 'Tipo de vehículo',
                        model: 'Modelo',
                        cambios: 'Cambios',
                        brand2: 'Familia',
                        brand: 'Marca',
                        motor: 'Combustible',
                        carroceria: 'Carroceria',
                        distintivos: 'Distintivos',
                        minP: 'Precio mínimo',
                        maxP: 'Precio máximo'
                        
                    }

                                     
                    spanMsg.style.display = 'none';
                    var exists = document.querySelector('.aplicado-label.ap-' + type);
                    var value = type == 'minP' || type == 'maxP' && type != '' ? numberWithCommas(value) + ' €' : value;

                    if(exists) {
                        exists.children[1].textContent = value;
                        exists.style.display = 'flex';
                        if(value == '' || value == ' €') {
                            exists.style.display = 'none';
                        }

                    } else {
                        if((value != '' || value != ' €') && dic[type]) {
                            var cont = document.createElement('div');
                            var title = document.createElement('span');
                            var values = document.createElement('div');
                            var x = document.createElement('i');
    
                            x.setAttribute('class','fa fa-times remove-option2');
                            title.innerHTML = dic[type] + ':&nbsp;';
                            cont.appendChild(title);
                            values.textContent = value;
                            cont.appendChild(values);
                            cont.appendChild(x);
                            cont.setAttribute('class', 'aplicado-label ap-' + type);
                            aplicados.appendChild(cont);
    
                            cont.addEventListener('click', function() {
                                $('#' + type + ' .remove-option').trigger('click'); 
                                $('#' + type + ' .todos').trigger('click'); 
                                cont.style.display = 'none'; 

                                var values = $('#slider-range').slider('values');

                                if(type == 'minP') {
                                    //Slider Range
                                    $('#slider-range').slider( 'option', 'values', [ infoFilters.minP, values[1]] );

                                    domFilters.range.children[0].value = numberWithCommas(infoFilters.minP) + ' € / ' + numberWithCommas(values[1]) + ' €';
                                    resetPagination('minP', '');
                                    
                                }

                                if(type == 'maxP') {
                                    //Slider Range
                                    $('#slider-range').slider( 'option', 'values', [ values[0], infoFilters.maxP] );

                                    domFilters.range.children[0].value = numberWithCommas(values[0]) + ' € / +' + numberWithCommas(infoFilters.maxP) + ' €';

                                    resetPagination('maxP','');
                                }

                                

                                //Especial distintivos
                                if(type == 'distintivos'){
                                    resetPagination(type, '');
                                    
                                    //Reset like .todos
                                    $('#' + type + ' .removeAplicado').attr('removeAll','true');
                                    $('#' + type + ' .removeAplicado').trigger('click');

                                    var items = document.querySelectorAll('#' + type + ' .itemsFilter');
                                    items = Array.prototype.slice.call(items);

                                    for(var z = 0; z < items.length; z++){
                                        items[z].children[0].setAttribute('checked', 'false');
                                    }
                                }

                                var filtersNone = [];
                                for(var a = 2; a < aplicados.children.length; a++) {
                                    filtersNone.push(aplicados.children[a]);
                                }

                                filtersNone = filtersNone.every(function(a) { return a.getAttribute('style') == 'display: none;'; });

                                if(filtersNone) spanMsg.style.display = 'block';

                            })
    
                            cont.addEventListener('mouseover', function() {
                                cont.children[2].style.color = '#111';
                                cont.children[2].style.transform = 'rotateZ(90deg)';
                            })
    
                            cont.addEventListener('mouseout', function() {
                                cont.children[2].style.color = '#AAA';
                                cont.children[2].style.transform = 'rotateZ(0deg)';
                            })
                        }

                    }

                }

                function initListeners(){

                    var inputs = document.querySelectorAll('.options input');
                    var btnFiltros = document.querySelector('#mas-filtros');
                    var defaults = document.querySelectorAll('.default');
                    var isBtnOpen;

                    // Select: toggle displays
                    for(var x = 0; x < defaults.length; x++) {
                        defaults[x].addEventListener('click', function() {

                            //Toggle Display block && none
                            var display = this.nextElementSibling.style.display; //.options
                            display = display == 'none' ? 'block' : 'none';

                            if(display == 'block') { 
                                var options = document.querySelectorAll('.options');
                                for(var i = 0; i < options.length; i++) options[i].style.display = 'none';
                            }
                            this.nextElementSibling.style.display = display;
                        });
                    }

                    document.body.addEventListener('click', function(ev) { 
                        if(!ev.target.getAttribute('keep')) {
                            for(var x = 0; x < defaults.length; x++) {
                                defaults[x].nextElementSibling.style.display = 'none';
                            }
                        }

                        //Tancar filterAside quan es fa click fora
                        if(ev.target.getAttribute('id') == 'mas-filtros') {
                            isBtnOpen = true; 
                        } else {
                            isBtnOpen = btnFiltros.contains(ev.target);
                        }

                        if(!filterAside.contains(ev.target) && !isBtnOpen) {
                            filterAside.style.marginLeft = '-500px';
                        }

                    })

                    // Select: Input Search
                    for(var x = 0; x < inputs.length; x++) {
                        inputs[x].addEventListener('input', function() {
                            var options = this.parentNode.children;
                            var regexp = new RegExp(this.value, 'i');

                            for(var i = 1; i < options.length; i++) {
                                if(regexp.test(options[i].getAttribute('value'))) {
                                    options[i].style.display = 'block';
                                } else {
                                    options[i].style.display = 'none';     
                                }
                            }

                        });
                    }

                    if(btnBorrar) {
                        btnBorrar.addEventListener('click', function(){

                            startFilter = 0;
                            limitFilter = offerBlockSize;

                            urlFilters = {};
        
                            window.scrollTo(0,0);
        
                            window.history.pushState(null, null, '?');
                            initFilters();
        
                            //Borrem totes les ofertas
                            while (ofertasLlistat.firstChild) {
                                ofertasLlistat.removeChild(ofertasLlistat.firstChild);
                            }
        
                            listOffers();

                            //Reset
                            $('#ofertasFiltre .cbox[value="Todos"]').trigger('click');

                            $('#distintivos .removeAplicado').attr('removeAll','true');
                            $('#distintivos .removeAplicado').trigger('click');


                            //Remove Aplicados
                            if(aplicados) {
                                var aplicadosLabel = document.querySelectorAll('.aplicado-label');
                                for(var x = 0; x < aplicadosLabel.length; x++) {
                                    aplicadosLabel[x].remove();
                                }
                            }

                            //remove doulble selects
                            clearDoubleSelects('year');
                            clearDoubleSelects('kilometer');
                            
                            


                            //Selects Off
                            clearSelects();   
                            
                            //SortBy Off
                            domFilters.sortBy.children[0].children[0].textContent = 'Destacados';
                            domFilters.sortBy.children[0].children[0].style.color = '#666';
                            domFilters.sortBy.children[0].children[1].children[0].style.display = 'none';

                            //Slider Range
                            var min = $('#slider-range').slider( 'option', 'min');
                            var max = $('#slider-range').slider( 'option', 'max');

                            $('#slider-range').slider( 'option', 'values', [ min, max] );
                            domFilters.range.children[0].value = numberWithCommas(min) + ' € - ' + numberWithCommas(max) + ' €';

                        })
                    }

                    if(domFilters.sortBy) {

                        domFilters.sortBy.addEventListener('click', function(ev) {

                            var value = ev.target.getAttribute('value');

                            if(typeof(value) == 'string') {

                                var dic = {
                                    price: 'Precio más bajo',
                                    price2: 'Precio más alto',
                                    potencia: 'Potencia más baja',
                                    potencia2: 'Potencia más alta'
                                };
                                
                                this.children[0].children[0].textContent = value == '' ? 'Destacados' : dic[value]; //AB
                                this.children[0].children[0].style.color = value === 'price' ? '#000' : '#666';
                                this.children[0].children[1].children[0].style.display = value === 'price' ? 'inline-block' : 'none';
                                resetPagination('sortBy', value);

                            };

                            if(ev.target.classList.contains('remove-option')) {

                                this.children[0].children[0].textContent = 'Destacados';
                                this.children[0].children[0].style.color = '#666';
                                this.children[0].children[1].children[0].style.display = 'none';
                                resetPagination('sortBy', '');

                            }

                        })
                    }

                    if(domFilters.brand) {

                        domFilters.brand.addEventListener('click', function(ev) {
                            if(ev.target.classList.contains('option')) {
                                filters.model = ''; //Reset model

                                var value = ev.target.getAttribute('value');

                                if(aplicados) addAplicado('brand', value);

                                domFilters.brand.children[0].children[0].style.color = '#000';
                                domFilters.brand.children[0].children[0].textContent = value;
                                domFilters.brand.children[0].children[1].children[0].style.display = 'inline-block'; // x button

                                resetPagination('brand', value); 

                                // Al canviar marca reset models
                                $('.ap-model > i').trigger('click');
                                
                                if(domFilters.model) {
                                    delete urlFilters.model; 
                                    window.history.pushState(null, null, buildURL('model',''));
    
                                    domFilters.model.children[0].children[0].style.color = '#666';
                                    domFilters.model.children[0].children[0].textContent = 'Selecciona un modelo';
                                    domFilters.model.children[0].children[1].children[0].style.display = 'none'; // x button
    
                                    resetSelect('model','name');
                                }

                            }

                            if(ev.target.classList.contains('remove-option')) clearSelects();
                        })
                    }

                    if(domFilters.model) {

                        domFilters.model.addEventListener('click', function(ev) {
                            if(ev.target.classList.contains('option')) {

                                var value = ev.target.getAttribute('value');

                                if(aplicados) addAplicado('model', value);

                                domFilters.model.children[0].children[0].style.color = '#000';
                                domFilters.model.children[0].children[0].textContent = value;
                                domFilters.model.children[0].children[1].children[0].style.display = 'inline-block'; // x button

                                resetPagination('model', value); 
                            }

                            if(ev.target.classList.contains('remove-option')) clearSelects(true);

                        })

                    }

                    if(domFilters.brandLogos) {
                        var logos = domFilters.brandLogos.children;

                        for(var x = 0; x < logos.length; x++) {
                            logos[x].addEventListener('click', function() {
                                $('#brand .options div[value="' + this.getAttribute('value') + '"]').trigger('click');
                            })
                        }

                    }

                    if(domFilters.year){
                        initDoubleSelectListeners('year');                        
                    }

                    if(domFilters.kilometer){                        
                        initDoubleSelectListeners('kilometer');                        
                    }


                    initCheckboxListeners('carroceria');
                    initCheckboxListeners('motor');
                    initCheckboxListeners('type');
                    initCheckboxListeners('category');
                    initCheckboxListeners('brand2');
                    initCheckboxListeners('cambios');
                    initHardcodedFilterListeners('distintivos');

                    function urlSlice(url){
                        if(url.charAt(0) == '_') {
                            return url.slice(1);
                        } else {
                            return url;
                        }
                    }


                    function initHardcodedFilterListeners(name) {
                        var urlstr = filters[name];
                        var items = document.querySelectorAll('#' + name + ' .itemsFilter');
                        items = Array.prototype.slice.call(items);

                        for(var x = 0; x < items.length; x++){
                            items[x].addEventListener('click', function() {
                                if(this.getAttribute('removeAll') == 'true') {
                                    urlstr = '';
                                    this.setAttribute('removeAll','false');
                                } else {
                                    var checked = this.children[0].getAttribute('checked') === 'false'; //Toggle
                                    this.children[0].setAttribute('checked',checked); //Toggle
    
                                    var value = this.children[0].getAttribute('value');
                       
                                    //Add to URL
                                    if(checked) {
                                        urlstr += '_' + value; 
                                    } else {
                                        var re = new RegExp('(_' + value + '|' + value + ')',"g");
                                        urlstr = urlstr.replace(re, '');
                                    }
    
                                    //*addAplicado('size'), *addAplicado('distintivos')
                                    if(aplicados) addAplicado(name, urlSlice(urlstr));
                                    resetPagination(name, urlSlice(urlstr)); 
                                }
                            });
                        }
                        
                    }

                    function initDoubleSelectListeners(type){

                        var items = document.querySelectorAll('#'+type+' select');
                        items = Array.prototype.slice.call(items);

                        for(var x = 0; x < items.length; x++){
                            items[x].addEventListener('change', function(ev) {                                
                                var valorSeleccionat = ev.target.value;
                                if(valorSeleccionat == 0) valorSeleccionat = '';
                                var idSelect = ev.target.id;
                                if(aplicados) addAplicadoInterval(type, idSelect, valorSeleccionat);                                
                                resetPagination(idSelect, valorSeleccionat); 
                                
                            });
                        }

                        /*var items = document.querySelectorAll('#year select');
                        items = Array.prototype.slice.call(items);

                        for(var x = 0; x < items.length; x++){
                            items[x].addEventListener('change', function(ev) {                                
                                var valorSeleccionat = ev.target.value;
                                if(valorSeleccionat == 0) valorSeleccionat = '';
                                var idSelect = ev.target.id;
                                if(aplicados) addAplicadoInterval('year',idSelect, valorSeleccionat);                                
                                resetPagination(idSelect, valorSeleccionat); 
                                
                            });
                        }
                        */

                    }
                    function initCheckboxListeners(name) {

                        var cboxs = document.querySelectorAll('#' + name + ' > div');
                        var urlstr = filters[name];

                        for(var x = 0; x < cboxs.length; x++) {

                            cboxs[x].addEventListener('click', function() {

                                var checked = this.children[0].getAttribute('checked') === 'false'; //Toggle
                                var value = this.children[0].getAttribute('value');
                                var boxes = [];

                                for(var e = 0; e < this.parentNode.children.length; e++) {
                                    var el = this.parentNode.children[e];
                                    if(el.classList.contains('cbox-container')) boxes.push(el);
                                }
                                
                                if(value === 'Todos') {
                                    //Reset
                                    urlstr = '';
                                    for(var y = 0; y < boxes.length; y++) {
                                        boxes[y].children[0].setAttribute('checked', 'false');
                                    }

                                } else {
                                    //Add to URL
                                    if(checked) {
                                        urlstr += '_' + value; 
                                    } else {
                                        var re = new RegExp('(_' + value + '|' + value + ')',"g");
                                        urlstr = urlstr.replace(re, '');
                                    }

                                }

                                this.children[0].setAttribute('checked', checked);

                                // Toggle Todos
                                cboxs[0].children[0].setAttribute('checked','false');
                                if(urlstr.length == 0) cboxs[0].children[0].setAttribute('checked','true');

                                // Remove first _
                                if(urlstr.charAt(0) == '_') urlstr = urlstr.slice(1);

                                if(aplicados) addAplicado(name, urlstr);

                                resetPagination(name, urlstr); 
                            })

                        }
                    }

                    function clearDoubleSelects(type){

                        var typeCapitalLetter = type.charAt(0).toUpperCase()+type.slice(1);


                        $('#min'+typeCapitalLetter).val("0");
                        $('#max'+typeCapitalLetter).val("0");
                        $('.ap-'+type).removeAttr('data-min');
                        $('.ap-'+type).removeAttr('data-max');

                        /*
                        $('#minYear').val("0");
                        $('#maxYear').val("0");
                        $('.ap-year').removeAttr('data-min');
                        $('.ap-year').removeAttr('data-max');
                        $('#minKilometer').val("0");
                        $('#maxKilometer').val("0");
                        $('.ap-kilometer').removeAttr('data-min');
                        $('.ap-kilometer').removeAttr('data-max');
                        */

                    }

                    function clearSelects(marca) {

                        function clearSelect(field, msg) {
                            if(field) {
                                field.children[0].children[0].style.color = '#666'; // Selecciona una marca
                                field.children[0].children[0].innerHTML = msg; 
                                field.children[0].children[1].children[0].style.display = 'none'; // X
                            }
                        }

                        if(!marca) {
                            filters.brand = '';
                            window.history.pushState(null, null, buildURL('brand',''));
                            $('.ap-brand > i').trigger('click');
                        }

                        if(domFilters.model) {
                            filters.model = '';
                            window.history.pushState(null, null, buildURL('model',''));
                            $('.ap-model > i').trigger('click');
                        }

                        //Borrem totes les ofertas
                        while (ofertasLlistat.firstChild) {
                            ofertasLlistat.removeChild(ofertasLlistat.firstChild);
                        }
                        
                        //Reset select
                        if(!marca) clearSelect(domFilters.brand, 'Selecciona una marca');
                        clearSelect(domFilters.model, 'Selecciona un modelo');

                        //Reset Models List

                        resetSelect('model','name');
                        listOffers();

                    }


                    window.addEventListener('resize', function() {
                        if(window.innerWidth < 992) {
                            filterAside.appendChild(domFilters.range);
                            filterAside.insertBefore(domFilters.range, filterAside.children[1]);

                            filterAside.appendChild(aplicados);
                            filterAside.insertBefore(aplicados, filterAside.children[1]);

                            filterAside.appendChild(domFilters.sortBy);
                            filterAside.insertBefore(domFilters.sortBy,  filterAside.children[2]);
                        } else {
                            filterBar.appendChild(domFilters.sortBy);
                            filterBar.appendChild(domFilters.range);
                            filterBar.appendChild(aplicados);
                        }
                    })

                    if(window.innerWidth < 992) {
                        filterAside.appendChild(domFilters.range);
                        filterAside.insertBefore(domFilters.range, filterAside.children[1]);

                        filterAside.appendChild(aplicados);
                        filterAside.insertBefore(aplicados, filterAside.children[1]);

                        filterAside.appendChild(domFilters.sortBy);
                        filterAside.insertBefore(domFilters.sortBy, filterAside.children[2]);
                    }

                }
                //Silvia
                function initModalForm() {
                    
                    var offersSelected = [];
                    var offersSelectedPrivado = [];

                    function fillTextarea(t) {
                        offersSelected.push(t.data('info-oferta'));
                        texto = "Hola!\nQuiero recibir más información de:\n";
                        $.each(offersSelected, function(key, value) {
                            texto = texto + "\n" + value + ".";
                        });
                        texto = texto + "\n\n¡Gracias!";
                        $(".modal-offer-related textarea").html(texto);
                    }
    
                    function fillHiddenField(t) {
                        offersSelectedPrivado.push(t.data('info-hidden'));
                        texto2 = "";
                        $.each(offersSelectedPrivado, function(key, value) {
                            texto2 = texto2 + "\n" + value + ".";
                        });
                        $(".modal-offer-related .textarea-privado textarea").html(texto2);
                    }

                    $("body").on("click",".addMessage",function(){
                        $(".textarea-interested").toggleClass("hidden");
                        $(".addMessage p").toggleClass("hidden");
                    });

                    $("body").on("click",".pideOferta",function(){
                        //Silvia
                        if($(this).data("adw-item")){
                            $(".adw-content").attr("data-adw-item",$(this).data("adw-item"));
                            $(".adw-content").attr("data-adw-item2",$(this).data("adw-item2"));
                            $(".adw-content").attr("data-adw-totalvalue",$(this).data("adw-totalvalue"));
                        }
    
                        var copiedModal = $("#modal-pideOferta");
                        ////$("#modal-pideOferta").remove();
                        ////copiedModal.appendTo("body");
                        $("#modal-pideOferta").modal();
                        fillTextarea($(this));
                        fillHiddenField($(this));
                        $(".textarea-interested").addClass("hidden");
                        $(".addMessage p").removeClass("hidden");

                        //Silvia
                        ga('send', 'event', 'Solicitar Oferta', 'Listado Ofertas', $(this).attr("data-info-oferta"));
                        
                    });
    
                    $("body").on("click",".btn-open-form-detail",function(){
                        copiedModal = $("#modal-pideOferta");
                        /////$("#modal-pideOferta").remove();
                        /////copiedModal.appendTo("body");
                        $("#modal-pideOferta").modal();
                        fillTextarea($(this));
                        fillHiddenField($(this));
                        $(".textarea-interested").addClass("hidden");
                        $(".addMessage p").removeClass("hidden");
                    });

                }

                function jsForCss(){

                    //Filter Toggle Left
                    var close = document.querySelector('#aplicarFiltres');
                    var masFiltros = document.querySelector('#mas-filtros');

                    close.addEventListener('click', function() {
                        filterAside.style.marginLeft = '-500px';
                    })

                    masFiltros.addEventListener('click', function() {
                        filterAside.style.marginLeft = '0px';
                    })


                }

                var menu2 = document.querySelector('.mg-side-menu-container2');
                
                if(menu2)  {
                    filterBar.style.marginTop = '57px';
                    menu2.classList.add('fixedNavKM');
                }


                iframe(); //Borra menus i footer amb url/?iframe
                getParamsFromURL(); //Agafa els parametres de la URL i inicialitza filtres(var)
                loadInfoForFilters(); // Query AJAX amb la info dels filtres
                listOffers(); // Carrega les ofertes per AJAX
                hardCodedModules(); //Moduls construits al HTML
                initModalForm(); //Modal Form

                /*SUGGESTER VEHICULOS 2025 */
console.log('ofertaSuggester');
if($('.search-vehicle').length) {
    $("body").addClass('suggesterVehiculosBody');
    var vehiclesData = [];
    var postID = $('.search-vehicle').data('post-id');
    var typeOfOffer = $('.search-vehicle').data('type');
    console.log('Initializing vehicle suggester...');
    
    $.ajax({
        url: mediagach_vars.rootFolder + '/wp-admin/admin-ajax.php',
        type: 'POST',
        dataType: 'json',
        data: {
            action: 'get_vehicles_json',
            post_id: postID,
            type: typeOfOffer
        },
        success: function(response) {
            //console.log('=== AJAX RESPONSE ===');
            //console.log('Post ID:', postID);
            //console.log('Raw response:', JSON.stringify(response, null, 2));
            //console.log('Response type:', typeof response);
            //console.log('Has data property:', response.hasOwnProperty('data'));
            
            if (response && response.data && Array.isArray(response.data)) {
                vehiclesData = response.data;
                //console.log('\n=== DATA ANALYSIS ===');
                //console.log('Number of vehicles:', vehiclesData.length);
                //console.log('First vehicle:', vehiclesData[0]);
                //console.log('Last vehicle:', vehiclesData[vehiclesData.length - 1]);
            } else {
                console.error('Invalid or empty response structure');
                vehiclesData = [];
            }
        },
        error: function(xhr, status, error) {
            console.error('=== AJAX ERROR ===');
            console.error('Status:', status);
            console.error('Error:', error);
            console.error('Response Text:', xhr.responseText);
            vehiclesData = [];
        }
    });

    $('.search-vehicle').autocomplete({
        minLength: 1,
        delay: 0,
        appendTo: '.suggesterVehiculos',
        classes: {
            "ui-autocomplete": "modern-autocomplete"
        },
        source: function(request, response) {
            console.log('\n=== SEARCH REQUEST ===');
            console.log('Search term:', request.term);
            console.log('Current vehiclesData length:', vehiclesData.length);
            
            if (!Array.isArray(vehiclesData) || vehiclesData.length === 0) {
                console.error('No vehicle data available for search');
                response([]);
                return;
            }

            var term = request.term.toLowerCase();
            var terms = term.split(' ').filter(function(t) { return t.length > 0; });
            
            var matches = vehiclesData.filter(function(item) {
                var fullText = (item.marca + ' ' + item.modelo).toLowerCase();
                return terms.every(function(t) {
                    return fullText.indexOf(t) !== -1;
                });
            }).slice(0, 10);
            
            console.log('Matches found:', matches.length);
            if (matches.length > 0) {
                console.log('Matches:', matches.map(function(m) {
                    return m.marca + ' ' + m.modelo;
                }));
            }
            
            if (matches.length === 0) {
                matches = [{
                    label: 'No se encontraron resultados',
                    value: '',
                    noResults: true
                }];
            }
            
            response(matches);
        },
        select: function(event, ui) {
            if (ui.item.noResults) {
                return false;
            }
            
            if (ui.item && ui.item.marca && ui.item.modelo) {
                // Mantener el valor seleccionado en el input
                $('.search-vehicle').val(ui.item.label);
                
                // Eliminar filtros existentes de marca y modelo
                if (filters.brand) {
                    delete filters.brand;
                    delete urlFilters.brand;
                    $('.ap-brand').remove();
                }
                if (filters.model) {
                    delete filters.model;
                    delete urlFilters.model;
                    $('.ap-model').remove();
                }

                // Aplicar nuevos filtros
                filters.brand = ui.item.marca;
                filters.model = ui.item.modelo;

                // Añadir filtros aplicados visuales
                addAplicado('brand', ui.item.marca);
                addAplicado('model', ui.item.modelo);

                // Actualizar URL
                var url = buildURL('brand', ui.item.marca);
                url = buildURL('model', ui.item.modelo);
                window.history.pushState(null, null, url);

                // Reset y ejecutar nueva búsqueda
                startFilter = 0;
                limitFilter = numItemsPerRow * 3;
                endOfOffers = false;

                // Limpiar resultados actuales
                while (ofertasLlistat.firstChild) {
                    ofertasLlistat.removeChild(ofertasLlistat.firstChild);
                }

                // Mostrar botones de "más ofertas"
                $("#more-ofertas").css("display", "block");
                $("#bottom-ofertas").css("display", "block");

                // Ejecutar nueva búsqueda
                listOffers();

                // Scroll al top
                window.scrollTo(0, 0);
            }
            
            return false;
        }
    }).data('ui-autocomplete')._renderItem = function(ul, item) {
        if (item.noResults) {
            return $('<li class="ui-state-disabled no-results">')
                .append('<div>' + item.label + '</div>')
                .appendTo(ul);
        }
        return $('<li class="suggestion-item">')
            .append('<div class="suggestion-content">' + item.label + '</div>')
            .appendTo(ul);
    }; 
}  
/*SUGGESTER VEHICULOS END 2025 */
 
 

 
            }
        },


        'page_template_template_nuestros_modelos': {
            init: function() {

            },
            finalize: function() {
                $(".sameheight").sameheight();
            }

        },
        
        'page_template_template_portada_star': {
            init: function() {

            },
            finalize: function() {
                $(".info-content h4").sameheight();
                
                $('.star-carousel').owlCarousel({
                    loop:true,
                    responsiveClass:true,
                    center: true,


                    items : 5,
                    slideSpeed : 10000,
                    nav: true,
                    autoplay: true, 
                    lazyLoad: false,
                    responsiveRefreshRate : 200,
                    navText: [
                       "<i class='icon-mediagach-tipografia_drivim_icones_final-02'></i>",
                       "<i class='icon-mediagach-tipografia_drivim_icones_final-03'></i>"
                    ],
                    responsiveClass:true,
                        responsive:{
                            0:{
                                items:1,
                            },
                            500:{
                                items:2,
                            },
                            800:{
                                items:3,
                            },
                            1200:{
                                items:4,
                            }
                        }
                })
                
            }

        },

        'post_template_template_star_post': {
            init: function() {

            },
            finalize: function() {

                var imgBlock = document.querySelector('.star-fixed-block');
                var mLeft = document.querySelector('.m-left');
                var mRight = document.querySelector('.m-right');

                if(window.innerWidth > 1000) {

                    setTimeout(function() {
                        imgBlock.style.opacity = 1;
                    }, 300);

                    setTimeout(function() {
                
                        mLeft.addEventListener('mouseover', function() {

                            imgBlock.style.backgroundPosition = '45%';
                        
                        })

                        mRight.addEventListener('mouseover', function() {

                            imgBlock.style.backgroundPosition = '55%';
                        
                        })
                        
                    }, 4000)

                } else {
                    var fades = document.querySelectorAll('.mg-animation');

                    imgBlock.style.opacity = 1;

                    for(var i = 0; i < fades.length; i++) {
                        fades[i].setAttribute('data-mg-animation-delay', '0s');
                        fades[i].setAttribute('data-mg-animation', 'fadeIn');
                    }
                }

            }

        },
        'page_template_template_slidertv': {
            init: function() {

            },
            finalize: function() {

                /* Get the documentElement (<html>) to display the page in fullscreen */
                var elem = document.documentElement;

                /* View in fullscreen */
                function toggleFullscreen() {
                    elem = document.documentElement;
                    if (!document.fullscreenElement && !document.mozFullScreenElement &&
                      !document.webkitFullscreenElement && !document.msFullscreenElement) {
                      if (elem.requestFullscreen) {
                        elem.requestFullscreen();
                      } else if (elem.msRequestFullscreen) {
                        elem.msRequestFullscreen();
                      } else if (elem.mozRequestFullScreen) {
                        elem.mozRequestFullScreen();
                      } else if (elem.webkitRequestFullscreen) {
                        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                      }
                    } else {
                      if (document.exitFullscreen) {
                        document.exitFullscreen();
                      } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                      } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                      } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                      }
                    }
                  }

                document.body.addEventListener('click', function() {
                    //toggleFullscreen();
                })


                $('#slider-tv').owlCarousel({
                    items: 1,
                    nav: false,
                    mouseDrag: false,
                    touchDrag: false,
                    autoplay: true,
                    autoplaySpeed: 100,
                    dots: false,
                    loop: true,
                    lazyLoad:true,
                    autoplayTimeout: 5000
                });


            }
        },
        'page_template_template_star_post': {
            init: function() {

            },
            finalize: function() {

                var imgBlock = document.querySelector('.star-fixed-block');
                var mLeft = document.querySelector('.m-left');
                var mRight = document.querySelector('.m-right');

                if(window.innerWidth > 1000) {

                    setTimeout(function() {
                        imgBlock.style.opacity = 1;
                    }, 300);

                    setTimeout(function() {
                
                        mLeft.addEventListener('mouseover', function() {

                            imgBlock.style.backgroundPosition = '45%';
                        
                        })

                        mRight.addEventListener('mouseover', function() {

                            imgBlock.style.backgroundPosition = '55%';
                        
                        })
                        
                    }, 4000)

                } else {
                    var fades = document.querySelectorAll('.mg-animation');

                    imgBlock.style.opacity = 1;

                    for(var i = 0; i < fades.length; i++) {
                        fades[i].setAttribute('data-mg-animation-delay', '0s');
                        fades[i].setAttribute('data-mg-animation', 'fadeIn');
                    }
                }

            }

        },
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


